<template>
  <div class="main-container">
    <div class="PDCcontainer">
      <header
        class="library-page-header library-page-header--tributo"
        aria-labelledby="library-page-title-tributo"
      >
        <img
          class="library-page-header__icon"
          src="/Titoli pagine/Icona Libreria Codici Tributo.png"
          alt=""
          aria-hidden="true"
        />
        <div class="library-page-header__copy">
          <div class="library-page-header__title-row">
            <h1
              id="library-page-title-tributo"
              class="library-page-header__title"
            >
              Libreria Codici Tributo
            </h1>
            <span class="library-scope-badge is-personal">
              <i class="fa-solid fa-user" aria-hidden="true"></i>
              Personale
            </span>
          </div>
          <p class="library-page-header__subtitle">
            Gestisci la tua libreria personale e riutilizza i codici tributo
            nelle elaborazioni successive.
          </p>
        </div>
        <img
          class="library-page-header__visual library-page-header__visual--tributo"
          src="/Titoli pagine/Immagine Libreria codici tributo.png"
          alt=""
          aria-hidden="true"
        />
      </header>
      <section
        class="library-workspace"
        :class="{
          'library-workspace--empty':
            isDataLoaded &&
            !jsonData.length &&
            !showAddBilancino &&
            !showAddPiano,
        }"
        aria-label="Strumenti e dati della libreria codici tributo"
      >
        <div class="dashboarddiv" v-if="isDataLoaded">
          <div class="dashboard" ref="dashboardRef">
            <div class="buttons">
              <button
                class="btninput addRowButton"
                :class="{ 'active-button': currentPctEditModeActive }"
                :disabled="!currentPctHasVisibleDataRows"
                @click="toggleCurrentPctEditMode"
              >
                <i class="fa-solid fa-pen-to-square toolicon"></i> Modifica
              </button>
              <button
                class="btninput addRowButton"
                :class="{ 'active-button': showAddRow }"
                :disabled="!currentAddRowHeaders.length"
                @click="openAddRowModal"
              >
                <i class="fa-solid fa-plus toolicon"></i> Aggiungi Riga
              </button>
              <button
                class="btninput addBilancinoButton leggibilancino"
                :class="{ 'active-button': showAddBilancino }"
                :disabled="isPctArchiveView || currentPctIsClient"
                :title="
                  currentPctIsClient
                    ? 'La lettura da F24 aggiorna il Piano Codici Tributo principale'
                    : 'Leggi Modello F24'
                "
                @click="
                  showAddBilancino = !showAddBilancino;
                  showAddRow = false;
                  showAddPiano = false;
                "
              >
                <i class="fa-solid fa-file-import toolicon"></i> Leggi Modello
                F24
                <!-- Menu a tendina per scegliere il software di output -->
              </button>
              <button
                class="btninput addRowButton"
                @click="deleteCurrentPctFile($event)"
                :title="currentPctDeleteButtonTitle"
                :disabled="!currentPctDeleteHasDataRows"
              >
                <i class="fa-solid fa-trash cursor toolicon"></i>
                {{ currentPctDeleteButtonLabel }}
              </button>
              <div class="download-menu">
                <button
                  class="btninput btn-scarica download-menu-trigger"
                  type="button"
                >
                  <i
                    title="Scarica il Piano dei conti"
                    class="fas fa-download download-icon cursor icon"
                  ></i>
                  Scarica
                  <i class="fa-solid fa-chevron-down download-menu-chevron"></i>
                </button>
                <div class="download-menu-dropdown">
                  <button
                    class="download-menu-item"
                    type="button"
                    @click="downloadCurrentPctFile"
                    :disabled="!currentPctFileHasDataRows"
                  >
                    <i class="fas fa-file-excel"></i> File attuale
                  </button>
                  <button
                    class="download-menu-item"
                    type="button"
                    @click="
                      scaricaModello(
                        currentPctTemplateKey,
                        currentPctTemplateFilename
                      )
                    "
                  >
                    <i class="fas fa-file-excel"></i> Modello vuoto
                  </button>
                </div>
              </div>
              <button
                class="btninput addBilancinoButton btn-carica"
                :class="{ 'active-button': showAddPiano }"
                @click="openCurrentPctUpload"
                :disabled="!ha(user, 'funzione_carica_piano')"
                :title="
                  !ha(user, 'funzione_carica_piano')
                    ? 'Carica un nuovo Piano Codici Tributo manualmente - Disponibile da piano Plus'
                    : 'Carica o sostituisci il Piano Codici Tributo selezionato'
                "
              >
                <i class="fas fa-upload toolicon"></i> Carica Piano
              </button>
              <input
                type="file"
                ref="fileInput9001Inline"
                class="hidden-file-input"
                accept=".xlsx,.xls,.csv"
                @change="replaceFile9001"
              />
              <input
                type="file"
                ref="fileInputSaldoFInline"
                class="hidden-file-input"
                accept=".xlsx,.xls,.csv"
                @change="replaceFileSaldoF"
              />
              <CondivisionePiano
                class="library-share-control"
                ref="condivisionePiano"
                tipoPiano="Piano Codici Tributo"
                :inviti-ricevuti="invitiRicevuti"
                :inviti-inviati="invitiInviati"
                :shareable-files="pctShareableFiles"
                :on-refresh-files="fetchFileFromBackend"
                @mostra-excel="apriExcelViewer"
                @refresh-inviti="fetchInviti"
                @success="mostraSuccesso"
                @error="mostraErrore"
                :json-length="jsonData.length"
                :auto-open="shouldOpenShareModal"
                :highlighted-invito-id="highlightedShareInvitoId"
                :feature-locked="!ha(user, 'condivisione_pdc_studio')"
                :title="
                  !ha(user, 'condivisione_pdc_studio')
                    ? 'Condividi il tuo Piano Codici Tributo - Disponibile da piano Plus'
                    : 'Condividi il tuo Piano Codici Tributo'
                "
              />
              <div
                v-if="false"
                class="archive-menu"
                ref="archiveMenuRef"
                :class="{ 'archive-menu--open': archiveMenuOpen }"
              >
                <button
                  class="btninput addRowButton archive-menu-trigger"
                  type="button"
                  title="Consulta i tuoi Archivi"
                  @click.stop="toggleArchiveMenu"
                >
                  <i class="fa-solid fa-folder-open toolicon"></i>
                  Archivi
                  <i class="fa-solid fa-chevron-down archive-chevron"></i>
                </button>
                <div v-show="archiveMenuOpen" class="archive-menu-dropdown">
                  <button
                    class="archive-menu-item"
                    type="button"
                    @click.stop="openArchive9001"
                  >
                    <i class="fa-solid fa-book-open"></i>
                    Archivio Codici Tributo 9001
                  </button>
                  <button
                    class="archive-menu-item"
                    type="button"
                    @click.stop="openArchiveSaldoF"
                  >
                    <i class="fa-solid fa-globe"></i>
                    Archivio Coordinate Bancarie
                  </button>
                </div>
              </div>
              <button
                class="btninput addRowButton savebuttondiv"
                :class="{ unsaved: currentPctFileHasUnsavedChanges }"
                title="Salva modifiche"
                @click="saveCurrentPctFile($event)"
                :disabled="!currentPctFileCanSaveOrCancel"
              >
                <i
                  class="fa-solid fa-floppy-disk savebutton"
                  :class="{ unsaved: currentPctFileHasUnsavedChanges }"
                >
                </i>
                <span>Salva</span>
              </button>
              <button
                class="btninput addRowButton savebuttondiv"
                :class="{ unsaved: currentPctFileHasUnsavedChanges }"
                title="Annulla modifiche"
                @click="cancelCurrentPctChanges"
                :disabled="!currentPctFileCanSaveOrCancel"
              >
                <i
                  class="fa-solid fa-xmark cancelbutton"
                  :class="{ unsaved: currentPctFileHasUnsavedChanges }"
                >
                </i>
                <span>Annulla</span>
              </button>
              <ExcelViewer
                :rows="PianoRows"
                :visible="showPianoModal"
                @close="showPianoModal = false"
              />
            </div>
          </div>
          <div
            v-if="noChangesMessage && jsonData.length > 0"
            class="dashboard-feedback"
          >
            <span class="nochanges-message">Nessuna modifica presente</span>
          </div>
        </div>
        <div
          class="PCT_header empty-plan-card"
          v-if="
            isDataLoaded &&
            !jsonData.length &&
            !showAddBilancino &&
            !showAddPiano
          "
        >
          <div class="empty-plan-icon" aria-hidden="true">
            <i class="fa-solid fa-table-list"></i>
          </div>
          <div class="empty-plan-body">
            <p class="nessun-piano-header">Crea il tuo Piano Codici Tributo</p>
            <p class="empty-plan-line">
              Questo file non esiste ancora. Verrà creato e aggiornato
              automaticamente usando il Convertitore Modelli F24.
              <br />
              In alternativa, puoi usare gli strumenti dedicati della libreria,
              caricare un file già compilato o scaricare il modello vuoto.
            </p>
            <div class="empty-plan-actions">
              <router-link
                class="empty-plan-action empty-plan-action--primary convertitore linkstrumentiPCT"
                title="Vai al convertitore"
                to="/home/modelli-f24"
              >
                <i class="fa-solid fa-wand-magic-sparkles"></i>
                Usa convertitore
              </router-link>
              <button
                class="empty-plan-action empty-plan-action--secondary"
                type="button"
                @click="
                  scaricaModello(
                    'pct_f24',
                    'MODELLO - Modelli F24 - Piano Codici Tributo.xlsx'
                  )
                "
              >
                <i class="fa-solid fa-file-arrow-down"></i>
                Scarica modello
              </button>
            </div>
          </div>
        </div>
        <div class="skeleton-loader" v-if="!isDataLoaded">
          <div class="skeleton skeleton-title"></div>
          <div class="skeleton skeleton-text"></div>
          <div class="skeleton skeleton-button"></div>
        </div>
        <div
          v-if="showAddBilancino"
          class="container-wrapper-add-bilancino library-reader-workspace library-reader-workspace--f24"
        >
          <div class="calcolatrice-add-bilancino">
            <div
              class="div-add-f24"
              :class="['div-add-bilancino', isShifted ? 'shift-left' : '']"
            >
              <!-- Titolo principale -->
              <div class="header-add-bilancino">
                <span class="library-reader-title-icon" aria-hidden="true">
                  <img src="/Pagina Home/F24.png" alt="" />
                </span>
                <h3 class="title-add-bilancino">
                  Leggi <span>MODELLO F24</span>
                </h3>
                <p class="library-reader-subtitle">
                  Individua e aggiungi nuovi codici al Piano Codici Tributo.
                </p>
              </div>
              <button
                type="button"
                class="headerButtons-add-bilancino headerbtn-add-f24"
                @click="refreshConversione"
                aria-label="Resetta la lettura del modello F24"
              >
                <i
                  title="Reset del convertitore"
                  class="fa-solid fa-arrows-rotate refresh"
                >
                </i>
              </button>
              <!-- Contenitore degli input -->
              <div
                v-show="expanded"
                class="input-container library-reader-form"
              >
                <label
                  for="bilancinoInput"
                  class="input-label input-label--file"
                >
                  Seleziona file da leggere:
                </label>
                <input
                  id="bilancinoInput"
                  class="file-input-add-bilancino library-reader-file-input"
                  type="file"
                  ref="bilancinoInput"
                  accept=".pdf,.csv,.xls,.xlsx"
                  :disabled="calculating || calculating2 || showResult"
                  @change="handleF24Input"
                />
                <small class="library-reader-formats">
                  Formati supportati: PDF, CSV, XLS, XLSX
                </small>
                <button
                  v-if="filePDF_URL"
                  @click="openPDFPreview"
                  class="btn anteprimapdf"
                >
                  <i class="fa-solid fa-file-pdf" aria-hidden="true"></i>
                  Visualizza PDF
                </button>
                <button
                  v-if="ExcelRows.length && fileType === 'excel'"
                  @click="showExcelModal = true"
                  class="anteprimaexcel anteprimaexcel--excel"
                >
                  <i class="fa-solid fa-file-excel" aria-hidden="true"></i>
                  Visualizza Excel
                </button>

                <button
                  v-if="ExcelRows.length && fileType === 'csv'"
                  @click="showExcelModal = true"
                  class="anteprimaexcel anteprimaexcel--csv"
                >
                  <i class="fa-solid fa-file-csv" aria-hidden="true"></i>
                  Visualizza CSV
                </button>
                <span class="softwaredetected" v-show="input_PC">
                  <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
                  <span class="softwaredetected-label"
                    >Software contabile rilevato</span
                  >
                  <strong class="input_PC">{{ input_PC }}</strong>
                </span>
                <label
                  for="outputSystem"
                  class="input-label input-label--software"
                >
                  Software contabile di conversione:
                </label>
                <select
                  :disabled="calculating || calculating2 || showResult"
                  v-model="output_PC"
                  id="outputSystem"
                  class="select-input-add-bilancino library-reader-select"
                >
                  <option disabled selected value="">Seleziona software</option>
                  <option value="TEAMSYSTEM">TEAMSYSTEM</option>
                  <option value="DATEV">DATEV</option>
                  <option value="ZUCCHETTI">ZUCCHETTI</option>
                  <option value="SEAC">SEAC</option>
                  <option value="SISTEMI">SISTEMI</option>
                  <!-- <option value="SISTEMI">SISTEMI</option> -->
                </select>
                <button
                  :disabled="calculating || calculating2 || showResult"
                  class="action-button"
                  @click="sendBilancino"
                >
                  <span v-if="calculating">
                    <div class="spinner"></div>
                    Elaborazione...
                  </span>
                  <span v-else>
                    <i class="fa-solid fa-play" aria-hidden="true"></i>
                    Avvia scansione
                  </span>
                </button>
              </div>
              <!-- Messaggio di errore PDF incompatibile con sistema di Input contabile -->
              <div v-if="errorMessage" class="error-message-leggi-f24">
                <p>{{ errorMessage }}</p>
              </div>
              <div v-if="showDelayedMessage" class="waiting-message">
                <span v-if="!delayedMessageUpdated">
                  MyStudio sta elaborando un file abbastanza lungo. Attendere,
                  per favore 🙂⏳
                </span>
                <span v-else>
                  Sei ancora lì? Non ti preoccupare, manca poco! 🙌⏳
                </span>
                <span class="dot-anim"></span>
              </div>
            </div>
          </div>
          <section
            v-if="!showResult"
            class="library-reader-placeholder"
            aria-label="Area risultato lettura modello F24"
          >
            <div class="library-reader-placeholder__visual" aria-hidden="true">
              <i class="fa-solid fa-file-arrow-up"></i>
              <span><i class="fa-solid fa-table-list"></i></span>
            </div>
            <div class="library-reader-placeholder__copy">
              <h3>Nuovi codici tributo</h3>
              <p>
                Carica un modello F24: i codici individuati compariranno qui
                pronti per la verifica e il salvataggio.
              </p>
            </div>
          </section>
          <div
            v-show="showResult"
            :class="[
              'result-container-add-bilancino library-reader-results',
              showResult ? 'show' : '',
            ]"
          >
            <div
              v-if="editPDCresponse"
              class="response-message-add-bilancino conversion-table-surface"
            >
              <!-- Titoli specifici per ciascuna sub-fase -->
              <h3
                v-if="currentSubPhase === 'A'"
                class="cod-conto-individuati title-conv"
                :class="{ 'hidden-title': vettorePCTVisible }"
              >
                CODICI TRIBUTO INDIVIDUATI
              </h3>
              <h3
                v-if="currentSubPhase === 'B'"
                class="cod-conto-individuati title-conv"
              >
                CODICI TRIBUTO 9001
              </h3>

              <!-- Contenuti specifici per sub-fase A -->
              <div v-if="currentSubPhase === 'A'">
                <button
                  v-show="vettoreCodTributoPCT.length > 0"
                  class="btnPCTvisible"
                  :class="{ active: vettorePCTVisible }"
                  @click="vettorePCTVisible = !vettorePCTVisible"
                >
                  <i class="fa-solid fa-book iconbtnPDC"></i>
                  Codici Tributo già salvati
                  <i
                    :class="
                      vettorePCTVisible
                        ? 'fa-solid fa-chevron-down'
                        : 'fa-solid fa-chevron-right'
                    "
                    class="toggle-icon"
                  ></i>
                </button>

                <!-- TABELLA ESPANDIBILE PER PCT (salvati) -->
                <div
                  class="divPCTtable"
                  :class="{ 'table-hidden': !vettorePCTVisible }"
                >
                  <div
                    v-show="
                      vettoreCodTributoPCT.length > 0 && vettorePCTVisible
                    "
                    class="cod_conto_table_divPCT"
                    :class="{ expanded: isTableTributoPCTExpanded }"
                  >
                    <table
                      :class="
                        output_PC === 'DATEV'
                          ? 'codcontotablePCT-datev'
                          : 'codcontotablePCT'
                      "
                    >
                      <thead>
                        <i
                          @click="toggleTableTributoPCTExpansion"
                          :class="
                            isTableTributoPCTExpanded
                              ? 'fa-solid fa-compress expand-buttontributo'
                              : 'fa-solid fa-expand expand-buttontributo'
                          "
                          title="Espandi / Comprimi Tabella"
                        ></i>
                        <tr>
                          <th class="headerIndici"></th>
                          <th
                            v-for="(header, index) in filteredHeadersPCT"
                            :key="index"
                            :class="{
                              'datev-column':
                                header === 'Aziende' ||
                                header === 'Liberi Professionisti',
                            }"
                          >
                            <div class="headerscodconto">{{ header }}</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(row, rowIndex) in vettoreCodTributoPCT"
                          :key="rowIndex"
                        >
                          <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                          <td
                            v-for="(col, colIndex) in validColumnsPCT"
                            :key="colIndex"
                            :class="{
                              'datev-column':
                                filteredHeadersPCT[colIndex] ===
                                  'Cod. tributo Datev Aziende' ||
                                filteredHeadersPCT[colIndex] ===
                                  'Cod. tributo Datev Liberi Professionisti',
                              'italic-text':
                                hasNessunaCorrelazione(
                                  vettoreCodTributoPCT[rowIndex][col]
                                ) ||
                                isNessuno(vettoreCodTributoPCT[rowIndex][col]),
                            }"
                          >
                            <template v-if="isEditableColumnPCT(col, rowIndex)">
                              <input
                                v-model="vettoreCodTributoPCT[rowIndex][col]"
                                type="text"
                                class="editable-input"
                                :class="{
                                  'italic-text':
                                    isNessuno(
                                      vettoreCodTributoPCT[rowIndex][col]
                                    ) ||
                                    hasNessunaCorrelazione(
                                      vettoreCodTributoPCT[rowIndex][col]
                                    ),
                                }"
                                :placeholder="
                                  isDescrizioneCodContoColumn(
                                    filteredHeaders[colIndex]
                                  )
                                    ? 'Inserisci Descrizione Codice Conto'
                                    : ''
                                "
                                @input="
                                  validateInput(
                                    rowIndex,
                                    colIndex,
                                    vettoreCodTributoPCT
                                  )
                                "
                                @keydown="
                                  blockLetters(
                                    $event,
                                    rowIndex,
                                    col,
                                    colIndex,
                                    vettoreCodTributoPCT
                                  )
                                "
                                @paste="blockPaste($event)"
                                @focus="$event.target.select()"
                              />
                            </template>
                            <template v-else>
                              {{
                                vettoreCodTributoPCT[rowIndex][col] === "None"
                                  ? ""
                                  : vettoreCodTributoPCT[rowIndex][col]
                              }}
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <button
                    v-if="vettoreCodTributoPCT.length > 0 && vettorePCTVisible"
                    key="edit-btn-pct"
                    class="edit-buttonPDC"
                    :class="{ 'active-editbuttonPDC': isEditModePCT }"
                    @click="toggleEditModePCT"
                    :disabled="!ha(user, 'modifica_descrizione_nomi_conto')"
                    :title="
                      !ha(user, 'modifica_descrizione_nomi_conto')
                        ? 'Modifica Codici Conto già salvati - Disponibile da piano Plus'
                        : 'Modifica Codici Conto già salvati'
                    "
                  >
                    <i class="fa-regular fa-pen-to-square edit-button-icon"></i>
                    <span class="edit-button-text">Modifica</span>
                  </button>
                </div>
                <!-- Contenuto principale per A quando non visibile il PCT -->
                <div v-if="!vettorePCTVisible">
                  <div
                    v-if="vettoreCodTributo.length > 0 && !vettorePCTVisible"
                    class="cod_conto_table_div"
                    :class="{
                      expanded: isTableExpanded,
                    }"
                  >
                    <table
                      :class="
                        output_PC === 'DATEV'
                          ? 'codtributotable-datev'
                          : 'codtributotable'
                      "
                    >
                      <thead>
                        <i
                          @click="toggleTableExpansion"
                          :class="
                            isTableExpanded
                              ? 'fa-solid fa-compress expand-buttontributo'
                              : 'fa-solid fa-expand expand-buttontributo'
                          "
                          title="Espandi / Comprimi Tabella"
                        ></i>
                        <tr>
                          <th class="headerIndici"></th>
                          <th
                            v-for="(header, index) in filteredHeaders"
                            :key="index"
                            :class="{
                              'datev-column':
                                header === 'Aziende' ||
                                header === 'Liberi Professionisti',
                            }"
                          >
                            {{ header }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(row, rowIndex) in vettoreCodTributo"
                          :key="rowIndex"
                        >
                          <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                          <td
                            v-for="(realColIndex, colIndex) in validColumns"
                            :key="colIndex"
                            :class="{
                              'italic-text':
                                hasNessunaCorrelazione(
                                  vettoreCodTributo[rowIndex][realColIndex]
                                ) ||
                                isNessuno(
                                  vettoreCodTributo[rowIndex][realColIndex]
                                ),
                            }"
                          >
                            <template
                              v-if="isEditableColumn(realColIndex, rowIndex)"
                            >
                              <input
                                v-model="
                                  vettoreCodTributo[rowIndex][realColIndex]
                                "
                                type="text"
                                class="editable-input"
                                :class="{
                                  'italic-text':
                                    isNessuno(
                                      vettoreCodTributo[rowIndex][realColIndex]
                                    ) ||
                                    hasNessunaCorrelazione(
                                      vettoreCodTributo[rowIndex][realColIndex]
                                    ),
                                }"
                                :placeholder="
                                  isDescrizioneCodContoColumn(
                                    filteredHeaders[colIndex]
                                  )
                                    ? 'Inserisci Descrizione Codice Conto'
                                    : ''
                                "
                                @input="
                                  validateInput(
                                    rowIndex,
                                    colIndex,
                                    vettoreCodTributo
                                  )
                                "
                                @keydown="
                                  blockLetters(
                                    $event,
                                    rowIndex,
                                    realColIndex,
                                    colIndex,
                                    vettoreCodTributo
                                  )
                                "
                                @paste="blockPaste($event)"
                                @focus="$event.target.select()"
                              />
                            </template>
                            <template v-else>
                              {{
                                vettoreCodTributo[rowIndex][realColIndex] ===
                                "None"
                                  ? ""
                                  : vettoreCodTributo[rowIndex][realColIndex]
                              }}
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="success-container">
                    <svg
                      class="checkcodicicontoIcon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <p class="checkcodiciconto">
                      Tutti i Codici Tributo individuati nel Modello F24 sono
                      già presenti nel tuo
                      <span class="scrittapiano">Piano Codici Tributo</span>
                    </p>
                  </div>
                  <button
                    v-if="
                      vettoreCodTributo.length > 0 &&
                      !vettorePCTVisible &&
                      isPiano(user, 'premium')
                    "
                    class="edit-button"
                    :class="{ 'active-editbutton': isEditMode }"
                    @click="toggleEditMode"
                    :disabled="!ha(user, 'modifica_descrizione_nomi_conto')"
                    :title="
                      !ha(user, 'modifica_descrizione_nomi_conto')
                        ? 'Personalizza Descrizioni Codici Conto - Disponibile da piano Plus'
                        : 'Personalizza Descrizioni Codici Conto'
                    "
                  >
                    <i class="fa-regular fa-pen-to-square edit-button-icon">
                    </i>
                    <span class="edit-button-text">Modifica</span>
                  </button>
                </div>
              </div>

              <div v-if="currentSubPhase === 'B'">
                <!-- Pulsante toggle per i codici 9001 già salvati -->
                <button
                  v-show="vettoreCodTributo9001_PCT?.length > 0"
                  class="btnPCTvisible"
                  :class="{ active: vettore9001PCTVisible }"
                  @click="vettore9001PCTVisible = !vettore9001PCTVisible"
                >
                  <i class="fa-solid fa-book iconbtnPDC"></i>
                  Codici 9001 già salvati
                  <i
                    :class="
                      vettore9001PCTVisible
                        ? 'fa-solid fa-chevron-down'
                        : 'fa-solid fa-chevron-right'
                    "
                    class="toggle-icon"
                  ></i>
                </button>

                <!-- TABELLA ESPANDIBILE PER PCT (salvati) – visibile SOLO se toggle attivo -->
                <div
                  class="divPCTtable"
                  :class="{ 'table-hidden': !vettore9001PCTVisible }"
                >
                  <div
                    v-show="
                      vettoreCodTributo9001_PCT?.length > 0 &&
                      vettore9001PCTVisible
                    "
                    class="cod_conto_table_divPCT"
                    :class="{ expanded: isTable9001PCTExpanded }"
                  >
                    <table
                      :class="
                        output_PC === 'DATEV'
                          ? 'codcontotable9001PCT-datev'
                          : 'codcontotable9001PCT'
                      "
                    >
                      <thead>
                        <i
                          @click="toggleTable9001PCTExpansion"
                          :class="
                            isTable9001PCTExpanded
                              ? 'fa-solid fa-compress expand-buttontributo'
                              : 'fa-solid fa-expand expand-buttontributo'
                          "
                          title="Espandi / Comprimi Tabella"
                        ></i>
                        <tr>
                          <th class="headerIndici"></th>
                          <th
                            v-for="(header, index) in filteredHeaders9001"
                            :key="index"
                          >
                            <div class="headerscodconto">{{ header }}</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(row, rowIndex) in vettoreCodTributo9001_PCT"
                          :key="rowIndex"
                        >
                          <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                          <td
                            v-for="(col, colIndex) in validColumns9001"
                            :key="colIndex"
                            :class="{
                              'italic-text':
                                hasNessunaCorrelazione(
                                  vettoreCodTributo9001_PCT[rowIndex][col]
                                ) ||
                                isNessuno(
                                  vettoreCodTributo9001_PCT[rowIndex][col]
                                ),
                            }"
                          >
                            <template v-if="isEditable9001(colIndex)">
                              <input
                                v-model="
                                  inputValues9001[`pct-${rowIndex}-${colIndex}`]
                                "
                                type="text"
                                class="editable-input"
                                :class="{
                                  'italic-text':
                                    isNessuno(
                                      vettoreCodTributo9001_PCT[rowIndex][col]
                                    ) ||
                                    hasNessunaCorrelazione(
                                      vettoreCodTributo9001_PCT[rowIndex][col]
                                    ),
                                }"
                                :placeholder="
                                  isDescrizioneCodContoColumn(
                                    filteredHeaders9001[colIndex]
                                  )
                                    ? 'Inserisci Descrizione Codice Conto'
                                    : ''
                                "
                                @input="
                                  validateInput9001(
                                    rowIndex,
                                    colIndex,
                                    $event,
                                    vettoreCodTributo9001_PCT
                                  )
                                "
                                @keydown="
                                  blockLetters(
                                    $event,
                                    rowIndex,
                                    col,
                                    colIndex,
                                    vettoreCodTributo9001_PCT
                                  )
                                "
                                @paste="blockPaste($event)"
                                @focus="$event.target.select()"
                              />
                            </template>
                            <template v-else>
                              {{
                                mapped9001(rowIndex, vettoreCodTributo9001_PCT)[
                                  colIndex
                                ] === "None"
                                  ? ""
                                  : mapped9001(
                                      rowIndex,
                                      vettoreCodTributo9001_PCT
                                    )[colIndex]
                              }}
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Contenuto principale – sempre visibile quando toggle chiuso -->
                <div v-if="!vettore9001PCTVisible">
                  <!-- Tabella codici nuovi (priorità massima) -->
                  <div
                    v-if="vettoreCodTributo9001?.length > 0"
                    class="vettore9001-table"
                    :class="{ expanded: isTable9001Expanded }"
                  >
                    <table>
                      <thead>
                        <i
                          @click="toggleTable9001Expansion"
                          :class="
                            isTable9001Expanded
                              ? 'fa-solid fa-compress expand-button9001'
                              : 'fa-solid fa-expand expand-button9001'
                          "
                          title="Espandi / Comprimi Tabella"
                        ></i>
                        <tr>
                          <th class="headerIndici"></th>
                          <th
                            v-for="(header, index) in filteredHeaders9001"
                            :key="index"
                          >
                            {{ header }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(row, rowIndex) in vettoreCodTributo9001"
                          :key="rowIndex"
                        >
                          <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                          <td
                            v-for="(col, colIndex) in validColumns9001"
                            :key="colIndex"
                            :class="{
                              'italic-text':
                                hasNessunaCorrelazione(
                                  mapped9001(rowIndex, vettoreCodTributo9001)[
                                    colIndex
                                  ]
                                ) ||
                                isNessuno(
                                  mapped9001(rowIndex, vettoreCodTributo9001)[
                                    colIndex
                                  ]
                                ),
                            }"
                          >
                            <template v-if="isEditable9001(colIndex)">
                              <input
                                v-model="
                                  inputValues9001[`${rowIndex}-${colIndex}`]
                                "
                                type="text"
                                class="editable-input"
                                :class="{
                                  'italic-text':
                                    isNessuno(
                                      inputValues9001[`${rowIndex}-${colIndex}`]
                                    ) ||
                                    hasNessunaCorrelazione(
                                      inputValues9001[`${rowIndex}-${colIndex}`]
                                    ),
                                }"
                                :placeholder="
                                  colIndex === 6
                                    ? 'Inserisci Descrizione Codice Conto'
                                    : ''
                                "
                                @input="
                                  validateInput9001(
                                    rowIndex,
                                    colIndex,
                                    $event,
                                    vettoreCodTributo9001
                                  )
                                "
                                @keydown="
                                  colIndex === 7
                                    ? blockLetters(
                                        $event,
                                        rowIndex,
                                        colIndex,
                                        colIndex,
                                        vettoreCodTributo9001
                                      )
                                    : null
                                "
                                @paste="
                                  colIndex === 7 ? blockPaste($event) : null
                                "
                                @focus="$event.target.select()"
                              />
                            </template>
                            <template v-else>
                              {{
                                mapped9001(rowIndex, vettoreCodTributo9001)[
                                  colIndex
                                ] === "None"
                                  ? ""
                                  : mapped9001(rowIndex, vettoreCodTributo9001)[
                                      colIndex
                                    ]
                              }}
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- Messaggio successo solo se NON ci sono nuovi ma ci sono PCT -->
                  <div
                    v-else-if="vettoreCodTributo9001_PCT?.length > 0"
                    class="success-container"
                  >
                    <svg
                      class="checkcodicicontoIcon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <p class="checkcodiciconto">
                      Tutti i codici tributo 9001 individuati nel Modello F24
                      sono già presenti nel tuo
                      <span class="scrittapiano">Piano Codici Tributo</span>
                    </p>
                  </div>
                </div>
              </div>

              <!-- Navigazione tra sub-fasi e bottone finale solo sull'ultima -->
              <div class="subphase-navigation">
                <button
                  v-show="!isFirstPhase"
                  @click="prevSubPhase"
                  class="prev-subphase-btn"
                  title="Indietro"
                >
                  <i class="fa-solid fa-arrow-left"></i>
                </button>
                <button
                  v-show="!isLastPhase"
                  @click="nextSubPhase"
                  class="next-subphase-btn"
                  title="Avanti"
                >
                  <i class="fa-solid fa-arrow-right"></i>
                </button>
                <div
                  v-if="showResult && isLastPhase"
                  class="addrow-buttons-add-bilancino"
                >
                  <button
                    v-if="
                      vettoreCodTributo.length > 0 ||
                      vettoreCodTributo9001?.length > 0
                    "
                    :disabled="calculating2"
                    class="addcodconto action-button-rows"
                    @click="addRowsInPDC"
                  >
                    <span v-if="calculating2">
                      <div class="spinner"></div>
                      Elaborazione...
                    </span>
                    <span v-else> Aggiungi righe e salva</span>
                  </button>
                  <button
                    v-if="
                      vettoreCodTributo.length > 0 ||
                      vettoreCodTributo9001?.length > 0
                    "
                    class="annullaAddRow"
                    @click="refreshAddBilancino"
                  >
                    Annulla
                  </button>
                  <button v-else @click="refreshAddBilancino" class="finebtn">
                    Fine
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddRowModal
          :visible="showAddRow"
          :title="currentAddRowTitle"
          :row="newRow"
          :base-fields="currentAddRowBaseFields"
          :software-options="currentAddRowSoftwareOptions"
          :software-fields="currentAddRowSoftwareFields"
          :selected-softwares="selectedAddRowSoftwares"
          @update:selected-softwares="updateSelectedAddRowSoftwares"
          @field-input="handleAddRowFieldInput"
          @submit="addRow"
          @close="refreshAddRow"
        />
        <div v-if="false && showAddRow" class="add-row-form">
          <div class="software-selector-add-row" v-if="showAddRow">
            <label for="softwareSelectAddRow">Seleziona Software: </label>
            <select v-model="selectedSoftwareAddRow" id="softwareSelectAddRow">
              <option value="TEAMSYSTEM">TeamSystem</option>
              <option value="DATEV">Datev</option>
              <!-- <option value="DATEV LIBERI PROF.">Datev Liberi Prof.</option> -->
              <option value="ZUCCHETTI">Zucchetti</option>
              <option value="SEAC">SEAC</option>
              <option value="SISTEMI">Sistemi</option>
            </select>
          </div>
          <table
            id="addRowTable"
            :class="
              selectedSoftwareAddRow === 'DATEV'
                ? 'addrowtabledatev'
                : 'addrowtable'
            "
          >
            <tr>
              <th
                class="addrowheaders"
                v-for="index in visibleHeaderIndices"
                :key="index"
              >
                {{ getHeaderLabel(index) }}
              </th>
            </tr>
            <tr>
              <td v-for="index in visibleHeaderIndices" :key="index">
                <!-- Codice Tributo (campo 0) -->
                <input
                  v-if="index === 0"
                  v-model="newRow[index]"
                  @input="formatCodiceConto($event, index)"
                  :placeholder="getPlaceholder(index)"
                  :title="getErrorMessage(index)"
                  :class="{ 'italic-text': newRow[index] === 'N.A.' }"
                />

                <!-- Cod. Conto TeamSystem (pattern con slash) -->
                <input
                  v-else-if="index === 2 || index === 3"
                  v-model="newRow[index]"
                  @input="formatCodiceConto($event, index)"
                  :placeholder="getPlaceholder(index)"
                  :title="getErrorMessage(index)"
                  :class="{ 'italic-text': newRow[index] === 'N.A.' }"
                />
                <input
                  v-else-if="index === 14 || index === 15"
                  v-model="newRow[index]"
                  @input="formatCodiceConto($event, index)"
                  :placeholder="getPlaceholder(index)"
                  :title="getErrorMessage(index)"
                  :class="{ 'italic-text': newRow[index] === 'N.A.' }"
                />
                <input
                  v-else-if="index === 17 || index === 18"
                  v-model="newRow[index]"
                  @input="formatCodiceConto($event, index)"
                  :placeholder="getPlaceholder(index)"
                  :title="getErrorMessage(index)"
                  :class="{ 'italic-text': newRow[index] === 'N.A.' }"
                />
                <!-- Descrizione Cod. Conto -->
                <input
                  v-else-if="
                    index === 1 ||
                    index === 4 ||
                    index === 7 ||
                    index === 10 ||
                    index === 13 ||
                    index === 16
                  "
                  v-model="newRow[index]"
                  :placeholder="getPlaceholder(index)"
                  :title="getErrorMessage(index)"
                />
                <!-- Altri campi numerici -->
                <input
                  v-else
                  v-model="newRow[index]"
                  @input="formatCodiceConto($event, index)"
                  :placeholder="getPlaceholder(index)"
                  :title="getErrorMessage(index)"
                  :pattern="getPattern(index)"
                  :class="{ 'italic-text': newRow[index] === 'N.A.' }"
                />
              </td>
            </tr>
          </table>
          <div class="addrowbuttons">
            <button class="addcodconto" @click="addRow">Aggiungi Riga</button>
            <button class="annullaAddRow" @click="refreshAddRow()">
              Annulla
            </button>
          </div>
        </div>
        <UploadFileModal
          :visible="showAddPiano"
          :title="currentPctUploadTitle"
          icon-class="fa-solid fa-table-list"
          :input-id="currentPctUploadInputId"
          file-label="Seleziona file Excel"
          accept=".xlsx,.xls,.csv"
          :warning-text="currentPctUploadWarningText"
          submit-label="Carica e salva"
          :uploading="uploading"
          :error-message="errorMessage"
          :show-preview="rows.length > 0"
          @file-selected="handleFileUpload"
          @preview="showExcelPiano = true"
          @submit="uploadFile"
          @close="closeUploadPianoModal"
        >
          <template v-if="isPctMainView" #extra-fields>
            <div class="upload-scope-panel">
              <label class="upload-scope-title">
                Dove vuoi caricare il file?
              </label>
              <div class="upload-scope-options">
                <label class="upload-scope-option">
                  <input v-model="uploadPctScope" type="radio" value="main" />
                  <span>File principale</span>
                </label>
                <label class="upload-scope-option">
                  <input
                    v-model="uploadPctScope"
                    type="radio"
                    value="existing_client"
                  />
                  <span>Cliente esistente</span>
                </label>
                <label class="upload-scope-option">
                  <input
                    v-model="uploadPctScope"
                    type="radio"
                    value="new_client"
                  />
                  <span>Nuovo cliente</span>
                </label>
              </div>

              <div
                v-if="uploadPctScope === 'existing_client'"
                class="form-group"
              >
                <label>Cliente</label>
                <select
                  v-model="selectedUploadClientKey"
                  class="upload-client-select"
                  :disabled="loadingUploadClients"
                >
                  <option value="">Seleziona cliente</option>
                  <option
                    v-for="cliente in uploadClientOptions"
                    :key="cliente.key"
                    :value="cliente.key"
                  >
                    {{ cliente.label }}
                  </option>
                </select>
                <small v-if="uploadPctErrors.client" class="field-error">
                  {{ uploadPctErrors.client }}
                </small>
              </div>

              <div
                v-if="uploadPctScope === 'new_client'"
                class="upload-new-client-grid"
              >
                <div class="form-group">
                  <label>Denominazione Cliente</label>
                  <input
                    v-model.trim="uploadNewClient.titolo_cliente"
                    type="text"
                    class="upload-client-input"
                    placeholder="Mario Rossi SRL"
                  />
                  <small
                    v-if="uploadPctErrors.titolo_cliente"
                    class="field-error"
                  >
                    {{ uploadPctErrors.titolo_cliente }}
                  </small>
                </div>
                <div class="form-group">
                  <label>Codice Fiscale</label>
                  <input
                    v-model.trim="uploadNewClient.codice_fiscale"
                    type="text"
                    class="upload-client-input"
                    maxlength="16"
                    placeholder="RSSMRA..."
                    @input="formatUploadClientFiscalCode"
                  />
                  <small
                    v-if="uploadPctErrors.codice_fiscale"
                    class="field-error"
                  >
                    {{ uploadPctErrors.codice_fiscale }}
                  </small>
                </div>
                <div class="form-group">
                  <label>Codice Ditta</label>
                  <input
                    v-model.trim="uploadNewClient.codice_ditta"
                    type="text"
                    class="upload-client-input"
                    maxlength="20"
                    placeholder="Opzionale"
                  />
                </div>
              </div>
            </div>
          </template>
        </UploadFileModal>
        <!-- Menu per caricare il piano -->
        <div
          v-if="false && showAddPiano"
          class="menu-invia-piano menu-invia-PCT"
        >
          <label for="fileInput" class="input-label titleaddpiano">
            Carica PIANO CODICI TRIBUTO
          </label>
          <div class="label-container">
            <!-- Input file -->
            <input
              id="fileInput"
              class="file-input-add-piano"
              type="file"
              ref="fileInput"
              @change="handleFileUpload"
              accept=".xlsx, .xls"
            />
            <button
              v-if="rows.length"
              @click="showExcelPiano = true"
              class="anteprimaexcel piano"
            >
              Visualizza Excel
            </button>
            <span class="info-piano">
              <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
              <span class="tooltip-piano">
                Assicurati di inserire un Piano Codici Tributo del formato
                corretto. <br />
                Il Piano attuale verrà sostituito con il Piano Codici Tributo
                caricato.
              </span>
            </span>
          </div>
          <!-- Pulsante di invio -->
          <button
            @click="uploadFile"
            :disabled="!selectedPiano || uploading"
            class="btn-invia"
          >
            <span v-if="uploading">
              <div class="spinner"></div>
              Caricamento...
            </span>
            <span v-else>Carica e salva</span>
          </button>
          <div v-if="errorMessage" class="error-message-leggi-piano">
            <p>{{ errorMessage }}</p>
          </div>
        </div>
        <div
          v-if="currentPctFileHasRows"
          class="table-meta-row"
          :class="{ 'table-meta-row--all': isAllSoftwareView }"
        >
          <div class="library-control-row">
            <div
              class="library-active-controls"
              :class="{
                'has-datev-causale':
                  isPctMainView && selectedSoftware === 'DATEV',
              }"
            >
              <div class="library-file-menu" ref="pctLibraryMenuRef">
                <button
                  type="button"
                  class="library-file-trigger"
                  :class="{
                    active: pctLibraryMenuOpen,
                    'is-client-file': currentPctIsClient,
                  }"
                  :title="`${activePctFileLabel} - ${activePctScopeLabel}`"
                  @click.stop="togglePctLibraryMenu"
                >
                  <span class="library-file-trigger-label">
                    <i
                      :class="[activePctFileIcon, 'library-file-trigger-book']"
                      aria-hidden="true"
                    ></i>
                    <span>{{ activePctFileLabel }}</span>
                  </span>
                  <i
                    :class="
                      pctLibraryMenuOpen
                        ? 'fa-solid fa-chevron-up'
                        : 'fa-solid fa-chevron-down'
                    "
                  ></i>
                </button>
                <span
                  v-if="currentPctIsClient"
                  class="library-file-trigger-scope"
                  :title="`Cliente: ${activePctScopeLabel}`"
                >
                  <span class="library-file-trigger-scope-prefix"
                    >Cliente:</span
                  >
                  <span>{{ activePctScopeLabel }}</span>
                </span>
                <div v-if="pctLibraryMenuOpen" class="library-file-dropdown">
                  <span class="library-file-section-title">Principale</span>
                  <button
                    v-for="option in pctLibraryFileOptions"
                    :key="option.key"
                    type="button"
                    class="library-file-option"
                    :class="{
                      active: isPctLibraryEntryActive(option),
                      'is-empty':
                        option.status && option.status.kind === 'empty',
                      'is-missing':
                        option.status && option.status.kind === 'missing',
                    }"
                    @click="selectPctLibraryEntry(option)"
                    :disabled="option.disabled"
                  >
                    <span class="library-file-option-body">
                      <i
                        :class="option.icon"
                        class="library-file-option-file-icon"
                        aria-hidden="true"
                      ></i>
                      <span class="library-file-option-text">
                        <strong>{{ option.label }}</strong>
                        <small>
                          {{ option.meta }}
                          <em
                            v-if="option.status"
                            class="library-file-status"
                            :class="`library-file-status--${option.status.kind}`"
                          >
                            {{ option.status.label }}
                          </em>
                        </small>
                      </span>
                    </span>
                    <i
                      v-if="isPctLibraryEntryActive(option)"
                      class="fa-solid fa-check library-file-option-check"
                    ></i>
                  </button>
                  <template v-if="pctLibraryClientGroups.length">
                    <span class="library-file-section-title">
                      Personalizzati
                    </span>
                    <div
                      v-for="client in pctLibraryClientGroups"
                      :key="client.key"
                      class="library-file-client-group"
                    >
                      <div class="library-file-client-heading">
                        <i class="fa-solid fa-star" aria-hidden="true"></i>
                        <span>{{ client.label }}</span>
                      </div>
                      <div class="library-file-client-actions">
                        <button
                          v-for="option in client.options"
                          :key="option.key"
                          type="button"
                          class="library-file-client-action"
                          :class="{
                            active: isPctLibraryEntryActive(option),
                            'is-empty':
                              option.status && option.status.kind === 'empty',
                            'is-missing':
                              option.status && option.status.kind === 'missing',
                          }"
                          :disabled="option.disabled"
                          @click="selectPctLibraryEntry(option)"
                        >
                          <i :class="option.icon" aria-hidden="true"></i>
                          <span>{{ option.shortLabel }}</span>
                          <em
                            v-if="option.status"
                            class="library-file-status library-file-status--compact"
                            :class="`library-file-status--${option.status.kind}`"
                          >
                            {{ option.status.label }}
                          </em>
                        </button>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="software-context-group">
                <select
                  v-model="selectedSoftware"
                  id="softwareSelect"
                  ref="softwareSelect"
                >
                  <option
                    v-for="option in tableSoftwareOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </div>
              <div class="search-input-wrap">
                <i class="fa-brands fa-sistrix search-icon"></i>
                <input
                  v-model.trim="tableSearchTerm"
                  type="text"
                  class="search-input-pct"
                  :placeholder="
                    isPctArchiveView ? 'Cerca nell Archivio' : 'Cerca nel Piano'
                  "
                />
              </div>
              <div
                v-if="isPctMainView && selectedSoftware === 'DATEV'"
                class="causale-library-cluster"
              >
                <button
                  type="button"
                  class="causale-library-trigger"
                  :class="{ active: editingCausaleF24 }"
                  @click="
                    editingCausaleF24
                      ? cancelEditCausaleF24()
                      : startEditCausaleF24()
                  "
                >
                  <span class="causale-library-trigger-label">
                    <span class="causale-library-trigger-label-text">
                      Causale Modelli F24
                    </span>
                    <span class="info-icon">
                      <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                      <span class="tooltip">
                        Valore usato nel CSV DATEV per importazione diretta dei
                        Modelli F24.
                      </span>
                    </span>
                  </span>
                  <strong class="causale-library-trigger-value">
                    {{ causaleModelliF24 || "Da impostare" }}
                  </strong>
                  <i
                    :class="
                      editingCausaleF24
                        ? 'fa-solid fa-chevron-up'
                        : 'fa-solid fa-chevron-down'
                    "
                    aria-hidden="true"
                  ></i>
                </button>
                <div v-if="editingCausaleF24" class="causale-library-panel">
                  <label class="causale-library-panel-label">
                    Valore causale
                  </label>
                  <div class="causale-library-panel-row">
                    <input
                      v-model.trim="causaleF24Draft"
                      class="causale-library-input"
                      type="text"
                      maxlength="4"
                      placeholder="B70"
                      @input="handleCausaleF24Input"
                    />
                    <button
                      class="causale-library-button"
                      type="button"
                      :disabled="savingCausaleF24"
                      @click="saveCausaleF24"
                    >
                      <i class="fa-solid fa-floppy-disk"></i>
                      Salva
                    </button>
                    <button
                      class="causale-library-button causale-library-button--ghost"
                      type="button"
                      @click="cancelEditCausaleF24"
                    >
                      Annulla
                    </button>
                  </div>
                  <span class="causale-library-panel-hint">
                    Massimo 4 caratteri alfanumerici.
                  </span>
                  <span v-if="causaleF24Error" class="causale-library-error">
                    {{ causaleF24Error }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="ultimamodifica">
            <span class="ultimamodificatext">
              Ultima modifica: {{ lastModified }}
            </span>
          </div>
        </div>
        <div v-if="showAllSoftwareScrollControls" class="table-scroll-toolbar">
          <input
            class="table-mini-scrollbar"
            type="range"
            min="0"
            max="100"
            step="0.1"
            :value="tableScrollPercent"
            :disabled="!canScrollTableLeft && !canScrollTableRight"
            title="Scorri colonne"
            aria-label="Scorri colonne della tabella"
            @input="setAllSoftwareScrollFromSlider"
          />
        </div>
        <div
          v-if="
            jsonData.length > 0 ||
            isPctArchiveView ||
            confirmModalVisibile ||
            modalVisible9001 ||
            modalVisibleSaldoF
          "
          class="table-wrapper"
          ref="tableWrapperRef"
          :class="{
            'table-wrapper--all': showAllSoftwareScrollControls,
            'can-scroll-left':
              showAllSoftwareScrollControls && canScrollTableLeft,
            'can-scroll-right':
              showAllSoftwareScrollControls && canScrollTableRight,
          }"
          @scroll="
            showAllSoftwareScrollControls
              ? updateAllSoftwareScrollState()
              : null
          "
        >
          <table
            v-if="isPctMainView && jsonData.length > 0"
            id="excelTable"
            :key="tableKey"
            ref="exceltableRef"
            :class="{
              editing: isEditing,
              'all-software-table': isAllSoftwareView,
              'has-empty-body':
                jsonData.length === 1 ||
                (tableSearchTerm && filteredDisplayRows.length === 1),
            }"
          >
            <tr
              class="riga"
              :class="[
                'riga',
                {
                  'row-deleting': deletedRows[displayRow.originalIndex],
                  'highlight-row':
                    !deletedRows[displayRow.originalIndex] &&
                    (hoveredRow === displayRow.originalIndex ||
                      hoveredRow === 'all') &&
                    displayRow.originalIndex !== 0,
                  'provisional-row':
                    !deletedRows[displayRow.originalIndex] &&
                    provisionalRows.includes(displayRow.originalIndex),
                },
              ]"
              v-for="displayRow in filteredDisplayRows"
              :key="displayRow.originalIndex"
            >
              <th
                v-if="displayRow.originalIndex === 0"
                :class="[
                  'row-index',
                  { 'sticky-row-index-cell': isAllSoftwareView },
                ]"
              ></th>
              <td
                v-else
                :class="[
                  'row-index',
                  { 'sticky-row-index-cell': isAllSoftwareView },
                ]"
              >
                {{ displayRow.originalIndex }}
              </td>
              <template v-for="(cell, colIndex) in displayRow.row">
                <th
                  v-if="
                    displayRow.originalIndex === 0 &&
                    (colIndex === 0 || visibleColumns.includes(colIndex))
                  "
                  :key="colIndex"
                  :class="{
                    'sticky-tributo-cell': isAllSoftwareView && colIndex === 0,
                  }"
                  @dblclick="toggleEditing"
                >
                  {{ cell }}
                </th>
                <td
                  v-else-if="
                    displayRow.originalIndex !== 0 &&
                    (colIndex === 0 || visibleColumns.includes(colIndex))
                  "
                  :key="colIndex"
                  :contenteditable="
                    isEditing && isEditableColumnTable(colIndex)
                  "
                  @dblclick="toggleEditing"
                  @input="
                    updateCell(
                      displayRow.originalIndex,
                      colIndex,
                      $event.target.textContent
                    )
                  "
                  :class="{
                    'highlight-cell': isCellModified(
                      displayRow.originalIndex,
                      colIndex
                    ),
                    'modified-cell':
                      modifiedCells[
                        `${displayRow.originalIndex}-${colIndex}`
                      ] && !errors[`${displayRow.originalIndex}-${colIndex}`],
                    'error-cell':
                      errors[`${displayRow.originalIndex}-${colIndex}`],
                    'italic-none':
                      cell === 'N.A.' || cell === 'NESSUNA CORRELAZIONE',
                    'sticky-tributo-cell': isAllSoftwareView && colIndex === 0,
                  }"
                >
                  {{ cell }}
                </td>
              </template>
              <td
                v-if="
                  isEditing && hasDataRows && displayRow.originalIndex === 0
                "
                class="delete-column"
              ></td>
              <td
                v-if="
                  isEditing && hasDataRows && displayRow.originalIndex !== 0
                "
                class="delete-column"
              >
                <button
                  v-if="isEditing"
                  title="Elimina riga"
                  class="delete-button"
                  :class="{ active: activeDelete[displayRow.originalIndex] }"
                  @click="deleteRow(displayRow.originalIndex, $event)"
                  @mouseenter="hoveredRow = displayRow.originalIndex"
                  @mouseleave="hoveredRow = null"
                >
                  <i class="fa-solid fa-trash" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </table>
          <div
            v-if="isPctMainView && pctMainTableIsEmpty"
            class="table-empty-message"
          >
            <p>Nessun codice tributo presente</p>
          </div>
          <div
            v-else-if="
              isPctMainView &&
              tableSearchTerm &&
              filteredDisplayRows.length === 1
            "
            class="table-empty-message"
          >
            <p>Nessun risultato per il filtro inserito</p>
          </div>
          <div v-if="isPct9001View" class="inline-archive-wrapper">
            <div v-if="archive9001Missing" class="archive-missing-notice">
              <p>
                Questo archivio non esiste ancora. Si popolera automaticamente
                con le conversioni. In alternativa, puoi caricare un file gia
                compilato oppure
                <button
                  class="archive-missing-inline-action"
                  type="button"
                  @click="
                    scaricaModello(
                      'archivio_9001',
                      'MODELLO - Modelli F24 - Archivio Codici Tributo 9001.xlsx'
                    )
                  "
                >
                  scaricare il modello vuoto
                </button>
                .
              </p>
            </div>
            <table
              v-else
              id="PDCTable9001Inline"
              ref="tableRef9001Inline"
              :key="tableKey9001"
              :class="[
                { 'editing-9001': isEditing9001 },
                tableExtraClasses9001,
              ]"
            >
              <tr
                class="riga"
                v-for="displayRow in filtered9001DisplayRows"
                :key="displayRow.originalIndex"
                :class="{
                  'header-row9001': displayRow.originalIndex === 0,
                  'row-deleting9001': deletedRows9001[displayRow.originalIndex],
                  'highlight-row9001':
                    !deletedRows9001[displayRow.originalIndex] &&
                    hoveredRow9001 === displayRow.originalIndex &&
                    displayRow.originalIndex !== 0,
                }"
              >
                <th
                  v-if="displayRow.originalIndex === 0"
                  class="row-index"
                ></th>
                <td v-else class="row-index">{{ displayRow.originalIndex }}</td>
                <template v-for="(cell, colIndex) in displayRow.row">
                  <th
                    v-if="
                      displayRow.originalIndex === 0 &&
                      isPctArchiveColumnVisible(colIndex, displayRow.row)
                    "
                    :key="'header-inline-9001-' + colIndex"
                    @dblclick="toggleEditing9001"
                  >
                    {{ cell }}
                  </th>
                  <td
                    v-else-if="
                      displayRow.originalIndex !== 0 &&
                      isPctArchiveColumnVisible(colIndex)
                    "
                    :key="'cell-inline-9001-' + colIndex"
                    :contenteditable="
                      isEditing9001 && (colIndex === 1 || colIndex > 3)
                    "
                    @dblclick="toggleEditing9001"
                    @input="
                      updateCell9001(
                        displayRow.originalIndex,
                        colIndex,
                        $event.target.textContent,
                        $event
                      )
                    "
                    :class="{
                      'highlight-cell': isCellModified9001(
                        displayRow.originalIndex,
                        colIndex
                      ),
                      'modified-cell':
                        modifiedCells9001[
                          `${displayRow.originalIndex}-${colIndex}`
                        ] &&
                        !errors9001[`${displayRow.originalIndex}-${colIndex}`],
                      'error-cell':
                        errors9001[`${displayRow.originalIndex}-${colIndex}`],
                      'desc-column-9001': colIndex === 1,
                    }"
                  >
                    {{ cell ?? "" }}
                  </td>
                </template>
                <td
                  v-if="isEditing9001 && displayRow.originalIndex === 0"
                  class="delete-column"
                ></td>
                <td
                  v-if="isEditing9001 && displayRow.originalIndex !== 0"
                  class="delete-column"
                >
                  <button
                    title="Elimina riga"
                    class="delete-button"
                    :class="{
                      active: activeDelete9001?.[displayRow.originalIndex],
                    }"
                    @click="delete9001Row(displayRow.originalIndex, $event)"
                    @mouseenter="hoveredRow9001 = displayRow.originalIndex"
                    @mouseleave="hoveredRow9001 = null"
                  >
                    <i class="fa-solid fa-trash" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </table>
            <div
              v-if="!archive9001Missing && archive9001TableIsEmpty"
              class="table-empty-message"
            >
              <p>Nessun codice tributo 9001 presente</p>
            </div>
            <div
              v-else-if="
                !archive9001Missing &&
                tableSearchTerm &&
                filtered9001DisplayRows.length === 1
              "
              class="table-empty-message"
            >
              <p>Nessun risultato per il filtro inserito</p>
            </div>
          </div>
          <div v-if="isPctSaldoFView" class="inline-archive-wrapper">
            <div v-if="archiveSaldoFMissing" class="archive-missing-notice">
              <p>
                Questo archivio non esiste ancora. Si popolera automaticamente
                con le conversioni. In alternativa, puoi caricare un file gia
                compilato oppure
                <button
                  class="archive-missing-inline-action"
                  type="button"
                  @click="
                    scaricaModello(
                      'coordinate_bancarie',
                      'MODELLO - Modelli F24 - Archivio Coordinate Bancarie.xlsx'
                    )
                  "
                >
                  scaricare il modello vuoto
                </button>
                .
              </p>
            </div>
            <table
              v-else
              id="SaldoFTableInline"
              ref="tableRefSaldoFInline"
              :key="tableKeySaldoF"
              :class="{
                'editing-9001': isEditingSaldoF,
                'all-software-bank-table': isAllSoftwareView,
              }"
            >
              <tr
                class="riga"
                v-for="displayRow in filteredSaldoFDisplayRows"
                :key="displayRow.originalIndex"
                :class="{
                  'header-rowsaldof': displayRow.originalIndex === 0,
                  'row-deleting9001':
                    deletedRowsSaldoF[displayRow.originalIndex],
                  'highlight-row9001':
                    !deletedRowsSaldoF[displayRow.originalIndex] &&
                    hoveredRowSaldoF === displayRow.originalIndex &&
                    displayRow.originalIndex !== 0,
                }"
              >
                <th
                  v-if="displayRow.originalIndex === 0"
                  class="row-index"
                ></th>
                <td v-else class="row-index">{{ displayRow.originalIndex }}</td>
                <template v-for="(cell, colIndex) in displayRow.row">
                  <th
                    v-if="
                      displayRow.originalIndex === 0 &&
                      isPctArchiveColumnVisible(colIndex, displayRow.row)
                    "
                    :key="'header-inline-saldof-' + colIndex"
                    :class="saldoFBankColumnClass(colIndex)"
                    @dblclick="toggleEditingSaldoF"
                  >
                    {{ cell }}
                  </th>
                  <td
                    v-else-if="
                      displayRow.originalIndex !== 0 &&
                      isPctArchiveColumnVisible(colIndex)
                    "
                    :key="'cell-inline-saldof-' + colIndex"
                    :data-saldof-cell="`${displayRow.originalIndex}-${colIndex}`"
                    :contenteditable="
                      isEditingSaldoF &&
                      isSaldoFEditableColumn(colIndex) &&
                      !isSaldoFIbanColumn(colIndex)
                    "
                    @dblclick="toggleEditingSaldoF"
                    @input="
                      !isSaldoFIbanColumn(colIndex) &&
                        updateCellSaldoF(
                          displayRow.originalIndex,
                          colIndex,
                          $event.target.textContent,
                          $event
                        )
                    "
                    :class="[
                      saldoFBankColumnClass(colIndex),
                      {
                        'highlight-cell': isCellModifiedSaldoF(
                          displayRow.originalIndex,
                          colIndex
                        ),
                        'modified-cell':
                          modifiedCellsSaldoF[
                            `${displayRow.originalIndex}-${colIndex}`
                          ] &&
                          !errorsSaldoF[
                            `${displayRow.originalIndex}-${colIndex}`
                          ],
                        'error-cell':
                          errorsSaldoF[
                            `${displayRow.originalIndex}-${colIndex}`
                          ],
                        'italic-none': cell === 'N.A.',
                      },
                    ]"
                  >
                    <IbanMaskedInput
                      v-if="isSaldoFIbanColumn(colIndex) && isEditingSaldoF"
                      class="library-bank-iban-editor"
                      :value="cell || ''"
                      :invalid="
                        Boolean(
                          errorsSaldoF[
                            `${displayRow.originalIndex}-${colIndex}`
                          ]
                        )
                      "
                      @input="
                        updateSaldoFIbanCell(
                          displayRow.originalIndex,
                          colIndex,
                          $event
                        )
                      "
                      @blur="
                        validateSaldoFIbanCell(
                          displayRow.originalIndex,
                          colIndex
                        )
                      "
                    />
                    <span
                      v-else-if="isSaldoFIbanColumn(colIndex)"
                      class="library-bank-iban-value"
                    >
                      {{ formatItalianIban(cell) }}
                    </span>
                    <template v-else>{{ cell ?? "" }}</template>
                  </td>
                </template>
                <td
                  v-if="isEditingSaldoF && displayRow.originalIndex === 0"
                  class="delete-column"
                ></td>
                <td
                  v-if="isEditingSaldoF && displayRow.originalIndex !== 0"
                  class="delete-column"
                >
                  <button
                    title="Elimina riga"
                    class="delete-button"
                    :class="{
                      active: activeDeleteSaldoF?.[displayRow.originalIndex],
                    }"
                    @click="deleteSaldoFRow(displayRow.originalIndex, $event)"
                    @mouseenter="hoveredRowSaldoF = displayRow.originalIndex"
                    @mouseleave="hoveredRowSaldoF = null"
                  >
                    <i class="fa-solid fa-trash" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </table>
            <div
              v-if="!archiveSaldoFMissing && archiveSaldoFTableIsEmpty"
              class="table-empty-message"
            >
              <p>Nessuna coordinata bancaria presente</p>
            </div>
            <div
              v-else-if="
                !archiveSaldoFMissing &&
                tableSearchTerm &&
                filteredSaldoFDisplayRows.length === 1
              "
              class="table-empty-message"
            >
              <p>Nessun risultato per il filtro inserito</p>
            </div>
          </div>
          <!-- Modal di conferma per l'eliminazione -->
          <LibraryDeleteModal
            v-if="confirmModalConfirmClass === 'btn-danger'"
            :visible="confirmModalVisibile"
            title="Elimina file dalla libreria"
            :message="confirmModalMessaggio"
            :options="
              confirmModalShowArchiveOptions ? confirmModalDeleteOptions : []
            "
            :selected-options="deletePctTargets"
            :confirm-label="confirmModalConfirmLabel"
            :cancel-label="confirmModalCancelLabel"
            :confirm-disabled="
              confirmModalShowArchiveOptions && !confirmModalDeleteHasSelection
            "
            @toggle-option="$set(deletePctTargets, $event.key, $event.checked)"
            @cancel="confirmModalCallback && confirmModalCallback(false)"
            @confirm="confirmModalCallback && confirmModalCallback(true)"
          />
          <div v-else-if="confirmModalVisibile" class="modal">
            <div class="modal-content">
              <h2>{{ confirmModalTitle }}</h2>
              <p class="deletemessage">{{ confirmModalMessaggio }}</p>
              <div
                v-if="confirmModalShowArchiveOptions"
                class="delete-archive-options"
              >
                <label
                  v-for="option in confirmModalDeleteOptions"
                  :key="option.key"
                  class="delete-archive-checkbox"
                >
                  <input
                    v-model="deletePctTargets[option.key]"
                    type="checkbox"
                  />
                  {{ option.label }}
                </label>
              </div>
              <button
                @click="confirmModalCallback(false)"
                class="btn-modal btn-secondary"
              >
                {{ confirmModalCancelLabel }}
              </button>
              <button
                @click="confirmModalCallback(true)"
                class="btn-modal"
                :class="confirmModalConfirmClass"
                :disabled="
                  confirmModalShowArchiveOptions &&
                  !confirmModalDeleteHasSelection
                "
              >
                <i
                  v-if="confirmModalConfirmIcon"
                  :class="confirmModalConfirmIcon"
                  aria-hidden="true"
                ></i>
                {{ confirmModalConfirmLabel }}
              </button>
            </div>
          </div>
          <!-- Modal for Codici Tributo 9001 -->
          <div v-if="modalVisible9001" class="modal-9001">
            <div class="modal-content-9001">
              <i
                class="fa-solid fa-xmark chiudiPDC9001"
                @click="attemptClose9001Modal"
              ></i>

              <h2 class="titlePDC9001">Archivio Codici Tributo 9001</h2>

              <div class="table-container">
                <!-- Dashboard -->
                <div class="dashboard9001">
                  <div class="buttons" ref="dashboardRef9001">
                    <!-- MODIFICA -->
                    <button
                      class="btninput"
                      :class="{ 'active-button': isEditing9001 }"
                      :disabled="jsonData9001.length <= 1"
                      @click="toggleEditing9001"
                    >
                      <i class="fa-solid fa-pen-to-square toolicon"></i>
                      Modifica
                    </button>

                    <button
                      class="btninput addRowButton"
                      :class="{ 'active-button': showAddRow }"
                      :disabled="!currentAddRowHeaders.length"
                      @click="openAddRowModal"
                    >
                      <i class="fa-solid fa-plus toolicon"></i>
                      Aggiungi Riga
                    </button>

                    <!-- SCARICA -->
                    <div class="download-menu">
                      <button
                        class="btninput download-menu-trigger"
                        type="button"
                      >
                        <i class="fas fa-download toolicon"></i> Scarica
                        <i
                          class="fa-solid fa-chevron-down download-menu-chevron"
                        ></i>
                      </button>
                      <div class="download-menu-dropdown">
                        <button
                          class="download-menu-item"
                          type="button"
                          @click="downloadPDC9001"
                          :disabled="jsonData9001.length <= 1"
                        >
                          <i class="fas fa-file-excel"></i> File attuale
                        </button>
                        <button
                          class="download-menu-item"
                          type="button"
                          @click="
                            scaricaModello(
                              'archivio_9001',
                              'MODELLO - Modelli F24 - Archivio Codici Tributo 9001.xlsx'
                            )
                          "
                        >
                          <i class="fas fa-file-excel"></i> Modello vuoto
                        </button>
                      </div>
                    </div>

                    <!-- SOSTITUISCI -->
                    <button
                      class="btninput"
                      :class="{ uploading9001: uploading9001 }"
                      @click="openUploadPianoModal"
                      :disabled="uploading9001"
                    >
                      <i class="fas fa-upload toolicon"></i>
                      {{ uploading9001 ? "Elaborazione..." : "Sostituisci" }}
                    </button>

                    <!-- ELIMINA -->
                    <button
                      class="btninput danger"
                      @click="deleteFile9001"
                      :disabled="jsonData9001.length <= 1 || uploading9001"
                    >
                      <i class="fas fa-trash toolicon"></i> Elimina
                    </button>

                    <!-- SALVA -->
                    <button
                      class="btninput addRowButton savebuttondiv"
                      :class="{ unsaved: hasUnsavedChanges9001 }"
                      @click="saveChanges9001"
                      :disabled="
                        !hasUnsavedChanges9001 ||
                        uploading9001 ||
                        !jsonData9001.length
                      "
                    >
                      <i
                        class="fa-solid fa-floppy-disk savebutton"
                        :class="{ unsaved: hasUnsavedChanges9001 }"
                      ></i>
                      <span>Salva</span>
                    </button>

                    <!-- ANNULLA -->
                    <button
                      class="btninput addRowButton savebuttondiv"
                      :class="{ unsaved: hasUnsavedChanges9001 }"
                      @click="cancelChanges9001"
                      :disabled="!hasUnsavedChanges9001 || !jsonData9001.length"
                    >
                      <i
                        class="fa-solid fa-xmark cancelbutton"
                        :class="{ unsaved: hasUnsavedChanges9001 }"
                      ></i>
                      <span>Annulla</span>
                    </button>

                    <!-- Input file nascosto -->
                    <input
                      type="file"
                      ref="fileInput9001"
                      class="hidden-file-input"
                      accept=".xlsx,.xls,.csv"
                      @change="replaceFile9001"
                    />
                  </div>
                </div>

                <div v-if="archive9001Missing" class="archive-missing-notice">
                  <p>
                    Questo archivio non esiste ancora. Si popolerà
                    automaticamente con le conversioni. In alternativa, puoi
                    caricare un file già compilato oppure
                    <button
                      class="archive-missing-inline-action"
                      type="button"
                      @click="
                        scaricaModello(
                          'archivio_9001',
                          'MODELLO - Modelli F24 - Archivio Codici Tributo 9001.xlsx'
                        )
                      "
                    >
                      scaricare il modello vuoto
                    </button>
                    .
                  </p>
                </div>

                <!-- Tabella -->
                <table
                  v-if="!archive9001Missing"
                  id="PDCTable9001"
                  ref="tableRef9001"
                  :key="tableKey9001"
                  :class="[
                    { 'editing-9001': isEditing9001 },
                    tableExtraClasses9001,
                  ]"
                >
                  <tr
                    class="riga"
                    v-for="(row, rowIndex) in jsonData9001"
                    :key="rowIndex"
                    :class="{
                      'header-row9001': rowIndex === 0,
                      'row-deleting9001': deletedRows9001[rowIndex],
                      'highlight-row9001':
                        !deletedRows9001[rowIndex] &&
                        hoveredRow9001 === rowIndex &&
                        rowIndex !== 0,
                    }"
                  >
                    <!-- Numero riga -->
                    <th v-if="rowIndex === 0" class="row-index"></th>
                    <td v-else class="row-index">{{ rowIndex }}</td>

                    <!-- Celle -->
                    <template v-for="(cell, colIndex) in row">
                      <!-- Header -->
                      <th
                        v-if="
                          rowIndex === 0 &&
                          isPctArchiveColumnVisible(colIndex, row)
                        "
                        :key="'header-' + colIndex"
                        @dblclick="toggleEditing9001"
                      >
                        {{ cell }}
                      </th>

                      <!-- Dati -->
                      <td
                        v-else-if="
                          rowIndex !== 0 && isPctArchiveColumnVisible(colIndex)
                        "
                        :key="'cell-' + colIndex"
                        :contenteditable="
                          isEditing9001 && (colIndex === 1 || colIndex > 3)
                        "
                        @dblclick="toggleEditing9001"
                        @input="
                          updateCell9001(
                            rowIndex,
                            colIndex,
                            $event.target.textContent,
                            $event
                          )
                        "
                        :class="{
                          'highlight-cell': isCellModified9001(
                            rowIndex,
                            colIndex
                          ),
                          'modified-cell':
                            modifiedCells9001[`${rowIndex}-${colIndex}`] &&
                            !errors9001[`${rowIndex}-${colIndex}`],
                          'error-cell': errors9001[`${rowIndex}-${colIndex}`],
                          'desc-column-9001': colIndex === 1,
                        }"
                      >
                        {{ cell ?? "" }}
                      </td>
                    </template>

                    <!-- Colonna cestino (solo in editing) -->
                    <td
                      v-if="isEditing9001 && rowIndex === 0"
                      class="delete-column"
                    ></td>
                    <td
                      v-if="isEditing9001 && rowIndex !== 0"
                      class="delete-column"
                    >
                      <button
                        title="Elimina riga"
                        class="delete-button"
                        :class="{ active: activeDelete9001?.[rowIndex] }"
                        @click="delete9001Row(rowIndex, $event)"
                        @mouseenter="hoveredRow9001 = rowIndex"
                        @mouseleave="hoveredRow9001 = null"
                      >
                        <i class="fa-solid fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </table>

                <!-- Messaggio vuoto -->
                <div
                  v-if="!archive9001Missing && jsonData9001.length <= 1"
                  class="noRowsArchivio"
                >
                  <p>Nessun codice tributo presente nell'archivio</p>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  @click="attemptClose9001Modal"
                  class="btn-modal-9001 btn-secondary-9001"
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
          <!-- Modal Coordinate Bancarie -->
          <div v-if="modalVisibleSaldoF" class="modal-saldof">
            <div class="modal-content-saldof">
              <i
                class="fa-solid fa-xmark chiudiPDCsaldof"
                @click="attemptCloseSaldoFModal"
              ></i>

              <h2 class="titlePDCsaldof">Archivio Coordinate Bancarie</h2>

              <div class="table-container">
                <div class="dashboard9001">
                  <div class="buttons" ref="dashboardRefSaldoF">
                    <button
                      class="btninput"
                      :class="{ 'active-button': isEditingSaldoF }"
                      :disabled="jsonDataSaldoF.length <= 1"
                      @click="toggleEditingSaldoF"
                    >
                      <i class="fa-solid fa-pen-to-square toolicon"></i>
                      Modifica
                    </button>
                    <button
                      class="btninput addRowButton"
                      :class="{ 'active-button': showAddRow }"
                      :disabled="!currentAddRowHeaders.length"
                      @click="openAddRowModal"
                    >
                      <i class="fa-solid fa-plus toolicon"></i>
                      Aggiungi Riga
                    </button>
                    <div class="download-menu">
                      <button
                        class="btninput download-menu-trigger"
                        type="button"
                      >
                        <i class="fas fa-download toolicon"></i> Scarica
                        <i
                          class="fa-solid fa-chevron-down download-menu-chevron"
                        ></i>
                      </button>
                      <div class="download-menu-dropdown">
                        <button
                          class="download-menu-item"
                          type="button"
                          @click="downloadSaldoF"
                          :disabled="jsonDataSaldoF.length <= 1"
                        >
                          <i class="fas fa-file-excel"></i> File attuale
                        </button>
                        <button
                          class="download-menu-item"
                          type="button"
                          @click="
                            scaricaModello(
                              'coordinate_bancarie',
                              'MODELLO - Modelli F24 - Archivio Coordinate Bancarie.xlsx'
                            )
                          "
                        >
                          <i class="fas fa-file-excel"></i> Modello vuoto
                        </button>
                      </div>
                    </div>
                    <button
                      class="btninput"
                      :class="{ uploading9001: uploadingSaldoF }"
                      @click="openUploadPianoModal"
                      :disabled="uploadingSaldoF"
                    >
                      <i class="fas fa-upload toolicon"></i>
                      {{ uploadingSaldoF ? "Elaborazione..." : "Sostituisci" }}
                    </button>
                    <button
                      class="btninput danger"
                      @click="deleteFileSaldoF"
                      :disabled="jsonDataSaldoF.length <= 1 || uploadingSaldoF"
                    >
                      <i class="fas fa-trash toolicon"></i> Elimina
                    </button>
                    <button
                      class="btninput addRowButton savebuttondiv"
                      :class="{ unsaved: hasUnsavedChangesSaldoF }"
                      @click="saveChangesSaldoF"
                      :disabled="
                        !hasUnsavedChangesSaldoF ||
                        uploadingSaldoF ||
                        !jsonDataSaldoF.length
                      "
                    >
                      <i
                        class="fa-solid fa-floppy-disk savebutton"
                        :class="{ unsaved: hasUnsavedChangesSaldoF }"
                      ></i>
                      <span>Salva</span>
                    </button>
                    <button
                      class="btninput addRowButton savebuttondiv"
                      :class="{ unsaved: hasUnsavedChangesSaldoF }"
                      @click="cancelChangesSaldoF"
                      :disabled="
                        !hasUnsavedChangesSaldoF || !jsonDataSaldoF.length
                      "
                    >
                      <i
                        class="fa-solid fa-xmark cancelbutton"
                        :class="{ unsaved: hasUnsavedChangesSaldoF }"
                      ></i>
                      <span>Annulla</span>
                    </button>
                    <input
                      type="file"
                      ref="fileInputSaldoF"
                      class="hidden-file-input"
                      accept=".xlsx,.xls,.csv"
                      @change="replaceFileSaldoF"
                    />
                  </div>
                </div>

                <div v-if="archiveSaldoFMissing" class="archive-missing-notice">
                  <p>
                    Questo archivio non esiste ancora. Si popolerà
                    automaticamente con le conversioni. In alternativa, puoi
                    caricare un file già compilato oppure
                    <button
                      class="archive-missing-inline-action"
                      type="button"
                      @click="
                        scaricaModello(
                          'coordinate_bancarie',
                          'MODELLO - Modelli F24 - Archivio Coordinate Bancarie.xlsx'
                        )
                      "
                    >
                      scaricare il modello vuoto
                    </button>
                    .
                  </p>
                </div>

                <table
                  v-if="!archiveSaldoFMissing"
                  id="SaldoFTable"
                  ref="tableRefSaldoF"
                  :key="tableKeySaldoF"
                  :class="{ 'editing-9001': isEditingSaldoF }"
                >
                  <tr
                    class="riga"
                    v-for="(row, rowIndex) in jsonDataSaldoF"
                    :key="rowIndex"
                    :class="{
                      'header-rowsaldof': rowIndex === 0,
                      'row-deleting9001': deletedRowsSaldoF[rowIndex],
                      'highlight-row9001':
                        !deletedRowsSaldoF[rowIndex] &&
                        hoveredRowSaldoF === rowIndex &&
                        rowIndex !== 0,
                    }"
                  >
                    <!-- Numero riga -->
                    <th v-if="rowIndex === 0" class="row-index"></th>
                    <td v-else class="row-index">{{ rowIndex }}</td>

                    <!-- Celle -->
                    <template v-for="(cell, colIndex) in row">
                      <th
                        v-if="
                          rowIndex === 0 &&
                          isPctArchiveColumnVisible(colIndex, row)
                        "
                        :key="'header-' + colIndex"
                        :class="saldoFBankColumnClass(colIndex)"
                        @dblclick="toggleEditingSaldoF"
                      >
                        {{ cell }}
                      </th>

                      <td
                        v-else-if="
                          rowIndex !== 0 && isPctArchiveColumnVisible(colIndex)
                        "
                        :key="'cell-' + colIndex"
                        :data-saldof-cell="`${rowIndex}-${colIndex}`"
                        :contenteditable="
                          isEditingSaldoF &&
                          isSaldoFEditableColumn(colIndex) &&
                          !isSaldoFIbanColumn(colIndex)
                        "
                        @dblclick="toggleEditingSaldoF"
                        @input="
                          !isSaldoFIbanColumn(colIndex) &&
                            updateCellSaldoF(
                              rowIndex,
                              colIndex,
                              $event.target.textContent,
                              $event
                            )
                        "
                        :class="[
                          saldoFBankColumnClass(colIndex),
                          {
                            'highlight-cell': isCellModifiedSaldoF(
                              rowIndex,
                              colIndex
                            ),
                            'modified-cell':
                              modifiedCellsSaldoF[`${rowIndex}-${colIndex}`] &&
                              !errorsSaldoF[`${rowIndex}-${colIndex}`],
                            'error-cell':
                              errorsSaldoF[`${rowIndex}-${colIndex}`],
                            'italic-none': cell === 'N.A.',
                          },
                        ]"
                      >
                        <IbanMaskedInput
                          v-if="isSaldoFIbanColumn(colIndex) && isEditingSaldoF"
                          class="library-bank-iban-editor"
                          :value="cell || ''"
                          :invalid="
                            Boolean(errorsSaldoF[`${rowIndex}-${colIndex}`])
                          "
                          @input="
                            updateSaldoFIbanCell(rowIndex, colIndex, $event)
                          "
                          @blur="validateSaldoFIbanCell(rowIndex, colIndex)"
                        />
                        <span
                          v-else-if="isSaldoFIbanColumn(colIndex)"
                          class="library-bank-iban-value"
                        >
                          {{ formatItalianIban(cell) }}
                        </span>
                        <template v-else>{{ cell ?? "" }}</template>
                      </td>
                    </template>
                    <td
                      v-if="isEditingSaldoF && rowIndex === 0"
                      class="delete-column"
                    ></td>
                    <td
                      v-if="isEditingSaldoF && rowIndex !== 0"
                      class="delete-column"
                    >
                      <button
                        title="Elimina riga"
                        class="delete-button"
                        :class="{ active: activeDeleteSaldoF?.[rowIndex] }"
                        @click="deleteSaldoFRow(rowIndex, $event)"
                        @mouseenter="hoveredRowSaldoF = rowIndex"
                        @mouseleave="hoveredRowSaldoF = null"
                      >
                        <i class="fa-solid fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </table>

                <div
                  v-if="!archiveSaldoFMissing && jsonDataSaldoF.length <= 1"
                  class="noRowsArchivio"
                >
                  <p>Nessuna coordinata bancaria presente nell'archivio</p>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  @click="attemptCloseSaldoFModal"
                  class="btn-modal-saldof btn-secondary-saldof"
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <PDFViewer
      v-if="showPDF"
      :visible="showPDF"
      :src="filePDF_URL"
      :title="fileTitle"
      @close="showPDF = false"
    />
    <ExcelViewer
      v-if="showExcelModal"
      :rows="ExcelRows"
      :visible="showExcelModal"
      :title="fileTitle"
      @close="showExcelModal = false"
    />
    <ExcelViewer
      :rows="rows"
      :visible="showExcelPiano"
      @close="showExcelPiano = false"
    />
    <SuccessMessage
      :message="successModalMessaggio"
      :isVisible="successModalVisibile"
      @close="onSuccessModalClosed"
    />
    <SimpleErrorModal
      :message="erroreModalMessaggio"
      :isVisible="erroreModalVisibile"
      @close="erroreModalVisibile = false"
    />
    <ConfirmActionModal
      :visible="showScanResetConfirmModal"
      title="Azzerare la scansione?"
      eyebrow="Reset lettore F24"
      message="L'operazione in corso verrà abbandonata e l'area di lettura sarà azzerata. Eventuali risultati arrivati dopo il reset saranno ignorati."
      confirm-label="Azzera lettura"
      cancel-label="Annulla"
      icon-class="fa-solid fa-triangle-exclamation"
      confirm-icon-class="fa-solid fa-arrows-rotate"
      @close="showScanResetConfirmModal = false"
      @confirm="confirmScanReset"
    />
    <PageLoadingOverlay
      :visible="isResettingScan"
      title="Reset lettore F24"
      message="Pulizia dell'area di lavoro in corso..."
    />
    <ErrorMessageDisplay
      :errors="errorsData"
      :isVisible="showErrorModal"
      @close="showErrorModal = false"
      @fill-na="fillEmptyWithNA"
      @fill-no-corr="fillEmptyWithNoCorr"
      @proceed-warnings="proceedWithWarnings"
    />
    <SalvaModifiche
      :isVisible="showSaveModal"
      :message="'Hai modifiche non salvate. Vuoi salvarle prima di uscire?'"
      @save="handleSaveBeforeLeave"
      @close="cancelLeave"
      @discard="discardChangesAndLeave"
    />
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import axios from "axios";
import { API_BASE_URL } from "@/config.js";
import { downloadBlob, downloadModello } from "@/utils/downloads.js";
import {
  BANK_HEADERS,
  ARCHIVE_9001_HEADERS,
  bankAccountConflictErrors,
  bankErrors,
  bankRowFromArray,
  formatItalianIban,
  normalizeIban,
  newBankId,
  validFiscalCode,
  validItalianIban,
} from "@/utils/f24Banking.js";
import { isArchiveColumnVisible } from "@/utils/f24ArchiveColumns.js";
import { getUserSettings } from "@/utils/settings.js";
import { haFunzionalita as ha, isPiano } from "@/utils/plans";
import { isGuestMode } from "@/utils/guestMode";
import SuccessMessage from "../components/SuccessMessage.vue";
import SimpleErrorModal from "../components/SimpleErrorModal.vue";
import ErrorMessageDisplay from "../components/ErrorMessageDisplay.vue";
import SalvaModifiche from "../components/SalvaModifiche.vue";
import CondivisionePiano from "../components/CondivisionePiano.vue";
import PDFViewer from "@/components/PDFViewer.vue";
import ExcelViewer from "@/components/ExcelViewer.vue";
import UploadFileModal from "@/components/UploadFileModal.vue";
import AddRowModal from "@/components/AddRowModal.vue";
import ConfirmActionModal from "@/components/ConfirmActionModal.vue";
import LibraryDeleteModal from "@/components/LibraryDeleteModal.vue";
import PageLoadingOverlay from "@/components/PageLoadingOverlay.vue";
import IbanMaskedInput from "@/components/IbanMaskedInput.vue";

export default {
  name: "LibreriaCodiciTributo",
  components: {
    SuccessMessage,
    SimpleErrorModal,
    ErrorMessageDisplay,
    SalvaModifiche,
    CondivisionePiano,
    PDFViewer,
    ExcelViewer,
    UploadFileModal,
    AddRowModal,
    ConfirmActionModal,
    LibraryDeleteModal,
    PageLoadingOverlay,
    IbanMaskedInput,
  },
  data() {
    return {
      utenteSelezionato: "",
      invitiRicevuti: [],
      invitiInviati: [],
      showCondividiModal: false,
      showInvitiDropdown: false,
      archiveMenuOpen: false,
      pctLibraryMenuOpen: false,
      messaggio: "",
      jsonData: [],
      selectedPctFileKey: "pct",
      lastSelectedPctFileKey: "pct",
      selectedPctViewKey: "main",
      lastSelectedPctViewKey: "main",
      clientPctPlans: [],
      mainPctLibraryState: {
        has_pct: false,
        pct_empty: false,
      },
      loadingClientPctPlans: false,
      tableSearchTerm: "",
      canScrollTableLeft: false,
      canScrollTableRight: false,
      tableScrollPercent: 0,
      isDataLoaded: false,
      causaleModelliF24: "",
      causaleF24Draft: "",
      causaleF24Error: "",
      codContoDefault: "11/11/111",
      editingCausaleF24: false,
      savingCausaleF24: false,
      lastSavedData: [],
      modifiedCells: {},
      lastModified: "",
      tableKey: 0,
      filePDF_URL: null,
      fileTitle: null,
      showPDF: false,
      F24File: null,
      rows: [],
      showExcelModal: false,
      showExcelPiano: false,
      PianoRows: [],
      showPianoModal: false,
      selectedPiano: null,
      uploadPctScope: "main",
      uploadClienti: [],
      loadingUploadClients: false,
      selectedUploadClientKey: "",
      uploadNewClient: {
        titolo_cliente: "",
        codice_fiscale: "",
        codice_ditta: "",
      },
      uploadPctErrors: {
        client: "",
        titolo_cliente: "",
        codice_fiscale: "",
      },
      ExcelRows: [],
      fileType: "",
      isEditing: false,
      calculating: false,
      calculating2: false,
      uploading: false,
      errorMessage: "",
      isShifted: false,
      isTransitionDone: false, // Diventa true dopo la transizione
      expanded: true,
      showAddRow: false, // Gestisce la visualizzazione del form per aggiungere una riga
      deletedRows: {}, // Oggetto per tenere traccia delle righe eliminate
      pendingDeletedRowCount: 0,
      activeDelete: {}, // Inizializza un oggetto vuoto per tracciare i pulsanti attivi
      hoveredRow: null, // Salva l'indice della riga in cui si trova il mouse
      vettoreCodTributo: [],
      editPDCresponse: false,
      editableCells: new Set(), // Tracciamento celle editabili
      headers: [
        "Cod. Tributo", // Index 0
        "Descrizione Cod. Conto - TeamSystem", // Index 1
        "Cod. Conto DARE - TeamSystem", // Index 2
        "Cod. Conto AVERE - TeamSystem", // Index 3
        "Descrizione Cod. Conto - Datev Aziende", // Index 4
        "Cod. Conto DARE - Datev Aziende", // Index 5
        "Cod. Conto AVERE - Datev Aziende", // Index 6
        "Descrizione Cod. Conto - Datev Lib. Prof.", // Index 7
        "Cod. Conto DARE - Datev Lib. Prof.", // Index 8
        "Cod. Conto AVERE - Datev Lib. Prof.", // Index 9
        "Descrizione Cod. Conto - Zucchetti", // Index 10
        "Cod. Conto DARE - Zucchetti", // Index 11
        "Cod. Conto AVERE - Zucchetti", // Index 12
        "Descrizione Cod. Conto - SEAC", // Index 13
        "Cod. Conto DARE - SEAC", // Index 14
        "Cod. Conto AVERE - SEAC", // Index 15
        "Descrizione Cod. Conto - Sistemi", // Index 16
        "Cod. Conto DARE - Sistemi", // Index 17
        "Cod. Conto AVERE - Sistemi", // Index 18
      ],
      headers9001: [
        "Denominazione Cliente", // Index 0
        "Codice Fiscale", // Index 1
        "Data Pagamento", // Index 2
        "Codice Tributo", // Index 3
        "Saldo DARE", // Index 4
        "Saldo AVERE", // Index 5
        "Descrizione Cod. Conto", // Index 6
        "Cod. Conto DARE", // Index 7
        "Cod. Conto AVERE", // Index 8
      ],
      // Per tabella PCT
      selectedSoftware: "ALL", // default
      tableSoftwareOptions: [
        { label: "Tutti", value: "ALL" },
        { label: "TEAMSYSTEM", value: "TEAMSYSTEM" },
        { label: "DATEV", value: "DATEV" },
        { label: "ZUCCHETTI", value: "ZUCCHETTI" },
        { label: "SEAC", value: "SEAC" },
        { label: "SISTEMI", value: "SISTEMI" },
      ],
      softwareOptions: [
        { label: "TEAMSYSTEM", value: "TEAMSYSTEM" },
        { label: "DATEV", value: "DATEV" },
        { label: "ZUCCHETTI", value: "ZUCCHETTI" },
        { label: "SEAC", value: "SEAC" },
        { label: "SISTEMI", value: "SISTEMI" },
      ],
      // Seconda tabella (add row)
      newRow: new Array(13).fill(""),
      provisionalRows: [],
      selectedSoftwareAddRow: "TEAMSYSTEM",
      selectedAddRowSoftwares: ["TEAMSYSTEM"],
      output_PC: "",
      input_PC: "",
      showAddBilancino: false,
      showAddPiano: false,
      showResult: false,
      showDelayedMessage: false,
      delayedMessageUpdated: false,
      delayTimer: null,
      updateTimer: null,
      hasUnsavedChanges: false,
      noChangesMessage: false,
      errors: {},
      successModalVisibile: false,
      successModalMessaggio: "",
      erroreModalVisibile: false,
      erroreModalMessaggio: "",
      showScanResetConfirmModal: false,
      isResettingScan: false,
      pendingScanResetMode: "full",
      activeScanRequestId: 0,
      showErrorModal: false,
      errorsData: [],
      showSaveModal: false,
      nextRoute: null,
      pendingNavigationAfterSuccess: false,
      confirmModalVisibile: false,
      confirmModalTitle: "Elimina Piano Codici Tributo",
      confirmModalMessaggio: "",
      confirmModalShowArchiveOptions: false,
      confirmModalConfirmLabel: "Elimina",
      confirmModalCancelLabel: "Annulla",
      confirmModalConfirmClass: "btn-danger",
      confirmModalConfirmIcon: "",
      delete9001AlongWithPct: false,
      deleteSaldoFAlongWithPct: false,
      confirmModalDeleteOptions: [],
      deletePctTargets: {},
      confirmModalCallback: null,
      restoringFile: false,
      isEditMode: false,
      isEditModePCT: false,

      jsonData9001: [],
      lastSavedData9001: [],
      hasUnsavedChanges9001: false,
      isEditing9001: false,
      modifiedCells9001: {},
      deletedRows9001: {},
      pendingDeletedRows9001Count: 0,
      activeDelete9001: {},
      hoveredRow9001: null,
      uploading9001: false,
      errors9001: {},
      tableKey9001: 0,
      modalVisible9001: false,
      archive9001Missing: false,
      isLeavingDueTo9001Changes: false,

      modalVisibleSaldoF: false,
      jsonDataSaldoF: [],
      lastSavedDataSaldoF: [],
      archiveSaldoFMissing: false,
      hasUnsavedChangesSaldoF: false,
      isEditingSaldoF: false,
      modifiedCellsSaldoF: {},
      deletedRowsSaldoF: {},
      pendingDeletedRowsSaldoFCount: 0,
      activeDeleteSaldoF: {},
      hoveredRowSaldoF: null,
      uploadingSaldoF: false,
      errorsSaldoF: {},
      tableKeySaldoF: 0,
      isLeavingDueToSaldoFChanges: false,

      vettoreCodTributoPCT: [],
      isTable9001Expanded: false,
      originalPCT: [],
      currentSubPhase: "A",
      isTableExpanded: false,
      vettorePCTVisible: false,
      isTableTributoPCTExpanded: false,
      vettoreCodTributo9001: [],
      vettoreCodTributo9001_PCT: [],
      vettore9001PCTVisible: false,
      isTable9001PCTExpanded: false,
      isEditMode9001PCT: false,
      shareInvitoIdFromEvent: null,
    };
  },
  mounted() {
    this.fetchClientPctPlans().finally(() => {
      this.fetchCurrentPctFile();
    });
    this.fetchUserCausali();
    this.fetchAccountingDefaults();
    if (!this.isGuestMode) {
      this.fetchInviti();
    }
    this.loadUserPreferredSoftware();
    this.$root.$on("open-share-modal", this.handleOpenShareModalEvent);
    document.addEventListener("click", this.handleClickOutside);
    window.addEventListener("resize", this.updateAllSoftwareScrollState);
  },
  beforeDestroy() {
    this.$root.$off("open-share-modal", this.handleOpenShareModalEvent);
    document.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("resize", this.updateAllSoftwareScrollState);
  },
  beforeRouteLeave(to, from, next) {
    // Caso principale (già funzionante)
    if (this.hasUnsavedChanges) {
      this.isLeavingDueTo9001Changes = false;
      this.isLeavingDueToSaldoFChanges = false;
      this.showSaveModal = true;
      this.nextRoute = next;
      return;
    }

    // Caso 9001
    if (this.hasUnsavedChanges9001) {
      this.isLeavingDueTo9001Changes = true;
      this.isLeavingDueToSaldoFChanges = false;
      this.showSaveModal = true;
      this.nextRoute = next;
      return;
    }

    if (this.hasUnsavedChangesSaldoF) {
      this.isLeavingDueTo9001Changes = false;
      this.isLeavingDueToSaldoFChanges = true;
      this.showSaveModal = true;
      this.nextRoute = next;
      return;
    }

    next();
  },
  computed: {
    isGuestMode() {
      return isGuestMode();
    },
    user() {
      const data = localStorage.getItem("user");
      return data ? JSON.parse(data) : null;
    },
    addRowBaseFields() {
      return [
        {
          index: 0,
          label: this.jsonData[0]?.[0] || "Cod. Tributo",
          placeholder: this.getPlaceholder(0),
          title: this.getErrorMessage(0),
          required: true,
          format: true,
        },
      ];
    },
    addRowSoftwareFields() {
      const makeField = (index, extra = {}) => ({
        index,
        label: this.getHeaderLabel(index),
        placeholder: this.getPlaceholder(index),
        title: this.getErrorMessage(index),
        format: true,
        ...extra,
      });

      const makeDescriptionField = (index) =>
        makeField(index, {
          format: false,
          placeholder: this.getPlaceholder(index),
        });

      return {
        TEAMSYSTEM: [makeDescriptionField(1), makeField(2), makeField(3)],
        DATEV: [
          makeDescriptionField(4),
          makeField(5),
          makeField(6),
          makeField(8),
          makeField(9),
        ],
        ZUCCHETTI: [makeDescriptionField(10), makeField(11), makeField(12)],
        SEAC: [makeDescriptionField(13), makeField(14), makeField(15)],
        SISTEMI: [makeDescriptionField(16), makeField(17), makeField(18)],
      };
    },
    hiddenSoftwareBlocks9001() {
      if (this.jsonData9001.length <= 1) {
        return new Set();
      }

      const headers = this.jsonData9001[0];
      const dataRows = this.jsonData9001.slice(1);

      const hidden = new Set(); // conterrà gli indici dei software da nascondere (0 = TeamSystem, 1 = Datev Aziende, ecc.)

      // I blocchi partono dalla colonna 4 (indice 4 = prima Descrizione dopo le colonne fisse)
      // Colonne fisse: 0,1,2,3
      for (let i = 0; i < 7; i++) {
        // 7 software: TeamSystem, Datev Aziende, Datev Lib.Prof, Zucchetti, Seac, Sistemi + eventuale futuro
        const descColIndex = 4 + i * 3; // 4, 7, 10, 13, 16, 19, 22

        if (descColIndex >= headers.length) break;

        // Controlla se la colonna Descrizione è completamente vuota
        const isDescriptionEmpty = dataRows.every((row) => {
          const val = row[descColIndex];
          return !val || String(val).trim() === "";
        });

        if (isDescriptionEmpty) {
          hidden.add(i);
        }
      }

      return hidden;
    },
    isCellModified9001() {
      return (row, col) => !!this.modifiedCells9001[`${row}-${col}`];
    },
    isCellModifiedSaldoF() {
      return (row, col) => !!this.modifiedCellsSaldoF[`${row}-${col}`];
    },
    // Per mettere classi sulla table (opzionale ma utile)
    tableExtraClasses9001() {
      const cls = [];
      this.hiddenSoftwareBlocks9001.forEach((blockIdx) => {
        cls.push(`hide-block-${blockIdx}`);
      });
      return cls.join(" ");
    },
    validColumns() {
      const excludedColumnsMap = {
        TEAMSYSTEM: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18], // Per TS, escludi Datev e Zucchetti
        DATEV: [1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18], // Per D, escludi Teamsystem e Zucchetti
        ZUCCHETTI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 13, 14, 15, 16, 17, 18], // Per Z, escludi Teamsystem e Datev
        SEAC: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 16, 17, 18],
        SISTEMI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      };
      const excluded = this.output_PC ? excludedColumnsMap[this.output_PC] : [];
      // Trova l'indice reale della colonna "Descrizione Cod. Conto" per il tipo selezionato
      let nomeContoIndex = null;

      switch (this.output_PC) {
        case "TEAMSYSTEM":
          nomeContoIndex = 1; // "Descrizione Cod. Conto - TeamSystem"
          break;
        case "DATEV":
          nomeContoIndex = 4; // "Descrizione Cod Conto - Datev"
          break;
        case "ZUCCHETTI":
          nomeContoIndex = 10; // "Descrizione Cod. Conto - Zucchetti"
          break;
        case "SEAC":
          nomeContoIndex = 13; // "Descrizione Cod. Conto - SEAC"
          break;
        case "SISTEMI":
          nomeContoIndex = 16; // "Descrizione Cod. Conto - Sistemi"
          break;
      }

      if (
        nomeContoIndex !== null &&
        this.vettoreCodTributo.every(
          (row) => !row[nomeContoIndex] || row[nomeContoIndex] === "None"
        )
      ) {
        console.log(nomeContoIndex);
        // excluded.push(nomeContoIndex);
      }
      // Mostra tutte le colonne (0...headers.length-1) che non sono escluse
      return this.headers
        .map((_, index) => index)
        .filter((index) => !excluded.includes(index));
    },
    validColumnsPCT() {
      const excludedColumnsMap = {
        TEAMSYSTEM: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        DATEV: [1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        ZUCCHETTI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 13, 14, 15, 16, 17, 18],
        SEAC: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 16, 17, 18],
        SISTEMI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      };
      const excluded = this.output_PC ? excludedColumnsMap[this.output_PC] : [];
      //Per DARE e AVERE None
      if (this.numeroClienti > 1) {
        const maxColIndex = this.headers.length - 1;
        excluded.push(maxColIndex, maxColIndex - 1); // Ultima e penultima
      }
      // Mostra tutte le colonne (0...headers.length-1) che non sono escluse
      return this.headers
        .map((_, index) => index)
        .filter((index) => !excluded.includes(index));
    },
    visibleColumnsaddf24() {
      const excludedColumnsMap = {
        TEAMSYSTEM: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        DATEV: [1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        ZUCCHETTI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 13, 14, 15, 16, 17, 18],
        SEAC: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 16, 17, 18],
        SISTEMI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      };

      const excluded = this.output_PC
        ? [...excludedColumnsMap[this.output_PC]]
        : [];

      // Trova l'indice corretto della colonna "Descrizione Cod. Conto" per il gestionale corrente
      let nomeContoIndex = null;

      switch (this.output_PC) {
        case "TEAMSYSTEM":
          nomeContoIndex = 1; // Descrizione Cod. Conto - TeamSystem
          break;
        case "DATEV":
          nomeContoIndex = 4; // Descrizione Cod. Conto - Datev
          break;
        case "ZUCCHETTI":
          nomeContoIndex = 10; // Descrizione Cod. Conto - Zucchetti
          break;
        case "SEAC":
          nomeContoIndex = 13; // Descrizione Cod. Conto - SEAC
          break;
        case "SISTEMI":
          nomeContoIndex = 16; // Descrizione Cod. Conto - Sistemi
          break;
      }

      if (
        nomeContoIndex !== null &&
        this.vettoreCodTributo.every(
          (row) =>
            !row[nomeContoIndex] ||
            row[nomeContoIndex].toString().trim() === "None"
        )
      ) {
        console.log(nomeContoIndex);
        // excluded.push(nomeContoIndex);
      }

      return this.headers
        .map((_, index) => index)
        .filter((index) => !excluded.includes(index));
    },
    availablePhases() {
      const phases = ["A"];
      if (this.hasPhaseB) phases.push("B");
      if (this.hasPhaseC) phases.push("C");
      return phases;
    },
    hasPhaseB() {
      return (
        (Array.isArray(this.vettoreCodTributo9001) &&
          this.vettoreCodTributo9001.length > 0) ||
        (Array.isArray(this.vettoreCodTributo9001_PCT) &&
          this.vettoreCodTributo9001_PCT.length > 0)
      );
    },
    isFirstPhase() {
      return this.currentSubPhase === "A";
    },
    isLastPhase() {
      const phases = this.availablePhases;
      return this.currentSubPhase === phases[phases.length - 1];
    },
    visibleColumns() {
      const mapping = {
        ALL: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        TEAMSYSTEM: [1, 2, 3], // descrizione, dare, avere
        DATEV: [4, 5, 6, 7, 8, 9],
        ZUCCHETTI: [10, 11, 12],
        SEAC: [13, 14, 15],
        SISTEMI: [16, 17, 18],
      };
      return mapping[this.selectedSoftware];
    },
    isAllSoftwareView() {
      return this.selectedSoftware === "ALL";
    },
    showAllSoftwareScrollControls() {
      return (
        this.isAllSoftwareView &&
        ((this.isPctMainView &&
          Array.isArray(this.jsonData) &&
          this.jsonData.length > 0) ||
          (this.isPctSaldoFView &&
            !this.archiveSaldoFMissing &&
            this.jsonDataSaldoF.length > 0))
      );
    },
    hasDataRows() {
      return Array.isArray(this.jsonData) && this.jsonData.length > 1;
    },
    pctFileOptions() {
      return [
        {
          value: "pct",
          label: "Piano Codici Tributo",
          icon: "fa-solid fa-table-list",
        },
        {
          value: "archive_9001",
          label: "Archivio 9001",
          icon: "fa-solid fa-book",
        },
        {
          value: "archive_saldo",
          label: "Coordinate Bancarie",
          icon: "fa-solid fa-building",
        },
      ];
    },
    pctLibraryFileOptions() {
      return [
        {
          key: "pct",
          fileKey: "pct",
          viewKey: "main",
          label: "Piano Codici Tributo",
          meta: "Principale",
          icon: "fa-solid fa-table-list",
          status: this.getPctLibraryFileStatus("pct"),
          disabled: !this.mainPctLibraryState.has_pct,
        },
        {
          key: "archive_9001",
          fileKey: "archive_9001",
          viewKey: "main",
          label: "Archivio 9001",
          meta: "Archivio dei codici tributo 9001",
          icon: "fa-solid fa-book",
          status: this.getPctLibraryFileStatus("archive_9001"),
        },
        {
          key: "archive_saldo",
          fileKey: "archive_saldo",
          viewKey: "main",
          label: "Coordinate Bancarie",
          meta: "Coordinate bancarie per pagamenti F24",
          icon: "fa-solid fa-building",
          status: this.getPctLibraryFileStatus("archive_saldo"),
        },
      ];
    },
    pctLibraryClientGroups() {
      return this.clientPctPlans
        .filter((client) => client?.has_pct)
        .map((client) => ({
          key: client.key,
          label: client.label,
          options: [
            {
              key: `pct:client:${client.key}`,
              fileKey: "pct",
              viewKey: `client:${client.key}`,
              label: client.label,
              meta: "Piano Codici Tributo personalizzato",
              shortLabel: "Piano Codici Tributo",
              icon: "fa-solid fa-table-list",
              status: this.getPctLibraryFileStatus("pct", client),
              disabled: !client?.has_pct,
            },
          ],
        }))
        .sort((a, b) => a.label.localeCompare(b.label, "it"));
    },
    pctShareableFiles() {
      const files = [];

      if (this.mainPctLibraryState.has_pct) {
        files.push({
          key: "main",
          label: "Piano Codici Tributo",
          shortLabel: "Piano Codici Tributo",
          meta: "Principale",
          icon: "fa-solid fa-table-list",
          section: "principali",
          status: this.getPctLibraryFileStatus("pct"),
        });
      }

      files.push(
        {
          key: "archivio_9001",
          label: "Archivio Codici Tributo 9001",
          shortLabel: "Archivio 9001",
          meta: "Principale",
          icon: "fa-solid fa-book",
          section: "principali",
          status: this.getPctLibraryFileStatus("archive_9001"),
        },
        {
          key: "archivio_saldo_finale",
          label: "Archivio Coordinate Bancarie",
          shortLabel: "Coordinate Bancarie",
          meta: "Principale",
          icon: "fa-solid fa-building",
          section: "principali",
          status: this.getPctLibraryFileStatus("archive_saldo"),
        }
      );

      this.clientPctPlans.forEach((client) => {
        if (!client?.has_pct) return;
        files.push({
          key: `client_pct:${client.key}`,
          label: `Piano Codici Tributo - ${client.label}`,
          shortLabel: "Piano Codici Tributo",
          meta: "Personalizzato",
          icon: "fa-solid fa-table-list",
          section: "personalizzati",
          clientKey: client.key,
          clientLabel: client.label,
          status: this.getPctLibraryFileStatus("pct", client),
        });
      });

      return files;
    },
    activePctFileLabel() {
      return (
        this.pctFileOptions.find(
          (option) => option.value === this.selectedPctFileKey
        )?.label || "File della libreria"
      );
    },
    activePctFileIcon() {
      return (
        this.pctFileOptions.find(
          (option) => option.value === this.selectedPctFileKey
        )?.icon || "fa-solid fa-table-list"
      );
    },
    activePctScopeLabel() {
      if (this.currentPctIsClient) {
        return this.selectedClientPctLabel || "Cliente";
      }
      return this.isPctMainView ? "Principale" : "Archivio";
    },
    activePctSoftwareLabel() {
      return (
        this.tableSoftwareOptions.find(
          (option) => option.value === this.selectedSoftware
        )?.label || this.selectedSoftware
      );
    },
    isPctMainView() {
      return this.selectedPctFileKey === "pct";
    },
    currentPctIsClient() {
      return String(this.selectedPctViewKey || "").startsWith("client:");
    },
    selectedClientPctKey() {
      return this.currentPctIsClient
        ? String(this.selectedPctViewKey).slice("client:".length)
        : "";
    },
    selectedClientPctLabel() {
      const client = this.clientPctPlans.find(
        (item) => item.key === this.selectedClientPctKey
      );
      return client?.label || this.selectedClientPctKey || "";
    },
    uploadClientOptions() {
      return (this.uploadClienti || [])
        .map((cliente) => {
          const key = this.normalizeUploadClientKey(cliente.codice_fiscale);
          return {
            key,
            label: cliente.titolo_cliente,
            codice_fiscale: cliente.codice_fiscale || "",
            codice_ditta: cliente.codice_ditta || "",
          };
        })
        .filter((cliente) => cliente.key && cliente.label)
        .sort((a, b) => a.label.localeCompare(b.label, "it"));
    },
    isPct9001View() {
      return this.selectedPctFileKey === "archive_9001";
    },
    isPctSaldoFView() {
      return this.selectedPctFileKey === "archive_saldo";
    },
    isPctArchiveView() {
      return this.isPct9001View || this.isPctSaldoFView;
    },
    pctMainTableIsEmpty() {
      return (
        Array.isArray(this.jsonData) &&
        this.jsonData.length > 0 &&
        !this.hasMeaningfulLibraryRows(this.jsonData)
      );
    },
    archive9001TableIsEmpty() {
      return (
        !this.archive9001Missing &&
        Array.isArray(this.jsonData9001) &&
        this.jsonData9001.length > 0 &&
        !this.hasMeaningfulLibraryRows(this.jsonData9001)
      );
    },
    archiveSaldoFTableIsEmpty() {
      return (
        !this.archiveSaldoFMissing &&
        Array.isArray(this.jsonDataSaldoF) &&
        this.jsonDataSaldoF.length > 0 &&
        !this.hasMeaningfulLibraryRows(this.jsonDataSaldoF)
      );
    },
    currentPctFileHasRows() {
      if (this.isPct9001View) return Array.isArray(this.jsonData9001);
      if (this.isPctSaldoFView) return Array.isArray(this.jsonDataSaldoF);
      return Array.isArray(this.jsonData) && this.jsonData.length > 0;
    },
    currentPctFileHasDataRows() {
      if (this.isPct9001View) return this.jsonData9001.length > 1;
      if (this.isPctSaldoFView) return this.jsonDataSaldoF.length > 1;
      return this.hasDataRows;
    },
    currentPctHasVisibleDataRows() {
      if (this.isPct9001View) return this.filtered9001DisplayRows.length > 1;
      if (this.isPctSaldoFView) {
        return this.filteredSaldoFDisplayRows.length > 1;
      }
      return this.filteredDisplayRows.length > 1;
    },
    currentPctDeleteHasDataRows() {
      if (this.currentPctIsClient) {
        const client = this.clientPctPlans.find(
          (item) => item?.key === this.selectedClientPctKey
        );
        return Boolean(client?.has_pct);
      }
      return (
        this.hasDataRows ||
        (Array.isArray(this.jsonData9001) && this.jsonData9001.length > 1) ||
        (Array.isArray(this.jsonDataSaldoF) && this.jsonDataSaldoF.length > 1)
      );
    },
    currentPctFileHasUnsavedChanges() {
      if (this.isPct9001View) return this.hasUnsavedChanges9001;
      if (this.isPctSaldoFView) return this.hasUnsavedChangesSaldoF;
      return this.hasUnsavedChanges;
    },
    currentPctFileCanSaveOrCancel() {
      if (this.isPct9001View) {
        return (
          !this.archive9001Missing &&
          (this.currentPctFileHasDataRows ||
            this.hasUnsavedChanges9001 ||
            this.pendingDeletedRows9001Count > 0)
        );
      }
      if (this.isPctSaldoFView) {
        return (
          !this.archiveSaldoFMissing &&
          (this.currentPctFileHasDataRows ||
            this.hasUnsavedChangesSaldoF ||
            this.pendingDeletedRowsSaldoFCount > 0)
        );
      }
      return (
        this.currentPctFileHasRows &&
        (this.currentPctFileHasDataRows ||
          this.hasUnsavedChanges ||
          this.pendingDeletedRowCount > 0)
      );
    },
    currentPctEditModeActive() {
      if (this.isPct9001View) return this.isEditing9001;
      if (this.isPctSaldoFView) return this.isEditingSaldoF;
      return this.isEditing;
    },
    currentPctDeleteButtonLabel() {
      return this.currentPctIsClient ? "Elimina file cliente" : "Elimina file";
    },
    currentPctDeleteButtonTitle() {
      return this.currentPctIsClient
        ? "Elimina il Piano Codici Tributo del cliente"
        : "Scegli quali file dei codici tributo eliminare";
    },
    hasAnyPctLibraryFiles() {
      return (
        this.mainPctLibraryState.has_pct ||
        this.clientPctPlans.some((client) => client?.has_pct) ||
        this.currentPctFileHasRows
      );
    },
    hasActivePctLibrarySelection() {
      return this.isPctLibraryEntryAvailable(
        this.selectedPctFileKey,
        this.selectedPctViewKey
      );
    },
    confirmModalDeleteHasSelection() {
      return this.confirmModalDeleteOptions.some(
        (option) => this.deletePctTargets?.[option.key]
      );
    },
    currentPctTemplateKey() {
      if (this.isPct9001View) return "archivio_9001";
      if (this.isPctSaldoFView) return "coordinate_bancarie";
      return "pct_f24";
    },
    currentPctTemplateFilename() {
      if (this.isPct9001View) {
        return "MODELLO - Modelli F24 - Archivio Codici Tributo 9001.xlsx";
      }
      if (this.isPctSaldoFView) {
        return "MODELLO - Modelli F24 - Archivio Coordinate Bancarie.xlsx";
      }
      return "MODELLO - Modelli F24 - Piano Codici Tributo.xlsx";
    },
    currentPctUploadTitle() {
      if (this.currentPctIsClient) return "Carica Piano Codici Tributo cliente";
      if (this.isPct9001View) return "Carica Archivio Codici Tributo 9001";
      if (this.isPctSaldoFView) return "Carica Archivio Coordinate Bancarie";
      return "Carica Piano Codici Tributo";
    },
    currentPctUploadInputId() {
      if (this.isPct9001View) return "pct9001UploadFileInput";
      if (this.isPctSaldoFView) return "pctSaldoUploadFileInput";
      return "pctFileInput";
    },
    currentPctUploadWarningText() {
      if (this.currentPctIsClient) {
        return "Assicurati di inserire un Piano Codici Tributo del formato corretto. Il piano personalizzato del cliente selezionato verra sostituito con il file caricato.";
      }
      if (this.isPct9001View) {
        return "Assicurati di inserire un Archivio Codici Tributo 9001 del formato corretto. L'archivio attuale verra sostituito con il file caricato.";
      }
      if (this.isPctSaldoFView) {
        return "Assicurati di inserire un Archivio Coordinate Bancarie del formato corretto. L'archivio attuale verra sostituito con il file caricato.";
      }
      return "Assicurati di inserire un Piano Codici Tributo del formato corretto. Il Piano attuale verra sostituito con il Piano Codici Tributo caricato.";
    },
    currentAddRowTitle() {
      if (this.isPct9001View) {
        return "Aggiungi riga nell'Archivio Codici Tributo 9001";
      }
      if (this.isPctSaldoFView) {
        return "Aggiungi riga nell'Archivio Coordinate Bancarie";
      }
      return "Aggiungi riga nel Piano Codici Tributo";
    },
    default9001Headers() {
      return [...ARCHIVE_9001_HEADERS];
    },
    currentAddRowHeaders() {
      if (this.isPct9001View) {
        const headers = this.jsonData9001?.[0] || [];
        return headers.length >= 9 ? headers : this.default9001Headers;
      }
      if (this.isPctSaldoFView) {
        return this.jsonDataSaldoF?.[0] || [];
      }
      return this.jsonData?.[0] || [];
    },
    currentAddRowBaseFields() {
      if (this.isPctMainView) {
        return this.addRowBaseFields;
      }

      return this.currentAddRowHeaders
        .map((header, index) => ({
          index,
          label: header || `Colonna ${index + 1}`,
          placeholder: this.getArchiveAddRowPlaceholder(index),
          title: this.getArchiveAddRowTitle(index),
          required: this.isArchiveAddRowRequired(index),
          format: this.isArchiveAddRowFormatted(index),
        }))
        .filter((field) => this.isPctArchiveColumnVisible(field.index));
    },
    currentAddRowSoftwareOptions() {
      return this.isPctMainView ? this.softwareOptions : [];
    },
    currentAddRowSoftwareFields() {
      return this.isPctMainView ? this.addRowSoftwareFields : {};
    },
    filteredDisplayRows() {
      if (!Array.isArray(this.jsonData) || this.jsonData.length === 0) {
        return [];
      }

      const headerRow = {
        row: this.jsonData[0],
        originalIndex: 0,
      };

      const term = this.tableSearchTerm.trim().toLowerCase();
      if (!term) {
        return [
          headerRow,
          ...this.jsonData.slice(1).map((row, index) => ({
            row,
            originalIndex: index + 1,
          })),
        ];
      }

      const searchableColumns = [0, ...(this.visibleColumns || [])];
      const filteredRows = this.jsonData
        .slice(1)
        .map((row, index) => ({
          row,
          originalIndex: index + 1,
        }))
        .filter(({ row }) =>
          searchableColumns.some((colIndex) =>
            String(row[colIndex] ?? "")
              .toLowerCase()
              .includes(term)
          )
        );

      return [headerRow, ...filteredRows];
    },
    filtered9001DisplayRows() {
      return this.filterArchiveRows(this.jsonData9001);
    },
    filteredSaldoFDisplayRows() {
      return this.filterArchiveRows(this.jsonDataSaldoF);
    },
    filteredHeaders() {
      return this.validColumns.map((index) => this.headers[index]);
    },
    filteredHeadersPCT() {
      return this.headers.filter((_, index) =>
        this.validColumnsPCT.includes(index)
      );
    },
    filteredHeaders9001() {
      return this.headers9001;
    },
    validColumns9001() {
      return [0, 1, 2, 3, 4, 5, 6, 7, 8]; // Tutte le colonne, senza filtro ad hoc per ora (puoi adattare se necessario)
    },
    invitiInAttesaCount() {
      return this.invitiRicevuti.filter(
        (i) =>
          i.stato === "in attesa" && i.tipo_piano === "Piano codici tributo"
      ).length;
    },
    visibleHeaderIndices() {
      const alwaysVisible = [0];
      const map = {
        TEAMSYSTEM: [1, 2, 3],
        DATEV: [4, 5, 6, 8, 9],
        ZUCCHETTI: [10, 11, 12],
        SEAC: [13, 14, 15],
        SISTEMI: [16, 17, 18],
      };
      const selected = this.selectedSoftwareAddRow;
      const softwareCols = map[selected] || [];

      return [...alwaysVisible, ...softwareCols];
    },
    shouldOpenShareModal() {
      return this.$route.query.openShare === "1";
    },
    highlightedShareInvitoId() {
      return this.shareInvitoIdFromEvent || this.$route.query.invito || null;
    },
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        this.determineCurrentPlan();
      },
    },
    isAllSoftwareView() {
      this.$nextTick(this.updateAllSoftwareScrollState);
    },
    isPctSaldoFView() {
      this.$nextTick(this.updateAllSoftwareScrollState);
    },
    filteredDisplayRows() {
      this.$nextTick(this.updateAllSoftwareScrollState);
    },
    filteredSaldoFDisplayRows() {
      this.$nextTick(this.updateAllSoftwareScrollState);
    },
    showAddBilancino(val) {
      if (val && this.F24File) {
        this.$nextTick(() => {
          const dt = new DataTransfer();
          dt.items.add(this.F24File);
          this.$refs.bilancinoInput.files = dt.files;
        });
      }
    },
  },
  methods: {
    formatItalianIban,
    ha,
    normalizeCodContoValue(value) {
      return String(value ?? "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },
    isCodContoDefault(value) {
      return (
        this.codContoDefault &&
        this.normalizeCodContoValue(value) ===
          this.normalizeCodContoValue(this.codContoDefault)
      );
    },
    applyCodContoDefaultFromResponse(data = {}) {
      if (data.codContoDefault) {
        this.codContoDefault = String(data.codContoDefault);
      }
    },
    fetchAccountingDefaults() {
      axios
        .get(`${API_BASE_URL}/accounting_defaults`)
        .then((response) => {
          this.applyCodContoDefaultFromResponse(response.data || {});
        })
        .catch((error) => {
          console.warn("Impossibile caricare il CodContoDefault:", error);
        });
    },
    getCodContoDefaultErrorMessage() {
      return `Il codice conto ${this.codContoDefault} e riservato e non puo essere salvato.`;
    },
    hasMeaningfulLibraryRows(rows) {
      if (!Array.isArray(rows) || rows.length <= 1) {
        return false;
      }

      return rows.slice(1).some((row) => {
        if (Array.isArray(row)) {
          return row.some((cell) => String(cell ?? "").trim() !== "");
        }
        return String(row ?? "").trim() !== "";
      });
    },
    getPctLibraryFileStatus(fileKey, client = null) {
      if (client) {
        return client.pct_empty ? { kind: "empty", label: "Vuoto" } : null;
      }

      if (fileKey === "archive_9001") {
        if (this.archive9001Missing) {
          return { kind: "missing", label: "Mancante" };
        }
        if (!Array.isArray(this.jsonData9001) || !this.jsonData9001.length) {
          return null;
        }
        return this.hasMeaningfulLibraryRows(this.jsonData9001)
          ? null
          : { kind: "empty", label: "Vuoto" };
      }

      if (fileKey === "archive_saldo") {
        if (this.archiveSaldoFMissing) {
          return { kind: "missing", label: "Mancante" };
        }
        if (
          !Array.isArray(this.jsonDataSaldoF) ||
          !this.jsonDataSaldoF.length
        ) {
          return null;
        }
        return this.hasMeaningfulLibraryRows(this.jsonDataSaldoF)
          ? null
          : { kind: "empty", label: "Vuoto" };
      }

      if (this.currentPctIsClient) {
        return this.hasMeaningfulLibraryRows(this.jsonData)
          ? null
          : { kind: "empty", label: "Vuoto" };
      }
      if (!this.mainPctLibraryState.has_pct) {
        return { kind: "missing", label: "Mancante" };
      }
      return this.mainPctLibraryState.pct_empty
        ? { kind: "empty", label: "Vuoto" }
        : null;
    },
    normalizeMainPctLibraryState(raw = {}) {
      return {
        has_pct: Boolean(raw?.has_pct),
        pct_empty: Boolean(raw?.pct_empty),
      };
    },
    findClientPctPlan(clientKey) {
      return this.clientPctPlans.find((client) => client?.key === clientKey);
    },
    isPctLibraryEntryAvailable(fileKey, viewKey = "main") {
      if (viewKey === "main") {
        if (fileKey === "pct") return this.mainPctLibraryState.has_pct;
        return ["archive_9001", "archive_saldo"].includes(fileKey);
      }

      if (!String(viewKey || "").startsWith("client:")) {
        return false;
      }
      if (fileKey !== "pct") {
        return false;
      }

      const clientKey = String(viewKey).slice("client:".length);
      return Boolean(this.findClientPctPlan(clientKey)?.has_pct);
    },
    buildAvailablePctLibraryEntries() {
      const entries = [];
      if (this.mainPctLibraryState.has_pct) {
        entries.push({ fileKey: "pct", viewKey: "main" });
      }
      this.clientPctPlans.forEach((client) => {
        if (client?.has_pct) {
          entries.push({ fileKey: "pct", viewKey: `client:${client.key}` });
        }
      });
      return entries;
    },
    pickAvailablePctLibraryEntry(preferredEntries = []) {
      const preferredEntry = preferredEntries.find((entry) =>
        this.isPctLibraryEntryAvailable(entry.fileKey, entry.viewKey)
      );
      if (preferredEntry) {
        return preferredEntry;
      }
      return this.buildAvailablePctLibraryEntries().find((entry) =>
        this.isPctLibraryEntryAvailable(entry.fileKey, entry.viewKey)
      );
    },
    applyPctLibrarySelection(entry) {
      this.selectedPctFileKey = entry.fileKey;
      this.selectedPctViewKey = entry.viewKey || "main";
      this.lastSelectedPctFileKey = this.selectedPctFileKey;
      this.lastSelectedPctViewKey = this.selectedPctViewKey;
      this.tableSearchTerm = "";
      this.showAddRow = false;
      this.showAddBilancino = false;
      this.showAddPiano = false;
      this.isEditing = false;
      this.isEditing9001 = false;
      this.isEditingSaldoF = false;
      this.pctLibraryMenuOpen = false;
    },
    fetchClientPctPlans(preferredEntries = []) {
      if (this.isGuestMode) {
        this.clientPctPlans = [];
        this.mainPctLibraryState = this.normalizeMainPctLibraryState();
        return Promise.resolve();
      }

      this.loadingClientPctPlans = true;
      return axios
        .get(`${API_BASE_URL}/client_pct/list`)
        .then((res) => {
          this.clientPctPlans = Array.isArray(res.data?.clients)
            ? res.data.clients
            : [];
          this.mainPctLibraryState = this.normalizeMainPctLibraryState(
            res.data?.main
          );

          if (
            !this.isPctLibraryEntryAvailable(
              this.selectedPctFileKey,
              this.selectedPctViewKey
            )
          ) {
            const nextEntry =
              this.pickAvailablePctLibraryEntry(preferredEntries);
            if (nextEntry) {
              this.applyPctLibrarySelection(nextEntry);
            }
          }
        })
        .catch((error) => {
          console.error("Errore nel caricamento dei PCT cliente:", error);
          this.clientPctPlans = [];
        })
        .finally(() => {
          this.loadingClientPctPlans = false;
        });
    },
    filterArchiveRows(rows) {
      if (!Array.isArray(rows) || rows.length === 0) {
        return [];
      }

      const headerRow = {
        row: rows[0],
        originalIndex: 0,
      };
      const term = this.tableSearchTerm.trim().toLowerCase();
      const searchableColumns = rows[0]
        .map((_, index) => index)
        .filter((index) => this.isPctArchiveColumnVisible(index, rows[0]));
      if (!term) {
        return [
          headerRow,
          ...rows.slice(1).map((row, index) => ({
            row,
            originalIndex: index + 1,
          })),
        ];
      }

      const filteredRows = rows
        .slice(1)
        .map((row, index) => ({
          row,
          originalIndex: index + 1,
        }))
        .filter(({ row }) =>
          searchableColumns.some((colIndex) =>
            String(row[colIndex] ?? "")
              .toLowerCase()
              .includes(term)
          )
        );

      return [headerRow, ...filteredRows];
    },
    isSaldoFEditableColumn(index) {
      const header = this.jsonDataSaldoF[0]?.[index] || "";
      return (
        ["Codice Fiscale", "Codice ABI", "Codice CAB", "IBAN"].includes(
          header
        ) || header.startsWith("Cod. Conto")
      );
    },
    isSaldoFIbanColumn(index) {
      return this.jsonDataSaldoF[0]?.[index] === "IBAN";
    },
    saldoFBankColumnClass(index) {
      const header = String(
        this.jsonDataSaldoF[0]?.[index] || ""
      ).toUpperCase();
      if (header === "CODICE ABI" || header === "CODICE CAB") {
        return "library-bank-code-column";
      }
      if (header === "IBAN") return "library-bank-iban-column";
      return "";
    },
    isPctArchiveColumnVisible(colIndex, headerRow = null) {
      return isArchiveColumnVisible(
        headerRow || this.currentAddRowHeaders || [],
        colIndex,
        this.isPctArchiveView ? this.selectedSoftware : "ALL"
      );
    },
    toggleCurrentPctEditMode() {
      if (this.isPct9001View) {
        this.toggleEditing9001();
        return;
      }
      if (this.isPctSaldoFView) {
        this.toggleEditingSaldoF();
        return;
      }
      this.isEditing = !this.isEditing;
    },
    saveCurrentPctFile(event) {
      if (this.isPct9001View) {
        this.saveChanges9001(event);
        return;
      }
      if (this.isPctSaldoFView) {
        this.saveChangesSaldoF(event);
        return;
      }
      this.saveChanges(event);
    },
    cancelCurrentPctChanges() {
      if (this.isPct9001View) {
        this.cancelChanges9001();
        return;
      }
      if (this.isPctSaldoFView) {
        this.cancelChangesSaldoF();
        return;
      }
      this.cancelChanges();
    },
    downloadCurrentPctFile() {
      if (this.isPct9001View) {
        this.downloadPDC9001();
        return;
      }
      if (this.isPctSaldoFView) {
        this.downloadSaldoF();
        return;
      }
      this.downloadPDC();
    },
    deleteCurrentPctFile(event) {
      this.openPctDeleteModal(event);
    },
    openCurrentPctUpload() {
      this.openUploadPianoModal();
    },
    togglePctLibraryMenu() {
      this.pctLibraryMenuOpen = !this.pctLibraryMenuOpen;
      if (this.pctLibraryMenuOpen) {
        this.archiveMenuOpen = false;
      }
    },
    isPctLibraryEntryActive(option) {
      return (
        option?.fileKey === this.selectedPctFileKey &&
        (option?.viewKey || "main") === this.selectedPctViewKey
      );
    },
    selectPctLibraryEntry(option) {
      if (option?.disabled) return;

      if (!option || this.isPctLibraryEntryActive(option)) {
        this.pctLibraryMenuOpen = false;
        return;
      }

      if (this.currentPctFileHasUnsavedChanges) {
        this.erroreModalMessaggio =
          "Salva o annulla le modifiche prima di cambiare file visualizzato.";
        this.erroreModalVisibile = true;
        this.pctLibraryMenuOpen = false;
        return;
      }

      this.selectedPctFileKey = option.fileKey;
      this.selectedPctViewKey = option.viewKey || "main";
      this.lastSelectedPctFileKey = option.fileKey;
      this.lastSelectedPctViewKey = this.selectedPctViewKey;
      this.tableSearchTerm = "";
      this.showAddRow = false;
      this.showAddBilancino = false;
      this.showAddPiano = false;
      this.isEditing = false;
      this.isEditing9001 = false;
      this.isEditingSaldoF = false;
      this.pctLibraryMenuOpen = false;
      this.fetchCurrentPctFile();
    },
    handlePctFileChange() {
      if (this.currentPctFileHasUnsavedChanges) {
        this.erroreModalMessaggio =
          "Salva o annulla le modifiche prima di cambiare file visualizzato.";
        this.erroreModalVisibile = true;
        this.selectedPctFileKey = this.lastSelectedPctFileKey;
        return;
      }

      this.tableSearchTerm = "";
      this.selectedPctViewKey = "main";
      this.lastSelectedPctFileKey = this.selectedPctFileKey;
      this.lastSelectedPctViewKey = "main";
      this.fetchCurrentPctFile();
    },
    fetchCurrentPctFile() {
      if (this.isPct9001View) {
        return this.fetch9001PDC(false);
      }
      if (this.isPctSaldoFView) {
        return this.fetchsaldofPDC(false);
      }
      return this.fetchFileFromBackend();
    },
    updateAllSoftwareScrollState() {
      const tableWrapper = this.$refs.tableWrapperRef;
      if (!this.showAllSoftwareScrollControls || !tableWrapper) {
        this.canScrollTableLeft = false;
        this.canScrollTableRight = false;
        this.tableScrollPercent = 0;
        return;
      }

      const maxScrollLeft = Math.max(
        0,
        tableWrapper.scrollWidth - tableWrapper.clientWidth
      );
      this.canScrollTableLeft = tableWrapper.scrollLeft > 2;
      this.canScrollTableRight =
        maxScrollLeft > 2 && tableWrapper.scrollLeft < maxScrollLeft - 2;
      this.tableScrollPercent = maxScrollLeft
        ? (tableWrapper.scrollLeft / maxScrollLeft) * 100
        : 0;
    },
    setAllSoftwareScrollFromSlider(event) {
      const tableWrapper = this.$refs.tableWrapperRef;
      if (!this.showAllSoftwareScrollControls || !tableWrapper) return;

      const maxScrollLeft = Math.max(
        0,
        tableWrapper.scrollWidth - tableWrapper.clientWidth
      );
      const percent = Number(event.target.value) || 0;
      tableWrapper.scrollLeft = (maxScrollLeft * percent) / 100;
      this.updateAllSoftwareScrollState();
    },
    scrollAllSoftwareTable(direction) {
      const tableWrapper = this.$refs.tableWrapperRef;
      if (!this.showAllSoftwareScrollControls || !tableWrapper) return;

      const scrollAmount = Math.max(tableWrapper.clientWidth * 0.72, 360);
      tableWrapper.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });

      window.setTimeout(this.updateAllSoftwareScrollState, 260);
    },
    async scaricaModello(tipo, fallbackFileName) {
      try {
        await downloadModello(tipo, fallbackFileName);
        this.successModalMessaggio = "Modello scaricato con successo!";
        this.successModalVisibile = true;
      } catch (err) {
        console.error("Errore download modello:", err);
        this.erroreModalMessaggio =
          err.response?.data?.error ||
          "Errore durante il download del modello.";
        this.erroreModalVisibile = true;
      }
    },
    isPiano,
    determineCurrentPlan() {
      if (isPiano(this.user, "premium")) {
        this.currentPlan = "Premium";
      } else if (isPiano(this.user, "plus")) {
        this.currentPlan = "Plus";
      } else {
        this.currentPlan = "Base";
      }
    },
    fetchInviti() {
      if (this.isGuestMode) {
        this.invitiRicevuti = [];
        this.invitiInviati = [];
        return;
      }

      axios
        .get(`${API_BASE_URL}/piano_condiviso/inviti`)
        .then((res) => {
          this.invitiRicevuti = res.data.ricevuti;
          this.invitiInviati = res.data.inviati;
        })
        .catch((err) => {
          console.error("Errore fetch inviti:", err);
          this.invitiRicevuti = [];
          this.invitiInviati = [];
        });
    },
    handleOpenShareModalEvent(payload = {}) {
      if (this.isGuestMode) {
        return;
      }

      if (payload.link && payload.link !== this.$route.path) {
        return;
      }

      this.shareInvitoIdFromEvent = payload.invitoId || null;
      this.$nextTick(() => {
        if (this.$refs.condivisionePiano) {
          this.$refs.condivisionePiano.openModal();
        }
      });
    },
    apriExcelViewer(rows) {
      this.PianoRows = rows;
      this.showPianoModal = true;
    },
    fetchUserCausali() {
      if (this.isGuestMode) {
        this.causaleModelliF24 = "";
        return Promise.resolve();
      }

      return axios
        .get(`${API_BASE_URL}/user_causali`)
        .then((res) => {
          this.causaleModelliF24 = res.data?.causale_modelli_f24 || "";
          this.causaleF24Draft = this.causaleModelliF24;
        })
        .catch((error) => {
          console.error("Errore nel caricamento della causale:", error);
        });
    },
    normalizeCausale(value) {
      return String(value || "")
        .trim()
        .toUpperCase();
    },
    handleCausaleF24Input() {
      this.causaleF24Draft = this.normalizeCausale(this.causaleF24Draft).slice(
        0,
        4
      );
      this.causaleF24Error = "";
    },
    startEditCausaleF24() {
      this.causaleF24Draft = this.causaleModelliF24;
      this.causaleF24Error = "";
      this.editingCausaleF24 = true;
    },
    cancelEditCausaleF24() {
      this.causaleF24Draft = this.causaleModelliF24;
      this.causaleF24Error = "";
      this.editingCausaleF24 = false;
    },
    saveCausaleF24() {
      const causale = this.normalizeCausale(this.causaleF24Draft);
      if (causale && !/^[A-Z0-9]{1,4}$/.test(causale)) {
        this.causaleF24Error =
          "La causale deve contenere da 1 a 4 caratteri alfanumerici.";
        return Promise.resolve();
      }

      this.savingCausaleF24 = true;
      return axios
        .post(`${API_BASE_URL}/user_causali`, {
          causale_modelli_f24: causale,
        })
        .then((res) => {
          this.causaleModelliF24 = res.data?.causale_modelli_f24 || "";
          this.causaleF24Draft = this.causaleModelliF24;
          this.editingCausaleF24 = false;
          this.causaleF24Error = "";
        })
        .catch((error) => {
          this.causaleF24Error =
            error.response?.data?.error ||
            "Errore durante il salvataggio della causale.";
        })
        .finally(() => {
          this.savingCausaleF24 = false;
        });
    },
    fetchFileFromBackend() {
      const isClientPct = this.currentPctIsClient;
      const requestConfig = {
        responseType: "arraybuffer",
      };
      if (isClientPct) {
        requestConfig.params = {
          client_key: this.selectedClientPctKey,
        };
      }

      return axios
        .get(
          `${API_BASE_URL}${
            isClientPct ? "/excel/client_pct" : "/get_piano_tributo"
          }`,
          requestConfig
        )
        .then((response) => {
          console.log(response);
          // Recupera la data di ultima modifica dall'header della risposta
          const lastModified = response.headers["x-last-modified"];
          this.lastModified = lastModified; // Salva la data in una variabile Vue se necessario

          const data = new Uint8Array(response.data); // Trasformiamo i dati in un array di byte
          const workbook = XLSX.read(data, { type: "array" }); // Leggiamo il file Excel
          const firstSheetName = workbook.SheetNames[0]; // Otteniamo il nome del primo foglio
          const worksheet = workbook.Sheets[firstSheetName];

          // Convertiamo i dati del foglio in formato JSON
          this.jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          // Assicura che tutte le righe abbiano la stessa lunghezza
          const maxColumns = this.jsonData[0].length;
          this.jsonData.forEach((row) => {
            while (row.length < maxColumns) {
              row.push(""); // Aggiunge celle vuote se una riga è più corta
            }
          });

          //**Rimuove solo l'ultima colonna se è completamente vuota**
          const lastColumnIndex = this.jsonData[0].length - 1;
          const isLastColumnEmpty = this.jsonData.every(
            (row) => row[lastColumnIndex] === ""
          );
          if (isLastColumnEmpty) {
            this.jsonData.forEach((row) => row.pop());
          }

          this.lastSavedData = JSON.parse(JSON.stringify(this.jsonData));
          this.pendingDeletedRowCount = 0;
          this.modifiedCells = {};
          this.errors = {};
          this.hasUnsavedChanges = false;
          this.newRow = new Array(this.jsonData[0].length).fill(""); // Assicura che newRow abbia lo stesso numero di celle
          this.tableKey += 1;
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            console.error(
              isClientPct
                ? "Piano Codici Tributo cliente non presente."
                : "Piano ancora non presente."
            );
            this.jsonData = [];
            this.lastSavedData = [];
            this.modifiedCells = {};
            this.errors = {};
            this.hasUnsavedChanges = false;
            this.tableKey += 1;
          } else {
            console.error("Errore nel caricamento del file Excel:", error);
          }
        })
        .finally(() => {
          this.isDataLoaded = true;
        });
    },
    fetch9001PDC(openModal = true) {
      return axios
        .get(`${API_BASE_URL}/excel/9001`, { responseType: "arraybuffer" })
        .then((response) => {
          const data = new Uint8Array(response.data);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          this.jsonData9001 = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          });

          // Padding colonne
          const maxCols = this.jsonData9001[0]?.length || 0;
          this.jsonData9001.forEach((row) => {
            while (row.length < maxCols) row.push("");
          });

          // Rimuovi ultima colonna se vuota
          const lastIdx = maxCols - 1;
          if (
            lastIdx >= 0 &&
            this.jsonData9001.every((r) => r[lastIdx] === "")
          ) {
            this.jsonData9001.forEach((r) => r.pop());
          }

          // Snapshot iniziale
          this.lastSavedData9001 = JSON.parse(
            JSON.stringify(this.jsonData9001)
          );

          // Reset stato
          this.archive9001Missing = false;
          this.hasUnsavedChanges9001 = false;
          this.isEditing9001 = false;
          this.modifiedCells9001 = {};
          this.pendingDeletedRows9001Count = 0;

          if (openModal) {
            this.modalVisible9001 = true;
          }
          this.isDataLoaded = true;
        })
        .catch((err) => {
          if (err.response?.status === 404) {
            console.warn("Archivio 9001 non trovato (404)");

            // Tabella vuota con solo header (adattalo ai nomi reali delle tue colonne!)
            this.jsonData9001 = [this.default9001Headers];

            this.lastSavedData9001 = JSON.parse(
              JSON.stringify(this.jsonData9001)
            );

            this.archive9001Missing = true;
            this.hasUnsavedChanges9001 = false;
            this.isEditing9001 = false;
            this.modifiedCells9001 = {};
            this.pendingDeletedRows9001Count = 0;

            // Apriamo comunque il modal → utente vede dashboard e può caricare
            if (openModal) {
              this.modalVisible9001 = true;
            }
            this.isDataLoaded = true;
          } else {
            console.error("Errore caricamento archivio 9001:", err);
            // opzionale: alert o toast
          }
        });
    },
    replaceFile9001() {
      const fileInput =
        this.$refs.fileInput9001Inline || this.$refs.fileInput9001;
      const file = fileInput?.files?.[0];
      if (!file) return;

      const validExtensions = ["xlsx", "xls", "csv"];
      const ext = file.name.split(".").pop().toLowerCase();

      // Controllo formato
      if (!validExtensions.includes(ext)) {
        this.erroreModalMessaggio =
          "Formato non supportato. Usa .xlsx, .xls o .csv";
        this.erroreModalVisibile = true;
        fileInput.value = "";
        return;
      }

      // Controllo dimensione
      if (file.size > 10 * 1024 * 1024) {
        // 10 MB
        this.erroreModalMessaggio =
          "File troppo grande. Dimensione massima consentita: 10 MB";
        this.erroreModalVisibile = true;
        fileInput.value = "";
        return;
      }

      this.uploading9001 = true;
      this.uploadProgress9001 = 0;

      const formData = new FormData();
      formData.append("file", file);

      axios
        .post(`${API_BASE_URL}/upload_excel_9001`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (e) => {
            this.uploadProgress9001 = Math.round((e.loaded * 100) / e.total);
          },
        })
        .then(() => {
          this.successModalMessaggio =
            "Archivio Codici Tributo 9001 caricato con successo!";
          this.successModalVisibile = true;

          this.fetch9001PDC(false);

          this.hasUnsavedChanges9001 = false;
          this.modifiedCells9001 = {};
          this.isEditing9001 = false;
        })
        .catch((err) => {
          console.error("Errore sostituzione archivio 9001:", err);

          let msg = "Errore durante la sostituzione dell'archivio.";

          if (err.response) {
            if (err.response.status === 400) {
              msg =
                err.response.data?.error ||
                "Il file non rispetta la struttura richiesta.";
            } else if (err.response.status === 413) {
              msg = "File troppo grande.";
            } else if (err.response.status === 500) {
              msg = "Errore interno del server.";
            } else if (err.response.status === 401) {
              msg = "Sessione scaduta. Effettua nuovamente il login.";
            }
          }

          // Mostra il modal di errore
          this.erroreModalMessaggio = msg;
          this.erroreModalVisibile = true;
        })
        .finally(() => {
          this.uploading9001 = false;
          this.uploadProgress9001 = 0;
          fileInput.value = ""; // reset input
        });
    },
    deleteFile9001() {
      this.confirmModalTitle = "Elimina Archivio Codici Tributo 9001";
      this.confirmModalMessaggio =
        "Sei sicuro di voler eliminare l'archivio Codici Tributo 9001?\nTutti i dati verranno eliminati.";
      this.confirmModalShowArchiveOptions = false;
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.confirmModalVisibile = true;

      this.confirmModalCallback = (confirmed) => {
        this.resetConfirmModal();

        if (!confirmed) return;

        document.documentElement.style.cursor = "progress";
        document.body.style.cursor = "progress";

        axios
          .post(`${API_BASE_URL}/delete_excel_9001`)
          .then(() => {
            this.successModalMessaggio =
              "Archivio Codici Tributo 9001 eliminato con successo.";
            this.successModalVisibile = true;

            this.jsonData9001 = [[]];
            this.lastSavedData9001 = [];
            this.modifiedCells9001 = {};
            this.hasUnsavedChanges9001 = false;
            this.pendingDeletedRows9001Count = 0;
            this.modalVisible9001 = false;
          })
          .catch((err) => {
            console.error("Errore eliminazione archivio 9001:", err);
            alert(
              "Errore durante l'eliminazione.\n" +
                (err.response?.data?.error || "Errore sconosciuto")
            );
          })
          .finally(() => {
            document.documentElement.style.cursor = "default";
            document.body.style.cursor = "default";
          });
      };
    },
    toggleEditing9001() {
      this.isEditing9001 = !this.isEditing9001;
    },
    downloadPDC9001() {
      axios
        .get(`${API_BASE_URL}/excel/9001/download`, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);

          let fileName = "Modelli F24 - Archivio Codici Tributo 9001.xlsx";
          const disposition = response.headers["content-disposition"];

          if (disposition) {
            const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
            const asciiMatch = disposition.match(/filename="?([^"]+)"?/i);

            if (utfMatch?.[1]) fileName = decodeURIComponent(utfMatch[1]);
            else if (asciiMatch?.[1]) fileName = asciiMatch[1];
          }

          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();

          window.URL.revokeObjectURL(url);

          this.successModalMessaggio = "File scaricato con successo!";
          this.successModalVisibile = true;
        })
        .catch((err) => {
          console.error("Errore download 9001:", err);

          let msg = "Impossibile scaricare il file.";
          if (err.response?.status === 404) msg = "Archivio 9001 non trovato.";
          else if (err.response?.status === 403)
            msg = "Accesso non autorizzato.";

          alert(msg);
        });
    },
    // isColumnVisible(colIndex) {
    //   return true;
    // },
    mapped9001(rowIndex, vettore = this.vettoreCodTributo9001) {
      const row = vettore?.[rowIndex];
      if (!row) return Array(9).fill(""); // ritorna array vuoto se non c'è riga
      const dateFull = row[9] || "";
      const dateTrimmed = dateFull.replace(/_\d+$/, "");
      return [
        row[0] || "", // Denominazione Cliente
        row[1] || "", // C.F. Cliente
        dateTrimmed, // Data Pagamento
        "9001", // Codice Tributo
        row[2] || "0,00", // Saldo DARE
        row[3] || "0,00", // Saldo AVERE
        row[4] || null, // Descrizione Cod. Conto
        row[5] || null, // Cod. Conto DARE
        row[6] || null, // Cod. Conto AVERE
      ];
    },
    isEditable9001(colIndex) {
      return colIndex === 6 || colIndex === 7 || colIndex === 8; // Descrizione e i 2 Cod. Conto sempre editabili
    },
    validateInput9001(rowIndex, colIndex, event, vettoreTarget) {
      let value = event.target.value;

      // Solo per le colonne Cod. Conto DARE e AVERE (7 e 8)
      if (colIndex === 7 || colIndex === 8) {
        // Copia la logica di validazione già esistente
        const onlyLetters = value.replace(/[^a-zA-Z]/g, "").toLowerCase();

        if (onlyLetters === "na") {
          const numbers = value.replace(/\D/g, "");
          if (numbers.length > 0) {
            value = numbers; // se c'è almeno un numero → continua con quello
          } else {
            value = "N.A."; // altrimenti resta N.A.
          }
        }
        // Se contiene lettere (e non è N.A.) → forza "N.A."
        else if (/[a-zA-Z]/.test(value)) {
          value = "N.A.";
        } else {
          // Solo numeri → applichiamo le regole in base al nome colonna
          value = value.replace(/\D/g, "");

          // TEAMSYSTEM
          if (this.output_PC === "TEAMSYSTEM") {
            // Formato 99/99/999
            if (value.length > 2)
              value = value.slice(0, 2) + "/" + value.slice(2);
            if (value.length > 5)
              value = value.slice(0, 5) + "/" + value.slice(5);
            value = value.slice(0, 9);
          }
          // SISTEMI
          else if (this.output_PC === "SISTEMI") {
            // xxx.xx.xxxx
            if (value.length > 2)
              value = value.slice(0, 2) + "." + value.slice(2);
            if (value.length > 5)
              value = value.slice(0, 5) + "." + value.slice(5);
            if (value.length > 8)
              value = value.slice(0, 8) + "." + value.slice(8);
            value = value.slice(0, 12);
          }
          // SEAC
          else if (this.output_PC === "SEAC") {
            value = value.slice(0, 6);
          }
          // Datev / Zucchetti → solo numeri, nessun formato particolare
          else if (
            this.output_PC === "DATEV" ||
            this.output_PC === "ZUCCHETTI"
          ) {
            // value rimane solo numeri
          }
          // Default: solo numeri senza limiti particolari
          else {
            // value rimane solo numeri
          }
        }
      }

      // Aggiorna il valore nell'input
      event.target.value = value;

      // Salva nei valori temporanei e nel vettore mappato
      this.inputValues9001[`${rowIndex}-${colIndex}`] = value;
      this.updateMapped9001(rowIndex, colIndex, value, vettoreTarget);
    },
    updateMapped9001(rowIndex, colIndex, value, vettoreTarget) {
      const row = vettoreTarget[rowIndex];
      if (!row) return;
      switch (colIndex) {
        case 2:
          row[9] = value;
          break; // Data Pagamento
        case 6:
          row[4] = value;
          break; // Descrizione
        case 7:
          row[5] = value;
          break; // Cod. Conto DARE
        case 8:
          row[6] = value; // Cod. Conto AVERE
          break;
      }
    },
    updateCell9001(rowIndex, colIndex, value, event = null) {
      if (rowIndex === 0) return;

      const table = document.getElementById("PDCTable9001");
      const cell = event?.target || table?.rows[rowIndex]?.cells[colIndex + 1];
      if (!cell) {
        console.warn(`Cella non trovata: row=${rowIndex}, col=${colIndex}`);
        return;
      }

      const selection = window.getSelection();
      let cursorPosition = selection?.anchorOffset || 0;

      let formattedValue = value;
      let oldSeparatorCount = 0;
      let newSeparatorCount = 0;
      let isValid = true;

      const columnName = (this.jsonData9001[0][colIndex] || "").toUpperCase();

      if (colIndex === 1) {
        value = value
          .replace(/[^A-Z0-9]/gi, "")
          .toUpperCase()
          .slice(0, 16);
        isValid = validFiscalCode(value);
      }
      // --- LOGICA "N.A." universale (escluso colonne Descrizione/Cod. Conto) ---
      const previousValue = this.jsonData9001[rowIndex][colIndex] || "";
      const isEmptyOrNA =
        previousValue.trim() === "" ||
        previousValue.trim().toUpperCase() === "N.A.";
      const hasLetters = /[a-zA-Z]/.test(value);
      const hasNumbers = /\d/.test(value);

      const isCodiceContoCol = columnName.includes("COD. CONTO");
      const isDescrizioneCol = columnName.includes("DESCRIZIONE");

      if (colIndex === 1) {
        formattedValue = value;
      } else if (
        !isCodiceContoCol &&
        !isDescrizioneCol &&
        isEmptyOrNA &&
        hasLetters &&
        !hasNumbers
      ) {
        formattedValue = "N.A.";
      }

      // --- VALIDAZIONE CODICE CONTO ---
      else if (isCodiceContoCol) {
        let numeric = value.replace(/\D/g, "");

        const isTeamSystem = columnName.includes("TEAMSYSTEM");
        const isSistemi = columnName.includes("SISTEMI");
        const isSeac = columnName.includes("SEAC");
        const isDatev = columnName.includes("DATEV");
        const isZucchetti = columnName.includes("ZUCCHETTI");

        if (isTeamSystem) {
          oldSeparatorCount = (value.match(/\//g) || []).length;
          numeric = numeric.slice(0, 7);
          if (numeric.length >= 5) {
            formattedValue = `${numeric.slice(0, 2)}/${numeric.slice(
              2,
              4
            )}/${numeric.slice(4)}`;
          } else if (numeric.length >= 3) {
            formattedValue = `${numeric.slice(0, 2)}/${numeric.slice(2)}`;
          } else {
            formattedValue = numeric;
          }
          newSeparatorCount = (formattedValue.match(/\//g) || []).length;
          isValid =
            formattedValue === "" ||
            /^\d{2}\/\d{2}\/\d{3}$/.test(formattedValue);
        } else if (isSistemi) {
          oldSeparatorCount = (value.match(/\./g) || []).length;
          numeric = numeric.slice(0, 9);
          if (numeric.length >= 7) {
            formattedValue = `${numeric.slice(0, 2)}.${numeric.slice(
              2,
              4
            )}.${numeric.slice(4, 6)}.${numeric.slice(6)}`;
          } else if (numeric.length >= 5) {
            formattedValue = `${numeric.slice(0, 2)}.${numeric.slice(
              2,
              4
            )}.${numeric.slice(4)}`;
          } else if (numeric.length >= 3) {
            formattedValue = `${numeric.slice(0, 2)}.${numeric.slice(2)}`;
          } else {
            formattedValue = numeric;
          }
          newSeparatorCount = (formattedValue.match(/\./g) || []).length;
          isValid =
            formattedValue === "" ||
            /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/.test(formattedValue);
        } else if (isSeac) {
          formattedValue = numeric.slice(0, 6);
          isValid = formattedValue === "" || formattedValue.length === 6;
        } else if (isDatev) {
          formattedValue = numeric.slice(0, 11);
          isValid =
            formattedValue === "" ||
            (formattedValue.length >= 5 && formattedValue.length <= 11);
        } else if (isZucchetti) {
          formattedValue = numeric;
          isValid = formattedValue === "" || formattedValue.length >= 5;
        } else {
          formattedValue = numeric;
          isValid = true;
        }

        cursorPosition += newSeparatorCount - oldSeparatorCount;
      }

      // --- TUTTE LE ALTRE COLONNE → solo trim testo ---
      else {
        formattedValue = (value || "").trim();
      }

      if (
        isCodiceContoCol &&
        !isDescrizioneCol &&
        this.isCodContoDefault(formattedValue)
      ) {
        isValid = false;
      }

      // --- Aggiorna dati ---
      this.jsonData9001[rowIndex][colIndex] = formattedValue;

      // --- Flag modified / unsaved ---
      const original = this.lastSavedData9001?.[rowIndex]?.[colIndex] ?? "";
      if (String(formattedValue) !== String(original)) {
        this.$set(this.modifiedCells9001, `${rowIndex}-${colIndex}`, true);
      } else {
        this.$delete(this.modifiedCells9001, `${rowIndex}-${colIndex}`);
      }
      this.hasUnsavedChanges9001 = !this.isDataEqual(
        this.jsonData9001,
        this.lastSavedData9001
      );

      // --- Aggiorna DOM + cursore + errori ---
      this.$nextTick(() => {
        if (cell) {
          cell.innerText = formattedValue || "";

          const range = document.createRange();
          range.setStart(
            cell.firstChild || cell,
            Math.min(cursorPosition, formattedValue.length)
          );
          range.collapse(true);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);

          if (!isValid && formattedValue !== "") {
            cell.classList.add("error-cell");
            this.$set(this.errors9001, `${rowIndex}-${colIndex}`, true);
          } else {
            cell.classList.remove("error-cell");
            this.$delete(this.errors9001, `${rowIndex}-${colIndex}`);
          }
        }
      });
    },
    saveChanges9001(event, skipDeletionConfirmation = false) {
      if (!this.hasUnsavedChanges9001) {
        // Opzionale: messaggio "Nessuna modifica" (come nel tuo altro metodo)
        // this.noChangesMessage9001 = true;
        // setTimeout(() => { this.noChangesMessage9001 = false; }, 2000);
        return;
      }

      if (this.jsonData9001.slice(1).some((row) => !validFiscalCode(row[1]))) {
        this.mostraErrore(
          "Correggi il Codice Fiscale: sono richieste 11 cifre o 16 caratteri alfanumerici."
        );
        return;
      }
      // Controlla se ci sono errori attivi nelle celle (identico al funzionante)
      if (Object.keys(this.errors9001 || {}).length > 0) {
        this.erroreModalMessaggio =
          "Correggi i codici conto evidenziati in rosso per salvare le modifiche.";
        this.erroreModalVisibile = true;
        return; // blocca il salvataggio
      }
      if (!skipDeletionConfirmation && this.pendingDeletedRows9001Count > 0) {
        this.confirmSaveWithPendingDeletions(
          this.pendingDeletedRows9001Count,
          () => this.saveChanges9001(event, true),
          "archivio"
        );
        return;
      }

      // Cursore attesa (esattamente come nell'altro)
      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event && event.target) {
        event.target.style.cursor = "progress";
      }

      this.uploading9001 = true;

      // Creazione workbook e sheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(this.jsonData9001);
      XLSX.utils.book_append_sheet(wb, ws, "Archivio");

      // Creazione blob
      const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // FormData
      const formData = new FormData();
      formData.append("file", blob, "archivio_9001.xlsx");

      // Invio axios
      axios
        .post(`${API_BASE_URL}/update_excel_9001`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response); // per debug, come nell'altro

          this.successModalMessaggio = "Modifiche salvate con successo!";
          this.successModalVisibile = true;

          // Reset snapshot e stati (identico)
          this.lastSavedData9001 = JSON.parse(
            JSON.stringify(this.jsonData9001)
          );
          this.modifiedCells9001 = {};
          this.errors9001 = {}; // ← reset errori dopo successo
          this.hasUnsavedChanges9001 = false;

          this.pendingDeletedRows9001Count = 0;

          // Opzionale: refresh o altre azioni come finalizeAllRows se le hai
          // this.finalizeAllRows9001?.(); // se esiste
        })
        .catch((error) => {
          console.error("Errore nel salvataggio del file 9001:", error);
          this.mostraErrore(
            error.response?.data?.error || "Errore nel salvataggio del file."
          );
        })
        .finally(() => {
          // Ripristino cursore (identico)
          document.documentElement.style.cursor = "default";
          document.body.style.cursor = "default";
          if (event && event.target) {
            event.target.style.cursor = "pointer";
          }

          this.uploading9001 = false;
          // Opzionale: refresh dashboard o altro
          // this.refreshDashboard9001?.();
        });
    },

    cancelChanges9001() {
      if (!this.hasUnsavedChanges9001) return;

      this.jsonData9001 = JSON.parse(JSON.stringify(this.lastSavedData9001));
      this.modifiedCells9001 = {};
      this.errors9001 = {};
      this.hasUnsavedChanges9001 = false;
      this.pendingDeletedRows9001Count = 0;
      this.tableKey9001++;
    },

    delete9001Row(rowIndex, event) {
      this.performDelete9001Row(rowIndex, event);
    },

    performDelete9001Row(rowIndex, event) {
      // Mostra animazione cancellazione
      this.$set(this.deletedRows9001, rowIndex, true);
      this.$set(this.activeDelete9001, rowIndex, true);

      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event?.target) event.target.style.cursor = "progress";
      this.pendingDeletedRows9001Count += 1;

      setTimeout(() => {
        // Rimuovi riga
        this.jsonData9001.splice(rowIndex, 1);

        // Aggiorna hover e active
        this.hovered9001Row = null;
        this.$delete(this.deletedRows9001, rowIndex);
        this.$delete(this.activeDelete9001, rowIndex);

        // Flag modifiche
        this.hasUnsavedChanges9001 = !this.isDataEqual(
          this.jsonData9001,
          this.lastSavedData9001
        );

        // Reset cursore
        document.documentElement.style.cursor = "default";
        document.body.style.cursor = "default";
        if (event?.target) event.target.style.cursor = "pointer";
      }, 700); // tempo animazione come nel tuo esempio
    },
    deleteSaldoFRow(rowIndex, event) {
      this.performDeleteSaldoFRow(rowIndex, event);
    },

    performDeleteSaldoFRow(rowIndex, event) {
      this.$set(this.deletedRowsSaldoF, rowIndex, true);
      this.$set(this.activeDeleteSaldoF, rowIndex, true);

      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event?.target) event.target.style.cursor = "progress";
      this.pendingDeletedRowsSaldoFCount += 1;

      setTimeout(() => {
        this.jsonDataSaldoF.splice(rowIndex, 1);

        this.hoveredRowSaldoF = null;
        this.$delete(this.deletedRowsSaldoF, rowIndex);
        this.$delete(this.activeDeleteSaldoF, rowIndex);

        this.hasUnsavedChangesSaldoF = !this.isDataEqual(
          this.jsonDataSaldoF,
          this.lastSavedDataSaldoF
        );

        document.documentElement.style.cursor = "default";
        document.body.style.cursor = "default";
        if (event?.target) event.target.style.cursor = "pointer";
      }, 700);
    },
    fetchsaldofPDC(openModal = true) {
      return axios
        .get(`${API_BASE_URL}/excel/saldofinale`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const data = new Uint8Array(response.data);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          this.jsonDataSaldoF = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          });

          // padding colonne
          const maxCols = this.jsonDataSaldoF[0]?.length || 0;
          this.jsonDataSaldoF.forEach((row) => {
            while (row.length < maxCols) row.push("");
          });

          // rimuovi ultima colonna vuota
          const lastIdx = maxCols - 1;
          if (
            lastIdx >= 0 &&
            this.jsonDataSaldoF.every((r) => r[lastIdx] === "")
          ) {
            this.jsonDataSaldoF.forEach((r) => r.pop());
          }

          this.lastSavedDataSaldoF = JSON.parse(
            JSON.stringify(this.jsonDataSaldoF)
          );
          this.archiveSaldoFMissing = false;
          this.hasUnsavedChangesSaldoF = false;
          this.isEditingSaldoF = false;
          this.modifiedCellsSaldoF = {};
          this.errorsSaldoF = {};
          this.pendingDeletedRowsSaldoFCount = 0;

          if (openModal) {
            this.modalVisibleSaldoF = true;
          }
          this.isDataLoaded = true;
        })
        .catch((err) => {
          if (err.response?.status === 404) {
            console.warn("Archivio saldo finale non trovato");

            this.jsonDataSaldoF = [[...BANK_HEADERS]];

            this.lastSavedDataSaldoF = JSON.parse(
              JSON.stringify(this.jsonDataSaldoF)
            );
            this.archiveSaldoFMissing = true;
            this.hasUnsavedChangesSaldoF = false;
            this.isEditingSaldoF = false;
            this.modifiedCellsSaldoF = {};
            this.errorsSaldoF = {};
            this.pendingDeletedRowsSaldoFCount = 0;

            if (openModal) {
              this.modalVisibleSaldoF = true;
            }
            this.isDataLoaded = true;
          } else {
            console.error("Errore caricamento saldo finale:", err);
          }
        });
    },
    toggleEditingSaldoF() {
      this.isEditingSaldoF = !this.isEditingSaldoF;
    },
    replaceFileSaldoF() {
      const fileInput =
        this.$refs.fileInputSaldoFInline || this.$refs.fileInputSaldoF;
      const file = fileInput?.files?.[0];
      if (!file) return;

      const validExtensions = ["xlsx", "xls", "csv"];
      const ext = file.name.split(".").pop().toLowerCase();

      if (!validExtensions.includes(ext)) {
        this.erroreModalMessaggio =
          "Formato non supportato. Usa .xlsx, .xls o .csv";
        this.erroreModalVisibile = true;
        fileInput.value = "";
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        this.erroreModalMessaggio =
          "File troppo grande. Dimensione massima consentita: 10 MB";
        this.erroreModalVisibile = true;
        fileInput.value = "";
        return;
      }

      this.uploadingSaldoF = true;

      const formData = new FormData();
      formData.append("file", file);

      axios
        .post(`${API_BASE_URL}/upload_excel_saldofinale`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          this.successModalMessaggio =
            "Archivio Coordinate Bancarie caricato con successo!";
          this.successModalVisibile = true;
          this.fetchsaldofPDC(false);
        })
        .catch((err) => {
          console.error("Errore sostituzione archivio saldo finale:", err);

          let msg = "Errore durante la sostituzione dell'archivio.";
          if (err.response?.status === 400) {
            msg =
              err.response.data?.error ||
              "Il file non rispetta la struttura richiesta.";
          } else if (err.response?.status === 413) {
            msg = "File troppo grande.";
          } else if (err.response?.status === 500) {
            msg = "Errore interno del server.";
          } else if (err.response?.status === 401) {
            msg = "Sessione scaduta. Effettua nuovamente il login.";
          }

          this.erroreModalMessaggio = msg;
          this.erroreModalVisibile = true;
        })
        .finally(() => {
          this.uploadingSaldoF = false;
          fileInput.value = "";
        });
    },
    deleteFileSaldoF() {
      this.confirmModalTitle = "Elimina Archivio Coordinate Bancarie";
      this.confirmModalMessaggio =
        "Sei sicuro di voler eliminare l'archivio Coordinate Bancarie?\nTutti i dati verranno eliminati.";
      this.confirmModalShowArchiveOptions = false;
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.confirmModalVisibile = true;

      this.confirmModalCallback = (confirmed) => {
        this.resetConfirmModal();

        if (!confirmed) return;

        document.documentElement.style.cursor = "progress";
        document.body.style.cursor = "progress";

        axios
          .post(`${API_BASE_URL}/delete_excel_saldofinale`)
          .then(() => {
            this.successModalMessaggio =
              "Archivio Coordinate Bancarie eliminato con successo.";
            this.successModalVisibile = true;

            this.jsonDataSaldoF = [[]];
            this.lastSavedDataSaldoF = [];
            this.modifiedCellsSaldoF = {};
            this.errorsSaldoF = {};
            this.hasUnsavedChangesSaldoF = false;
            this.pendingDeletedRowsSaldoFCount = 0;
            this.modalVisibleSaldoF = false;
          })
          .catch((err) => {
            console.error("Errore eliminazione archivio saldo finale:", err);
            alert(
              "Errore durante l'eliminazione.\n" +
                (err.response?.data?.error || "Errore sconosciuto")
            );
          })
          .finally(() => {
            document.documentElement.style.cursor = "default";
            document.body.style.cursor = "default";
          });
      };
    },
    downloadSaldoF() {
      axios
        .get(`${API_BASE_URL}/excel/saldofinale/download`, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          let fileName = "Modelli F24 - Archivio Coordinate Bancarie.xlsx";
          const disposition = response.headers["content-disposition"];

          if (disposition) {
            const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
            const asciiMatch = disposition.match(/filename="?([^"]+)"?/i);
            if (utfMatch?.[1]) fileName = decodeURIComponent(utfMatch[1]);
            else if (asciiMatch?.[1]) fileName = asciiMatch[1];
          }

          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);

          this.successModalMessaggio = "File scaricato con successo!";
          this.successModalVisibile = true;
        })
        .catch((err) => {
          console.error("Errore download saldo finale:", err);
          let msg = "Impossibile scaricare il file.";
          if (err.response?.status === 404) {
            msg = "Archivio Coordinate Bancarie non trovato.";
          }
          alert(msg);
        });
    },
    updateSaldoFIbanCell(rowIndex, colIndex, value) {
      if (rowIndex === 0 || !this.isSaldoFIbanColumn(colIndex)) return;

      const normalizedValue = normalizeIban(value).slice(0, 27);
      const original = this.lastSavedDataSaldoF?.[rowIndex]?.[colIndex] ?? "";
      const isValid =
        !normalizedValue ||
        normalizedValue.length < 27 ||
        validItalianIban(normalizedValue);

      this.$set(this.jsonDataSaldoF[rowIndex], colIndex, normalizedValue);

      if (String(normalizedValue) !== String(original)) {
        this.$set(this.modifiedCellsSaldoF, `${rowIndex}-${colIndex}`, true);
      } else {
        this.$delete(this.modifiedCellsSaldoF, `${rowIndex}-${colIndex}`);
      }

      if (!isValid && normalizedValue) {
        this.$set(this.errorsSaldoF, `${rowIndex}-${colIndex}`, true);
      } else {
        this.$delete(this.errorsSaldoF, `${rowIndex}-${colIndex}`);
      }

      this.hasUnsavedChangesSaldoF = !this.isDataEqual(
        this.jsonDataSaldoF,
        this.lastSavedDataSaldoF
      );
    },
    validateSaldoFIbanCell(rowIndex, colIndex) {
      if (rowIndex === 0 || !this.isSaldoFIbanColumn(colIndex)) return;
      const value = normalizeIban(
        this.jsonDataSaldoF[rowIndex]?.[colIndex]
      ).slice(0, 27);
      if (value && !validItalianIban(value)) {
        this.$set(this.errorsSaldoF, `${rowIndex}-${colIndex}`, true);
      }
    },
    updateCellSaldoF(rowIndex, colIndex, value, event = null) {
      if (rowIndex === 0 || !this.isSaldoFEditableColumn(colIndex)) return;

      const cell =
        event?.target ||
        document
          .getElementById("SaldoFTableInline")
          ?.querySelector(`[data-saldof-cell="${rowIndex}-${colIndex}"]`) ||
        document
          .getElementById("SaldoFTable")
          ?.querySelector(`[data-saldof-cell="${rowIndex}-${colIndex}"]`);
      if (!cell) return;

      const selection = window.getSelection();
      let cursorPosition = selection?.anchorOffset || 0;

      let formattedValue = value;
      let oldSeparatorCount = 0;
      let newSeparatorCount = 0;
      let isValid = true;

      const previousValue = String(
        this.jsonDataSaldoF[rowIndex][colIndex] ?? ""
      );
      const isEmptyOrNA =
        previousValue.trim() === "" ||
        previousValue.trim().toUpperCase() === "N.A.";
      const hasLetters = /[a-zA-Z]/.test(value);
      const hasNumbers = /\d/.test(value);
      const columnName = (this.jsonDataSaldoF[0][colIndex] || "").toUpperCase();

      if (columnName === "IBAN") {
        formattedValue = normalizeIban(value).slice(0, 27);
        isValid = !formattedValue || validItalianIban(formattedValue);
      } else if (columnName === "CODICE FISCALE") {
        formattedValue = value
          .replace(/[^A-Z0-9]/gi, "")
          .toUpperCase()
          .slice(0, 16);
        isValid = validFiscalCode(formattedValue);
      } else if (columnName === "CODICE ABI" || columnName === "CODICE CAB") {
        formattedValue = value.replace(/\D/g, "").slice(0, 5);
        isValid = /^\d{5}$/.test(formattedValue) && formattedValue !== "00000";
      } else if (isEmptyOrNA && hasLetters && !hasNumbers) {
        formattedValue = "N.A.";
      } else {
        let numeric = value.replace(/\D/g, "");

        if (columnName.includes("TEAMSYSTEM")) {
          oldSeparatorCount = (value.match(/\//g) || []).length;
          numeric = numeric.slice(0, 7);
          if (numeric.length >= 5) {
            formattedValue = `${numeric.slice(0, 2)}/${numeric.slice(
              2,
              4
            )}/${numeric.slice(4)}`;
          } else if (numeric.length >= 3) {
            formattedValue = `${numeric.slice(0, 2)}/${numeric.slice(2)}`;
          } else {
            formattedValue = numeric;
          }
          newSeparatorCount = (formattedValue.match(/\//g) || []).length;
          isValid =
            formattedValue === "" ||
            formattedValue === "N.A." ||
            /^\d{2}\/\d{2}\/\d{3}$/.test(formattedValue);
        } else if (columnName.includes("SISTEMI")) {
          oldSeparatorCount = (value.match(/\./g) || []).length;
          numeric = numeric.slice(0, 9);
          if (numeric.length >= 7) {
            formattedValue = `${numeric.slice(0, 2)}.${numeric.slice(
              2,
              4
            )}.${numeric.slice(4, 6)}.${numeric.slice(6)}`;
          } else if (numeric.length >= 5) {
            formattedValue = `${numeric.slice(0, 2)}.${numeric.slice(
              2,
              4
            )}.${numeric.slice(4)}`;
          } else if (numeric.length >= 3) {
            formattedValue = `${numeric.slice(0, 2)}.${numeric.slice(2)}`;
          } else {
            formattedValue = numeric;
          }
          newSeparatorCount = (formattedValue.match(/\./g) || []).length;
          isValid =
            formattedValue === "" ||
            formattedValue === "N.A." ||
            /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/.test(formattedValue);
        } else if (columnName.includes("SEAC")) {
          formattedValue = numeric.slice(0, 6);
          isValid =
            formattedValue === "" ||
            formattedValue === "N.A." ||
            formattedValue.length === 6;
        } else if (columnName.includes("DATEV")) {
          formattedValue = numeric.slice(0, 11);
          isValid =
            formattedValue === "" ||
            formattedValue === "N.A." ||
            (formattedValue.length >= 5 && formattedValue.length <= 11);
        } else if (columnName.includes("ZUCCHETTI")) {
          formattedValue = numeric;
          isValid =
            formattedValue === "" ||
            formattedValue === "N.A." ||
            formattedValue.length >= 5;
        } else {
          formattedValue = (value || "").trim();
        }

        cursorPosition += newSeparatorCount - oldSeparatorCount;
      }

      if (
        columnName.includes("COD. CONTO") &&
        !columnName.includes("DESCRIZIONE") &&
        this.isCodContoDefault(formattedValue)
      ) {
        isValid = false;
      }

      this.jsonDataSaldoF[rowIndex][colIndex] = formattedValue;

      const original = this.lastSavedDataSaldoF?.[rowIndex]?.[colIndex] ?? "";
      if (String(formattedValue) !== String(original)) {
        this.$set(this.modifiedCellsSaldoF, `${rowIndex}-${colIndex}`, true);
      } else {
        this.$delete(this.modifiedCellsSaldoF, `${rowIndex}-${colIndex}`);
      }

      this.hasUnsavedChangesSaldoF = !this.isDataEqual(
        this.jsonDataSaldoF,
        this.lastSavedDataSaldoF
      );

      this.$nextTick(() => {
        cell.innerText = formattedValue || "";

        const range = document.createRange();
        range.setStart(
          cell.firstChild || cell,
          Math.min(cursorPosition, formattedValue.length)
        );
        range.collapse(true);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        if (!isValid && formattedValue !== "") {
          cell.classList.add("error-cell");
          this.$set(this.errorsSaldoF, `${rowIndex}-${colIndex}`, true);
        } else {
          cell.classList.remove("error-cell");
          this.$delete(this.errorsSaldoF, `${rowIndex}-${colIndex}`);
        }
      });
    },
    saveChangesSaldoF(event, skipDeletionConfirmation = false) {
      if (!this.hasUnsavedChangesSaldoF) return;
      const headers = this.jsonDataSaldoF[0];
      const coordinateErrors = this.jsonDataSaldoF
        .slice(1)
        .flatMap((row, index) =>
          bankErrors(
            row[headers.indexOf("Codice Fiscale")],
            row[headers.indexOf("Codice ABI")],
            row[headers.indexOf("Codice CAB")],
            row[headers.indexOf("IBAN")]
          ).map((error) => `Riga ${index + 1}: ${error}`)
        );
      coordinateErrors.push(
        ...bankAccountConflictErrors(
          this.jsonDataSaldoF
            .slice(1)
            .map((row) => bankRowFromArray(headers, row))
        )
      );
      if (coordinateErrors.length) {
        this.mostraErrore(coordinateErrors.join("\n"));
        return;
      }

      if (Object.keys(this.errorsSaldoF || {}).length > 0) {
        this.erroreModalMessaggio =
          "Correggi i codici conto evidenziati in rosso per salvare le modifiche.";
        this.erroreModalVisibile = true;
        return;
      }
      if (!skipDeletionConfirmation && this.pendingDeletedRowsSaldoFCount > 0) {
        this.confirmSaveWithPendingDeletions(
          this.pendingDeletedRowsSaldoFCount,
          () => this.saveChangesSaldoF(event, true),
          "archivio"
        );
        return;
      }

      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event?.target) {
        event.target.style.cursor = "progress";
      }

      this.uploadingSaldoF = true;

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(this.jsonDataSaldoF);
      XLSX.utils.book_append_sheet(wb, ws, "Archivio");

      const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const formData = new FormData();
      formData.append("file", blob, "archivio_coordinate_bancarie.xlsx");

      axios
        .post(`${API_BASE_URL}/update_excel_saldofinale`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.successModalMessaggio = "Modifiche salvate con successo!";
          this.successModalVisibile = true;
          this.lastSavedDataSaldoF = JSON.parse(
            JSON.stringify(this.jsonDataSaldoF)
          );
          this.modifiedCellsSaldoF = {};
          this.errorsSaldoF = {};
          this.hasUnsavedChangesSaldoF = false;
          this.pendingDeletedRowsSaldoFCount = 0;
        })
        .catch((error) => {
          console.error("Errore nel salvataggio del file saldo finale:", error);
          this.mostraErrore(
            error.response?.data?.error || "Errore nel salvataggio del file."
          );
        })
        .finally(() => {
          document.documentElement.style.cursor = "default";
          document.body.style.cursor = "default";
          if (event?.target) {
            event.target.style.cursor = "pointer";
          }
          this.uploadingSaldoF = false;
        });
    },
    cancelChangesSaldoF() {
      if (!this.hasUnsavedChangesSaldoF) return;
      this.jsonDataSaldoF = JSON.parse(
        JSON.stringify(this.lastSavedDataSaldoF)
      );
      this.modifiedCellsSaldoF = {};
      this.errorsSaldoF = {};
      this.hasUnsavedChangesSaldoF = false;
      this.pendingDeletedRowsSaldoFCount = 0;
      this.tableKeySaldoF++;
    },

    openUploadPianoModal() {
      this.errorMessage = "";
      this.resetUploadPctTargetState();
      if (this.isPctMainView) {
        this.fetchUploadClienti();
      }
      this.showAddPiano = true;
      this.showAddBilancino = false;
      this.showAddRow = false;
    },
    closeUploadPianoModal() {
      if (this.uploading) return;

      this.showAddPiano = false;
      this.selectedPiano = null;
      this.rows = [];
      this.errorMessage = "";
      this.resetUploadPctTargetState();
    },
    triggerFileInput() {
      this.openUploadPianoModal();
    },
    resetUploadPctTargetState() {
      this.uploadPctScope = this.currentPctIsClient
        ? "existing_client"
        : "main";
      this.selectedUploadClientKey = this.currentPctIsClient
        ? this.selectedClientPctKey
        : "";
      this.uploadNewClient = {
        titolo_cliente: "",
        codice_fiscale: "",
        codice_ditta: "",
      };
      this.uploadPctErrors = {
        client: "",
        titolo_cliente: "",
        codice_fiscale: "",
      };
    },
    async fetchUploadClienti() {
      this.loadingUploadClients = true;
      try {
        const response = await axios.get(
          `${API_BASE_URL}/get_clienti_by_studio`
        );
        this.uploadClienti = response.data?.success
          ? response.data.clienti
          : [];
      } catch (error) {
        console.error("Errore caricamento clienti anagrafica:", error);
        this.uploadClienti = [];
      } finally {
        this.loadingUploadClients = false;
      }
    },
    normalizeUploadClientKey(value) {
      return String(value || "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },
    formatUploadClientFiscalCode() {
      this.uploadNewClient.codice_fiscale = this.normalizeUploadClientKey(
        this.uploadNewClient.codice_fiscale
      ).slice(0, 16);
      this.uploadPctErrors.codice_fiscale = "";
    },
    isValidUploadFiscalCode(value) {
      const normalized = this.normalizeUploadClientKey(value);
      return /^\d{11}$/.test(normalized) || /^[A-Z0-9]{16}$/.test(normalized);
    },
    validateUploadPctTarget() {
      this.uploadPctErrors = {
        client: "",
        titolo_cliente: "",
        codice_fiscale: "",
      };

      if (!this.isPctMainView || this.uploadPctScope === "main") {
        return true;
      }

      if (this.uploadPctScope === "existing_client") {
        if (!this.selectedUploadClientKey) {
          this.uploadPctErrors.client =
            "Seleziona un cliente con Codice Fiscale";
          return false;
        }
        if (!this.isValidUploadFiscalCode(this.selectedUploadClientKey)) {
          this.uploadPctErrors.client =
            "Il cliente selezionato non ha un Codice Fiscale valido";
          return false;
        }
      }

      if (this.uploadPctScope === "new_client") {
        if (!this.uploadNewClient.titolo_cliente?.trim()) {
          this.uploadPctErrors.titolo_cliente =
            "La Denominazione Cliente e' obbligatoria";
        }
        if (!this.uploadNewClient.codice_fiscale?.trim()) {
          this.uploadPctErrors.codice_fiscale =
            "Il Codice Fiscale e' obbligatorio";
        } else if (
          !this.isValidUploadFiscalCode(this.uploadNewClient.codice_fiscale)
        ) {
          this.uploadPctErrors.codice_fiscale =
            "Inserisci un Codice Fiscale valido";
        }
      }

      return !Object.values(this.uploadPctErrors).some(Boolean);
    },
    async ensureUploadClientKey() {
      if (!this.isPctMainView || this.uploadPctScope === "main") return null;
      if (this.uploadPctScope === "existing_client") {
        return this.selectedUploadClientKey;
      }

      const payload = {
        titolo_cliente: this.uploadNewClient.titolo_cliente.trim(),
        codice_fiscale: this.normalizeUploadClientKey(
          this.uploadNewClient.codice_fiscale
        ),
        codice_ditta: this.uploadNewClient.codice_ditta.trim(),
      };
      const response = await axios.post(
        `${API_BASE_URL}/aggiungi_cliente`,
        payload
      );
      if (!response.data?.success) {
        throw new Error(response.data?.error || "Errore salvataggio cliente");
      }
      await this.fetchUploadClienti();
      return payload.codice_fiscale;
    },
    handleFileUpload(fileOrEvent) {
      const file = fileOrEvent?.target?.files
        ? fileOrEvent.target.files[0]
        : fileOrEvent;

      this.selectedPiano = file || null;
      this.rows = [];
      if (!this.selectedPiano) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        this.rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      };
      reader.readAsArrayBuffer(this.selectedPiano);
    },
    triggerBilancinoInput() {
      this.$refs.BilancinoInput.click();
    },
    handleF24Input(event) {
      console.log(
        "Change event triggered - files length:",
        event.target.files.length,
        "restoringFile:",
        this.restoringFile
      );

      // If we're restoring, skip processing to avoid infinite loop
      if (this.restoringFile) {
        this.restoringFile = false;
        console.log(
          "Restoration complete - F24File:",
          this.F24File?.name,
          "fileTitle:",
          this.fileTitle,
          "input files:",
          this.$refs.bilancinoInput.files[0]?.name
        );
        // Check if files were cleared unexpectedly and reapply restoration
        if (this.F24File && !this.$refs.bilancinoInput.files.length) {
          console.log(
            "Files cleared unexpectedly, reapplying restoration for:",
            this.F24File.name
          );
          this.$nextTick(() => {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(this.F24File);
            this.$refs.bilancinoInput.files = dataTransfer.files;
            console.log(
              "Re-restoration attempted - input files:",
              this.$refs.bilancinoInput.files[0]?.name
            );
          });
        }
        return;
      }

      const newFile = event.target.files[0];

      // Detect cancel: files.length === 0 (browser cleared it)
      if (!newFile) {
        if (this.F24File) {
          console.log("Cancel detected - restoring file:", this.F24File.name);
          this.$nextTick(() => {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(this.F24File);
            this.$refs.bilancinoInput.files = dataTransfer.files;
            this.restoringFile = true; // Set flag for potential change event
            this.fileTitle = this.F24File.name; // Ensure fileTitle is in sync
            console.log(
              "Restoration attempted - input files:",
              this.$refs.bilancinoInput.files[0]?.name
            );
          });
        } else {
          this.fileTitle = "Nessun file selezionato";
          console.log("No previous file to restore");
        }
        return;
      }

      // Estrazione estensione file
      const filename = newFile.name;
      const estensione = filename.split(".").pop().toLowerCase();

      // Set fileType per distinguere CSV da Excel
      if (estensione === "csv") {
        this.fileType = "csv";
      } else if (["xls", "xlsx", "xlsm"].includes(estensione)) {
        this.fileType = "excel";
      } else {
        this.fileType = "";
      }

      // Se il file è un PDF, genera l'URL per visualizzazione
      if (newFile.type === "application/pdf") {
        if (this.filePDF_URL) URL.revokeObjectURL(this.filePDF_URL); // Clean up previous URL
        this.filePDF_URL = URL.createObjectURL(newFile);
      } else {
        if (this.filePDF_URL) URL.revokeObjectURL(this.filePDF_URL); // Clean up previous URL
        this.filePDF_URL = null;
      }

      // Se non c'era un file prima, lo assegna direttamente
      if (!this.F24File) {
        this.F24File = newFile;
        this.fileTitle = this.F24File.name;
        this.leggiFileExcelOCsv(newFile, estensione);
        console.log("First file selected:", this.F24File.name);
        return;
      }

      // Controlla se il file è diverso dal precedente (per nome o data)
      if (
        this.F24File.name !== newFile.name ||
        this.F24File.lastModified !== newFile.lastModified
      ) {
        this.F24File = newFile;
        this.refreshConversione2();
        this.leggiFileExcelOCsv(newFile, estensione);
        console.log("New file selected:", this.F24File.name);
      }

      this.fileTitle = this.F24File.name;
      console.log(
        "After handleF24Input - F24File:",
        this.F24File?.name,
        "fileTitle:",
        this.fileTitle,
        "input files:",
        this.$refs.bilancinoInput.files[0]?.name
      );
    },
    leggiFileExcelOCsv(file, estensione) {
      if (estensione === "csv") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const testoCsv = e.target.result;
          this.ExcelRows = testoCsv.split("\n").map((line) => line.split(","));
        };
        reader.readAsText(file);
      } else if (estensione === "xls" || estensione === "xlsx") {
        console.log("EXCEL RILEVATO");
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          this.ExcelRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        };
        reader.readAsArrayBuffer(file);
      } else {
        this.ExcelRows = [];
        this.fileType = "";
      }
    },
    openPDFPreview() {
      this.showPDF = true;
    },
    nextSubPhase() {
      const phases = this.availablePhases;
      const currentIndex = phases.indexOf(this.currentSubPhase);
      if (currentIndex < phases.length - 1) {
        this.currentSubPhase = phases[currentIndex + 1];
      }
    },
    prevSubPhase() {
      const phases = this.availablePhases;
      const currentIndex = phases.indexOf(this.currentSubPhase);
      if (currentIndex > 0) {
        this.currentSubPhase = phases[currentIndex - 1];
      }
    },
    sendBilancino() {
      if (!this.F24File) return;

      if (!this.output_PC) {
        this.erroreModalMessaggio =
          "Devi selezionare il software contabile prima di procedere!";
        this.erroreModalVisibile = true;
        return;
      }
      this.resetSubPhaseState();
      this.calculating = true;
      const requestId = ++this.activeScanRequestId;
      this.errorMessage = "";
      const formData = new FormData();
      formData.append("file", this.F24File);
      formData.append("output_PC", this.output_PC);

      const settings = getUserSettings();
      formData.append("flag_saldoF24", settings.flag_saldoF24);

      this.startDelayMessageTimer();

      axios
        .post(`${API_BASE_URL}/edit_PCT_with_F24`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (this.isStaleScanRequest(requestId)) return;
          this.clearDelayMessageTimer();
          this.applyCodContoDefaultFromResponse(res.data || {});

          // ───────────────────────────────────────────────
          // 1. vettoreCodTributo (codici tributo "normali")
          // ───────────────────────────────────────────────
          if (Array.isArray(res.data.vettoreCodTributo)) {
            this.$set(
              this,
              "vettoreCodTributo",
              res.data.vettoreCodTributo.map((row) =>
                Array.isArray(row)
                  ? row.map((cell, index) => {
                      if (
                        [1, 2, 3, 4].includes(index) &&
                        (cell == null ||
                          cell === "None" ||
                          this.isCodContoDefault(cell))
                      ) {
                        return null;
                      }
                      return cell;
                    })
                  : row
              )
            );
          } else {
            this.$set(this, "vettoreCodTributo", []);
          }

          // ───────────────────────────────────────────────
          // 2. vettoreCodTributoPCT + originalPCT
          // ───────────────────────────────────────────────
          if (Array.isArray(res.data.vettoreCodTributoPCT)) {
            const mappedPCT = res.data.vettoreCodTributoPCT.map((row) =>
              Array.isArray(row)
                ? row.map((cell, index) =>
                    [1, 2, 3, 4].includes(index) &&
                    (cell == null ||
                      cell === "None" ||
                      this.isCodContoDefault(cell))
                      ? null
                      : cell
                  )
                : row
            );

            this.$set(this, "vettoreCodTributoPCT", mappedPCT);

            // deep copy per original
            this.originalPCT = JSON.parse(JSON.stringify(mappedPCT));

            console.log(
              "PCT caricato e originalPCT salvato:",
              this.originalPCT?.length ?? 0,
              "righe"
            );
          } else {
            this.$set(this, "vettoreCodTributoPCT", []);
            this.originalPCT = null;
          }

          // ───────────────────────────────────────────────
          // 3. vettoreCodTributo9001 (nuovi 9001)
          // ───────────────────────────────────────────────
          if (Array.isArray(res.data.vettoreCodTributo9001)) {
            const mapped9001 = res.data.vettoreCodTributo9001.map((row) =>
              Array.isArray(row)
                ? row.map((cell, index) => {
                    if (
                      [1, 2, 3, 4].includes(index) &&
                      (cell == null ||
                        cell === "None" ||
                        this.isCodContoDefault(cell))
                    ) {
                      return null;
                    }
                    return cell;
                  })
                : row
            );

            this.$set(this, "vettoreCodTributo9001", mapped9001);

            // Inizializza inputValues9001
            this.inputValues9001 = {};
            mapped9001.forEach((row, rowIndex) => {
              const mappedRow = this.mapped9001(rowIndex); // ← assicurati che esista!
              mappedRow.forEach((val, colIndex) => {
                let cleanVal = val ?? "";
                if (cleanVal === "None") cleanVal = "";
                if (this.isEditable9001(colIndex)) {
                  this.$set(
                    this.inputValues9001,
                    `${rowIndex}-${colIndex}`,
                    cleanVal
                  );
                }
              });
            });
          } else {
            this.$set(this, "vettoreCodTributo9001", []);
          }

          // ───────────────────────────────────────────────
          // 4. vettoreCodTributo9001_PCT + original9001PCT
          // ───────────────────────────────────────────────
          if (Array.isArray(res.data.vettoreCodTributo9001_PCT)) {
            const mapped9001PCT = res.data.vettoreCodTributo9001_PCT.map(
              (row) =>
                Array.isArray(row)
                  ? row.map((cell, index) =>
                      [1, 2, 3, 4].includes(index) &&
                      (cell == null ||
                        cell === "None" ||
                        this.isCodContoDefault(cell))
                        ? null
                        : cell
                    )
                  : row
            );

            this.$set(this, "vettoreCodTributo9001_PCT", mapped9001PCT);

            this.original9001PCT = JSON.parse(JSON.stringify(mapped9001PCT));

            // Popola inputValues9001 per PCT
            mapped9001PCT.forEach((row, rowIndex) => {
              const mappedRow = this.mapped9001(
                rowIndex,
                this.vettoreCodTributo9001_PCT
              );
              mappedRow.forEach((val, colIndex) => {
                let cleanVal = val ?? "";
                if (cleanVal === "None") cleanVal = "";
                if (this.isEditable9001(colIndex)) {
                  this.$set(
                    this.inputValues9001,
                    `pct-${rowIndex}-${colIndex}`,
                    cleanVal
                  );
                }
              });
            });

            console.log(
              "9001_PCT caricato e original9001PCT salvato:",
              this.original9001PCT?.length ?? 0,
              "righe"
            );
          } else {
            this.$set(this, "vettoreCodTributo9001_PCT", []);
            this.original9001PCT = null;
          }

          // ───────────────────────────────────────────────
          // Finalizzazione flusso
          // ───────────────────────────────────────────────
          this.input_PC = res.data.input_PC || "F24";
          this.editPDCresponse = true;
          this.isShifted = true;

          this.isEditMode = false;
          this.isEditModePCT = false;
          this.isEditMode9001PCT = false;

          // NON forziamo currentSubPhase → deve restare "A" (come impostato in reset)
          // this.currentSubPhase = ... ← eliminato!

          this.nextConversionStep(requestId);

          // Forza Vue a ricalcolare i computed dopo l'aggiornamento reattivo
          this.$nextTick(() => {
            console.log("=== DOPO $nextTick ===");
            console.log(
              "vettoreCodTributo9001.length     =",
              this.vettoreCodTributo9001?.length ?? 0
            );
            console.log(
              "vettoreCodTributo9001_PCT.length =",
              this.vettoreCodTributo9001_PCT?.length ?? 0
            );
            console.log("hasPhaseB         =", this.hasPhaseB);
            console.log("availablePhases   =", this.availablePhases);
            console.log("currentSubPhase   =", this.currentSubPhase);
            console.log("isLastPhase       =", this.isLastPhase);
            console.log("showResult        =", this.showResult);
            console.log("editPDCresponse   =", this.editPDCresponse);
          });

          // Log immediato (per confronto)
          console.log("=== DOPO POPOLAMENTO (prima di nextTick) ===");
          console.log(
            "vettoreCodTributo9001.length     =",
            this.vettoreCodTributo9001?.length ?? 0
          );
          console.log(
            "vettoreCodTributo9001_PCT.length =",
            this.vettoreCodTributo9001_PCT?.length ?? 0
          );
          console.log("hasPhaseB =", this.hasPhaseB);
          console.log("availablePhases =", this.availablePhases);
          console.log("currentSubPhase =", this.currentSubPhase);
          console.log("isLastPhase  =", this.isLastPhase);
        })
        .catch((err) => {
          if (this.isStaleScanRequest(requestId)) return;
          this.clearDelayMessageTimer();

          let msg = "Errore nella richiesta al server.";

          if (err.response) {
            const status = err.response.status;
            const data = err.response.data;

            if (status === 400) {
              msg = data?.error || "Richiesta non valida.";
            } else if (status === 401) {
              msg = "Sessione scaduta. Effettua nuovamente il login.";
            } else if (status === 404) {
              msg = "Utente non trovato.";
            } else if (status === 413) {
              msg = "File troppo grande.";
            } else if (status === 500) {
              msg = data?.error || "Errore interno del server.";
            } else {
              msg = data?.error || "Errore sconosciuto dal server.";
            }
          } else if (err.message) {
            msg = `Errore di rete: ${err.message}`;
          }

          this.erroreModalMessaggio = msg;
          this.erroreModalVisibile = true;

          console.error("Errore sendBilancino:", err);
        })
        .finally(() => {
          if (!this.isStaleScanRequest(requestId)) {
            this.calculating = false;
          }
        });
    },
    resetSubPhaseState() {
      this.currentSubPhase = "A"; // sempre ripartire da A
      this.vettorePCTVisible = false; // chiudi toggle PCT
      this.vettore9001PCTVisible = false; // chiudi toggle 9001
      this.isTableExpanded = false;
      this.isTableTributoPCTExpanded = false;
      this.isTable9001Expanded = false;
      this.isTable9001PCTExpanded = false;
      this.isEditMode = false;
      this.isEditModePCT = false;
      this.isEditMode9001PCT = false; // se ce l'hai
      this.showResult = false; // nascondi risultato
      this.editPDCresponse = false; // resetta stato risposta
      this.vettoreCodTributo = []; // pulisci vettori (opzionale)
      this.vettoreCodTributoPCT = [];
      this.vettoreCodTributo9001 = [];
      this.vettoreCodTributo9001_PCT = [];
      this.originalPCT = null;
      this.original9001PCT = null;
    },
    nextConversionStep(requestId = this.activeScanRequestId) {
      setTimeout(() => {
        if (this.isStaleScanRequest(requestId)) return;
        this.showResult = true; // Applica la classe "show" per farlo comparire
      }, 1000); // Ritardo della transizione per il secondo contenitore
    },
    loadUserPreferredSoftware() {
      const settings = getUserSettings();
      const saved = settings.software_contabile || "default";

      const mapping = {
        TEAMSYSTEM: "TEAMSYSTEM",
        DATEV: "DATEV",
        ZUCCHETTI: "ZUCCHETTI",
        SISTEMI: "SISTEMI",
        SEAC: "SEAC",
      };

      if (mapping[saved]) {
        this.output_PC = mapping[saved];
        this.selectedSoftware = mapping[saved];
        this.selectedSoftwareAddRow = mapping[saved];
        this.selectedAddRowSoftwares = [mapping[saved]];
      } else {
        this.selectedSoftware = "ALL";
      }
    },
    async uploadFile(payload = null) {
      const file = payload?.file || this.selectedPiano;
      if (!file) return;
      if (!this.validateUploadPctTarget()) return;

      this.uploading = true;

      try {
        const clientKey = await this.ensureUploadClientKey();
        const isClientUpload = Boolean(clientKey);
        const formData = new FormData();
        formData.append("file", file);
        if (isClientUpload) {
          formData.append("client_key", clientKey);
        }

        const uploadUrl = isClientUpload
          ? "/update_excel/client_pct"
          : this.isPct9001View
          ? "/upload_excel_9001"
          : this.isPctSaldoFView
          ? "/upload_excel_saldofinale"
          : "/upload_PCT";
        const successMessage = isClientUpload
          ? "Piano Codici Tributo cliente caricato con successo!"
          : this.isPct9001View
          ? "Archivio Codici Tributo 9001 caricato con successo!"
          : this.isPctSaldoFView
          ? "Archivio Coordinate Bancarie caricato con successo!"
          : "Piano caricato con successo!";

        const response = await axios.post(
          `${API_BASE_URL}${uploadUrl}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 200) {
          if (isClientUpload) {
            this.selectedPctFileKey = "pct";
            this.selectedPctViewKey = `client:${clientKey}`;
            this.lastSelectedPctFileKey = "pct";
            this.lastSelectedPctViewKey = this.selectedPctViewKey;
          }
          await this.fetchClientPctPlans(
            isClientUpload
              ? [{ fileKey: "pct", viewKey: `client:${clientKey}` }]
              : []
          );
          await this.fetchCurrentPctFile();
          this.refreshDashboard();

          this.successModalMessaggio = successMessage;
          this.successModalVisibile = true;
          this.showAddPiano = false;
          this.selectedPiano = null;
          this.rows = [];
        }
      } catch (error) {
        console.error("Errore durante il caricamento del Piano PCT:", error);

        let msg = "Errore durante il caricamento del file.";

        if (error.response) {
          const status = error.response.status;
          const data = error.response.data || {};

          if (status === 400) {
            msg = data.error || "Il file non rispetta la struttura richiesta.";
          } else if (status === 401) {
            msg = "Sessione scaduta. Effettua nuovamente il login.";
          } else if (status === 404) {
            msg = "Utente non trovato.";
          } else if (status === 413) {
            msg = "File troppo grande.";
          } else if (status === 500) {
            msg = data.error || "Errore interno del server.";
          } else {
            msg = data.error || "Errore sconosciuto dal server.";
          }
        } else if (error.message) {
          msg = `Errore di rete: ${error.message}`;
        }

        // Mostra il modal di errore
        this.erroreModalMessaggio = msg;
        this.erroreModalVisibile = true;
      } finally {
        this.uploading = false;
      }
    },

    isEditableColumnTable(colIndex) {
      const editableColumns = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
      ];
      return editableColumns.includes(colIndex);
    },
    isEditableColumnPCT(originalIndex, rowIndex) {
      // Escludi esplicitamente originalIndex === 0 (Codice Tributo)
      if (originalIndex === 0) {
        return false;
      }

      // Rendi editabile solo se isEditModePCT è attivo
      if (!this.isEditModePCT) {
        return false;
      }

      const cellKey = rowIndex + "-" + originalIndex;
      const currentRow =
        this.vettoreCodTributoPCT && this.vettoreCodTributoPCT[rowIndex];

      // Clear "Descrizione - Cod. Conto Default" proactively (solo in edit mode)
      if (
        currentRow &&
        currentRow[originalIndex] === "Descrizione - Cod. Conto Default"
      ) {
        this.vettoreCodTributoPCT[rowIndex][originalIndex] = "";
        this.editableCells.add(cellKey); // Mark as editable after clearing
      }

      // Controlla se la colonna è una "Descrizione Cod. Conto"
      const isNomeConto = this.isDescrizioneCodContoColumn(
        this.headers[originalIndex]
      );

      // Logica per le colonne "Descrizione Cod. Conto": editabile in edit mode, o se marcata
      if (isNomeConto) {
        return true; // Sempre editabile in edit mode
        // Oppure, se vuoi mantenere condizioni extra: return true || this.editableCells.has(cellKey);
      }

      // Logica per altre colonne editabili in base a output_PC (ora solo in edit mode)
      if (this.editableCells.has(cellKey)) {
        return true;
      }

      switch (this.output_PC) {
        case "TEAMSYSTEM":
          return originalIndex === 2 || originalIndex === 3; // Cod. conto DARE/AVERE TeamSystem
        case "DATEV":
          return [5, 6, 8, 9].includes(originalIndex); // Cod. conto DARE/AVERE Datev
        case "ZUCCHETTI":
          return [11, 12].includes(originalIndex); // Cod. conto DARE/AVERE Zucchetti
        case "SEAC":
          return [14, 15].includes(originalIndex); // Cod. conto DARE/AVERE SEAC
        case "SISTEMI":
          return [17, 18].includes(originalIndex); // Cod. conto DARE/AVERE Sistemi
        default:
          return false;
      }
    },
    isEditableColumn(realColIndex, rowIndex) {
      const cellKey = rowIndex + "-" + realColIndex;
      const currentRow = this.vettoreCodTributo[rowIndex];

      // Clear default description
      if (
        currentRow &&
        currentRow[realColIndex] === "Descrizione - Cod. Conto Default"
      ) {
        this.vettoreCodTributo[rowIndex][realColIndex] = "";
        this.editableCells.add(cellKey);
      }

      const isNomeConto = this.isNomeContoColumn(this.headers[realColIndex]);

      if (isNomeConto) {
        return (
          this.isEditMode ||
          !currentRow[realColIndex] ||
          this.editableCells.has(cellKey)
        );
      }
      if (this.editableCells.has(cellKey)) {
        return true;
      }

      switch (this.output_PC) {
        case "TEAMSYSTEM":
          return realColIndex === 2 || realColIndex === 3; // Cod. conto DARE/AVERE TeamSystem
        case "DATEV":
          return [5, 6, 8, 9].includes(realColIndex); // Cod. conto DARE/AVERE Datev
        case "ZUCCHETTI":
          return [11, 12].includes(realColIndex); // Cod. conto DARE/AVERE Zucchetti
        case "SEAC":
          return [14, 15].includes(realColIndex); // Cod. conto DARE/AVERE SEAC
        case "SISTEMI":
          return [17, 18].includes(realColIndex); // Cod. conto DARE/AVERE Sistemi
        default:
          return false;
      }
    },
    isCellModified(row, col) {
      return this.modifiedCells[`${row}-${col}`] === true;
    },
    rebuildCellStates() {
      const newModified = {};
      const newErrors = {};

      const numRows = Math.min(this.jsonData.length, this.lastSavedData.length);
      const numCols = this.headers.length;

      for (let rowIndex = 0; rowIndex < numRows; rowIndex++) {
        for (let colIndex = 0; colIndex < numCols; colIndex++) {
          const key = `${rowIndex}-${colIndex}`;
          const current = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
          const original = this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";

          if (String(current) !== String(original)) {
            newModified[key] = true;
          }

          // Rimuovi questa validazione per la colonna 1
          // if (colIndex === 1) { ... }

          // Validazione solo per altre colonne specifiche (esempio Datev)
          if (colIndex !== 1) {
            const columnName = this.headers[colIndex];
            const numericValue = String(current).replace(/\D/g, "");
            const isDatev =
              columnName === "Cod. conto Datev Aziende" ||
              columnName === "Cod. conto Datev Liberi Professionisti";

            if (
              isDatev &&
              numericValue.length > 0 &&
              (numericValue.length < 5 || numericValue.length > 11)
            ) {
              newErrors[key] = true;
            }
          }
        }
      }

      // Righe aggiunte segnate come modificate
      for (
        let rowIndex = numRows;
        rowIndex < this.jsonData.length;
        rowIndex++
      ) {
        for (let colIndex = 0; colIndex < numCols; colIndex++) {
          const key = `${rowIndex}-${colIndex}`;
          newModified[key] = true;
        }
      }

      this.modifiedCells = newModified;
      this.errors = newErrors;
    },
    clearDefaultDescription(rowIndex, colIndex) {
      if (
        this.vettoreCodTributo[rowIndex][colIndex] ===
        "Descrizione - Cod. Conto Default"
      ) {
        this.vettoreCodTributo[rowIndex][colIndex] = "";
      }
    },
    isNomeContoColumn(headerName) {
      const nomeContoLabels = [
        "Descrizione Cod. Conto",
        "Descrizione Cod. Conto - Datev Aziende",
        "Descrizione Cod. Conto - Datev Lib. Prof.",
        "Descrizione Cod. Conto - TeamSystem",
        "Descrizione Cod. Conto - Zucchetti",
        "Descrizione Cod. Conto - SEAC",
        "Descrizione Cod. Conto - Sistemi",
        "Descrizione - Cod. Conto Default",
      ];
      return nomeContoLabels.includes(headerName);
    },
    getDisplayedRowIndex(rowIndex) {
      return this.filteredDisplayRows.findIndex(
        (row) => row.originalIndex === rowIndex
      );
    },
    updateCell(rowIndex, colIndex, value) {
      const table = document.getElementById("excelTable");
      const displayRowIndex = this.getDisplayedRowIndex(rowIndex);

      // Calcola l’indice visibile nella riga (salta colonne nascoste)
      const getVisibleCellIndex = (colIndex) => {
        if (colIndex === 0) return 1;
        const pos = this.visibleColumns.indexOf(colIndex);
        return pos === -1 ? -1 : pos + 2;
      };
      const visibleCellIndex = getVisibleCellIndex(colIndex);
      if (visibleCellIndex === -1) return;

      const cell =
        displayRowIndex === -1
          ? null
          : table?.rows[displayRowIndex]?.cells[visibleCellIndex];
      if (!cell) return;

      const columnName = this.headers[colIndex];
      const upperValue = value.trim().toUpperCase();
      if (upperValue === "NESSUNA CORRELAZIONE") {
        this.jsonData[rowIndex][colIndex] = "NESSUNA CORRELAZIONE";
        this.$nextTick(() => {
          if (cell) {
            cell.innerText = "NESSUNA CORRELAZIONE";
            // Posiziona il cursore alla fine del testo
            const range = document.createRange();
            range.selectNodeContents(cell);
            range.collapse(false); // false = alla fine del contenuto
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
          }
          this.$delete(this.errors, `${rowIndex}-${colIndex}`);
          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== "NESSUNA CORRELAZIONE") {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }
          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
          this.$forceUpdate();
        });
        return;
      }
      // --- LOGICA "N.A." universale (esclusa la colonna Descrizione Cod. Conto) ---
      if (!columnName.includes("Descrizione Cod. Conto")) {
        const previousValue = this.jsonData[rowIndex][colIndex] || "";
        const isEmptyOrNA =
          previousValue.trim() === "" ||
          previousValue.trim().toUpperCase() === "N.A.";
        const hasLetters = /[a-zA-Z]/.test(value);
        const hasNumbers = /\d/.test(value);

        if (isEmptyOrNA && hasLetters && !hasNumbers) {
          this.jsonData[rowIndex][colIndex] = "N.A.";
          if (cell) cell.innerText = "N.A.";

          this.$delete(this.errors, `${rowIndex}-${colIndex}`);

          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== "N.A.") {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );

          this.$forceUpdate();
          return;
        }
      }
      // Gestione per SEAC: Cod. Conto DARE - SEAC e Cod. Conto AVERE - SEAC
      const isSeac = [
        "Cod. Conto DARE - SEAC",
        "Cod. Conto AVERE - SEAC",
      ].includes(columnName);

      // Gestione per Sistemi: Cod. Conto DARE - Sistemi e Cod. Conto AVERE - Sistemi
      const isSistemi = [
        "Cod. Conto DARE - Sistemi",
        "Cod. Conto AVERE - Sistemi",
      ].includes(columnName);

      if (isSeac) {
        // Mantieni la posizione del cursore
        const selection = window.getSelection();
        let cursorPosition = selection?.anchorOffset || 0;

        // Pulisci input, solo numeri, max 6 cifre
        let numericValue = value.replace(/\D/g, "").slice(0, 6);
        let isValid = numericValue.length === 6 || numericValue === ""; // Valido se 6 cifre o vuoto
        if (this.isCodContoDefault(numericValue)) {
          isValid = false;
        }

        this.$nextTick(() => {
          // Aggiorna il DOM
          cell.innerText = numericValue;

          // Riposiziona il cursore
          const range = document.createRange();
          range.setStart(
            cell.firstChild || cell,
            Math.min(cursorPosition, numericValue.length)
          );
          range.collapse(true);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);

          // Gestione errori
          if (!isValid) {
            this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.errors, `${rowIndex}-${colIndex}`);
          }

          // Salva nel modello dati, normalizzando il valore vuoto
          this.jsonData[rowIndex][colIndex] = numericValue || "";

          // Flag modified
          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          const currentValue = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== String(currentValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          // Aggiorna stato unsaved changes
          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
        });
      } else if (isSistemi) {
        // Mantieni la posizione del cursore
        const selection = window.getSelection();
        let cursorPosition = selection?.anchorOffset || 0;

        // Pulisci input, solo numeri
        let rawValue = value.replace(/[^0-9]/g, "").slice(0, 9);
        const oldDotCount = (value.match(/\./g) || []).length;
        let formattedValue = rawValue;

        // Formato xx.xx.xx o xx.xx.xx.xxx
        if (rawValue.length >= 6) {
          formattedValue = `${rawValue.slice(0, 2)}.${rawValue.slice(
            2,
            4
          )}.${rawValue.slice(4, 6)}${
            rawValue.length > 6 ? "." + rawValue.slice(6) : ""
          }`;
        } else if (rawValue.length >= 4) {
          formattedValue = `${rawValue.slice(0, 2)}.${rawValue.slice(
            2,
            4
          )}.${rawValue.slice(4)}`;
        } else if (rawValue.length >= 2) {
          formattedValue = `${rawValue.slice(0, 2)}.${rawValue.slice(2)}`;
        }

        const newDotCount = (formattedValue.match(/\./g) || []).length;
        cursorPosition += newDotCount - oldDotCount;

        // Validazione: solo xx.xx.xx o xx.xx.xx.xxx
        const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;
        let isValid =
          formattedValue === "" || sistemiRegex.test(formattedValue);
        if (this.isCodContoDefault(formattedValue)) {
          isValid = false;
        }

        this.$nextTick(() => {
          // Aggiorna il DOM
          cell.innerText = formattedValue;

          // Riposiziona il cursore
          const range = document.createRange();
          range.setStart(
            cell.firstChild || cell,
            Math.min(cursorPosition, formattedValue.length)
          );
          range.collapse(true);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);

          // Gestione errori
          if (!isValid) {
            this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.errors, `${rowIndex}-${colIndex}`);
          }

          // Salva nel modello dati, normalizzando il valore vuoto
          this.jsonData[rowIndex][colIndex] = formattedValue || "";

          // Flag modified
          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          const currentValue = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== String(currentValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          // Aggiorna stato unsaved changes
          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
        });
      } else if (colIndex === 2 || colIndex === 3) {
        // Mantieni la posizione del cursore
        const selection = window.getSelection();
        let cursorPosition = selection?.anchorOffset || 0;

        let rawValue = value.replace(/\D/g, "").slice(0, 7);
        const oldSlashCount = (value.match(/\//g) || []).length;
        let formattedValue = rawValue;
        if (rawValue.length >= 5) {
          formattedValue = `${rawValue.slice(0, 2)}/${rawValue.slice(
            2,
            4
          )}/${rawValue.slice(4)}`;
        } else if (rawValue.length >= 3) {
          formattedValue = `${rawValue.slice(0, 2)}/${rawValue.slice(2)}`;
        }
        const newSlashCount = (formattedValue.match(/\//g) || []).length;
        cursorPosition += newSlashCount - oldSlashCount;

        // Applica il testo formattato e riposiziona il cursore
        this.$nextTick(() => {
          cell.innerText = formattedValue;
          const range = document.createRange();
          range.setStart(
            cell.firstChild || cell,
            Math.min(cursorPosition, formattedValue.length)
          );
          range.collapse(true);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);

          // Validazione
          const teamSystemRegex = /^\d{2}\/\d{2}\/\d{3}$/;
          let isValid =
            formattedValue === "" || teamSystemRegex.test(formattedValue);
          if (this.isCodContoDefault(formattedValue)) {
            isValid = false;
          }

          // Gestione errori
          if (!isValid) {
            this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.errors, `${rowIndex}-${colIndex}`);
          }

          // Salva nel modello dati, normalizzando il valore vuoto
          this.jsonData[rowIndex][colIndex] = formattedValue || "";

          // Flag modified
          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          const currentValue = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== String(currentValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          // Stato unsaved changes
          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
        });
      } else if (this.isTextColumn(colIndex)) {
        this.$nextTick(() => {
          if (cell) {
            // Pulisci cella e inserisci valore
            while (cell.firstChild) cell.removeChild(cell.firstChild);
            cell.textContent = value;

            // Posiziona il cursore alla fine del testo
            const range = document.createRange();
            range.selectNodeContents(cell);
            range.collapse(false); // false = alla fine
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
          }

          // Salva nel modello dati, normalizzando il valore vuoto
          this.jsonData[rowIndex][colIndex] = value || "";

          // Flag modified
          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          const currentValue = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== String(currentValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          // Stato unsaved changes
          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
        });
      } else {
        // Mantieni la posizione del cursore
        const selection = window.getSelection();
        let cursorPosition = selection?.anchorOffset || 0;

        const isDatev = [
          "Cod. Conto DARE - Datev Aziende",
          "Cod. Conto AVERE - Datev Aziende",
          "Cod. Conto DARE - Datev Lib. Prof.",
          "Cod. Conto AVERE - Datev Lib. Prof.",
        ].includes(columnName);
        const numericValue = isDatev
          ? value.replace(/\D/g, "").slice(0, 11)
          : value.replace(/\D/g, "");
        let isValid =
          !isDatev ||
          numericValue.length === 0 ||
          (numericValue.length >= 5 && numericValue.length <= 11);
        if (this.isCodContoDefault(numericValue)) {
          isValid = false;
        }

        this.$nextTick(() => {
          // Aggiorna testo direttamente nel DOM
          if (cell) {
            while (cell.firstChild) cell.removeChild(cell.firstChild);
            cell.textContent = numericValue;
          }

          // Regola posizione cursore
          if (cell && cell.firstChild) {
            const range = document.createRange();
            range.setStart(
              cell.firstChild,
              Math.min(cursorPosition, numericValue.length)
            );
            range.collapse(true);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
          }

          // Validazione e errori
          if (!isValid) {
            this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.errors, `${rowIndex}-${colIndex}`);
          }

          // Aggiorna modello dati, normalizzando il valore vuoto
          this.jsonData[rowIndex][colIndex] = numericValue || "";

          // Flag modified
          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          const currentValue = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== String(currentValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          // Aggiorna stato unsaved changes
          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
        });
      }
    },

    isDataEqual(data1, data2) {
      // Verifica che i dati abbiano la stessa struttura
      if (!data1 || !data2 || data1.length !== data2.length) return false;

      // Converti tutti i valori in stringa, trattando null e undefined come ""
      const stringifyData1 = JSON.stringify(
        data1.map((row) =>
          row.map((cell) =>
            cell !== null && cell !== undefined ? String(cell) : ""
          )
        )
      );
      const stringifyData2 = JSON.stringify(
        data2.map((row) =>
          row.map((cell) =>
            cell !== null && cell !== undefined ? String(cell) : ""
          )
        )
      );
      return stringifyData1 === stringifyData2;
    },
    preventNonNumeric(event, colIndex) {
      // Consenti tutto per le colonne dei nomi conto
      const freeTextColumns = [1, 4, 7, 10];
      if (freeTextColumns.includes(colIndex)) return;

      // Altrimenti blocca tutto tranne numeri e tasti di navigazione
      if (
        !/[0-9]/.test(event.key) &&
        event.key !== "Backspace" &&
        event.key !== "Tab" &&
        event.key !== "ArrowLeft" &&
        event.key !== "ArrowRight"
      ) {
        event.preventDefault(); // Blocca l'input
      }
    },
    isTextColumn(colIndex) {
      const colName = this.headers[colIndex] || "";
      return colName.includes("Descrizione Cod. Conto");
    },
    toggleEditing() {
      if (!this.hasDataRows) {
        this.isEditing = false;
        return;
      }

      if (!this.isEditing) {
        this.isEditing = true;
      }
    },
    toggleTableExpansion() {
      this.isTableExpanded = !this.isTableExpanded;
    },
    toggleTableSaldoExpansion() {
      this.isTableSaldoExpanded = !this.isTableSaldoExpanded;
    },
    toggleTableTributoPCTExpansion() {
      this.isTableTributoPCTExpanded = !this.isTableTributoPCTExpanded;
    },
    toggleTable9001Expansion() {
      this.isTable9001Expanded = !this.isTable9001Expanded;
    },
    toggleTable9001PCTExpansion() {
      this.isTable9001PCTExpanded = !this.isTable9001PCTExpanded;
    },
    toggleInvitiDropdown() {
      this.showInvitiDropdown = !this.showInvitiDropdown;
    },
    isDescrizioneCodContoColumn(headerName) {
      const nomeContoLabels = [
        "Descrizione Cod. Conto",
        "Descrizione Cod. Conto - Datev Aziende",
        "Descrizione Cod. Conto - Datev Lib. Prof.",
        "Descrizione Cod. Conto - TeamSystem",
        "Descrizione Cod. Conto - Zucchetti",
        "Descrizione Cod. Conto - SEAC",
        "Descrizione Cod. Conto - Sistemi",
        "Descrizione - Cod. Conto Default",
      ];
      return nomeContoLabels.includes(headerName);
    },
    handleClickOutside(event) {
      const target = event.target;
      const isArchiveMenuInside = this.$refs.archiveMenuRef?.contains(target);
      const isPctLibraryMenuInside =
        this.$refs.pctLibraryMenuRef?.contains(target);
      const isMainInside =
        this.$refs.exceltableRef?.contains(target) ||
        this.$refs.dashboardRef?.contains(target) ||
        this.$refs.softwareSelect?.contains(target) ||
        isPctLibraryMenuInside;

      const is9001Inside =
        this.$refs.tableRef9001?.contains(target) ||
        this.$refs.tableRef9001Inline?.contains(target) ||
        this.$refs.dashboardRef?.contains(target) ||
        this.$refs.dashboardRef9001?.contains(target);

      const isSaldoFInside =
        this.$refs.tableRefSaldoF?.contains(target) ||
        this.$refs.tableRefSaldoFInline?.contains(target) ||
        this.$refs.dashboardRef?.contains(target) ||
        this.$refs.dashboardRefSaldoF?.contains(target);

      if (this.isEditing && !isMainInside) {
        this.isEditing = false;
        console.log("isEditing resettato a false da handleClickOutside");
      }

      if (this.isEditing9001 && !is9001Inside) {
        this.isEditing9001 = false;
      }

      if (this.isEditingSaldoF && !isSaldoFInside) {
        this.isEditingSaldoF = false;
      }

      if (this.archiveMenuOpen && !isArchiveMenuInside) {
        this.archiveMenuOpen = false;
      }

      if (this.pctLibraryMenuOpen && !isPctLibraryMenuInside) {
        this.pctLibraryMenuOpen = false;
      }
    },
    toggleArchiveMenu() {
      this.archiveMenuOpen = !this.archiveMenuOpen;
    },
    openArchive9001() {
      this.archiveMenuOpen = false;
      this.fetch9001PDC();
    },
    openArchiveSaldoF() {
      this.archiveMenuOpen = false;
      this.fetchsaldofPDC();
    },
    saveChanges(event, skipDeletionConfirmation = false) {
      if (!this.hasUnsavedChanges) {
        this.noChangesMessage = true;
        setTimeout(() => {
          this.noChangesMessage = false;
        }, 2000);
        return;
      }
      // Controlla se ci sono errori attivi nelle celle
      if (Object.keys(this.errors).length > 0) {
        this.erroreModalMessaggio =
          "Correggi i codici conto evidenziati in rosso per salvare le modifiche.";
        this.erroreModalVisibile = true;
        return; // blocca il salvataggio
      }
      const pendingDeletionCount = this.getPendingDeletionCount();
      if (!skipDeletionConfirmation && pendingDeletionCount > 0) {
        this.confirmSaveWithPendingDeletions(pendingDeletionCount, () =>
          this.saveChanges(event, true)
        );
        return;
      }
      const nomeContoIndices = [];
      for (let col = 0; col < this.jsonData[0].length; col++) {
        if (this.jsonData[0][col].includes("Descrizione Cod. Conto")) {
          nomeContoIndices.push(col);
        }
      }
      // Scorre le righe di dati (escludi header) e assegna "NESSUNA CORRELAZIONE" alle celle vuote
      // for (let row = 1; row < this.jsonData.length; row++) {
      //   for (const col of nomeContoIndices) {
      //     const cellValue = this.jsonData[row][col];
      //     if (cellValue === "" || cellValue == null) {
      //       this.jsonData[row][col] = "NESSUNA CORRELAZIONE";
      //     }
      //   }
      // }

      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event && event.target) {
        event.target.style.cursor = "progress";
      }
      console.log("Dati modificati da inviare al backend:", this.jsonData);
      let saveSucceeded = false;
      // Creazione di un nuovo workbook e sheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(this.jsonData);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // Creazione del file Excel in formato blob
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const excelBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Creazione del FormData per l'invio del file
      const formData = new FormData();
      formData.append(
        "file",
        excelBlob,
        "piano_codici_tributo_modificato.xlsx"
      );
      if (this.currentPctIsClient) {
        formData.append("client_key", this.selectedClientPctKey);
      }

      // Invio al backend con axios
      axios
        .post(
          `${API_BASE_URL}${
            this.currentPctIsClient ? "/update_excel/client_pct" : "/save_PCT"
          }`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          saveSucceeded = true;
          console.log("File salvato con successo:", response.data);
          this.successModalMessaggio = "Modifiche salvate con successo!";
          this.successModalVisibile = true;
          this.lastSavedData = JSON.parse(JSON.stringify(this.jsonData));
          this.pendingDeletedRowCount = 0;
          this.modifiedCells = {};
          this.errors = {};
          this.finalizeAllRows();
          this.messageToShow = "dataLoaded"; // Mostra "Dati caricati correttamente"
          return this.fetchClientPctPlans().then(() =>
            this.fetchFileFromBackend()
          );
        })
        .catch((error) => {
          console.error("Errore nel salvataggio del file:", error);
          this.erroreModalMessaggio =
            error.response?.data?.error || "Errore nel salvataggio del file.";
          this.erroreModalVisibile = true;
          this.messageToShow = null;
        })
        .finally(() => {
          document.documentElement.style.cursor = "default";
          document.body.style.cursor = "default";
          if (event && event.target) {
            event.target.style.cursor = "pointer";
          }
          if (saveSucceeded) {
            this.hasUnsavedChanges = false;
            this.refreshDashboard();
          }
        });
    },
    handleSaveBeforeLeave() {
      const fakeEvent = { target: { style: { cursor: "pointer" } } };

      if (this.isLeavingDueTo9001Changes) {
        this.saveChanges9001(fakeEvent);
      } else if (this.isLeavingDueToSaldoFChanges) {
        this.saveChangesSaldoF(fakeEvent);
      } else {
        this.saveChanges(fakeEvent);
      }

      this.showSaveModal = false;
      this.pendingNavigationAfterSuccess = true;
    },
    cancelLeave() {
      this.showSaveModal = false;
      this.nextRoute = null;
    },
    discardChangesAndLeave() {
      if (this.isLeavingDueTo9001Changes) {
        this.cancelChanges9001(); // devi implementarlo se non esiste
        this.modalVisible9001 = false;
      } else if (this.isLeavingDueToSaldoFChanges) {
        this.cancelChangesSaldoF();
        this.modalVisibleSaldoF = false;
      } else {
        this.cancelChanges();
      }

      this.showSaveModal = false;
      this.isLeavingDueTo9001Changes = false;
      this.isLeavingDueToSaldoFChanges = false;

      if (this.nextRoute) {
        const proceed = this.nextRoute;
        this.nextRoute = null;
        proceed();
      }
    },
    resetConfirmModal() {
      this.confirmModalVisibile = false;
      this.confirmModalTitle = "Elimina Piano Codici Tributo";
      this.confirmModalMessaggio = "";
      this.confirmModalShowArchiveOptions = false;
      this.confirmModalConfirmLabel = "Elimina";
      this.confirmModalCancelLabel = "Annulla";
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.delete9001AlongWithPct = false;
      this.deleteSaldoFAlongWithPct = false;
      this.confirmModalDeleteOptions = [];
      this.deletePctTargets = {};
      this.confirmModalCallback = null;
    },
    setPctConfirmDeleteOptions(options = [], selectedKeys = []) {
      const targets = {};
      options.forEach((option) => {
        targets[option.key] = selectedKeys.includes(option.key);
      });
      this.confirmModalDeleteOptions = options;
      this.deletePctTargets = targets;
    },
    getSelectedPctDeleteKeys() {
      return this.confirmModalDeleteOptions
        .filter((option) => this.deletePctTargets?.[option.key])
        .map((option) => option.key);
    },
    getPctDeleteOptions() {
      if (this.currentPctIsClient) {
        return [
          {
            key: "pct",
            label: `Piano Codici Tributo di ${this.selectedClientPctLabel}`,
          },
        ];
      }
      return [
        { key: "pct", label: "Piano Codici Tributo" },
        { key: "archive_9001", label: "Piano Codici Tributo 9001" },
        { key: "archive_saldo", label: "Coordinate Bancarie" },
      ];
    },
    resetDeletedPctState(selectedKeys) {
      if (selectedKeys.includes("pct")) {
        this.jsonData = [];
        this.messageToShow = "noRows";
        this.tableKey += 1;
        this.hasUnsavedChanges = false;
      }
      if (selectedKeys.includes("archive_9001")) {
        this.jsonData9001 = [[]];
        this.lastSavedData9001 = [];
        this.modifiedCells9001 = {};
        this.errors9001 = {};
        this.hasUnsavedChanges9001 = false;
        this.pendingDeletedRows9001Count = 0;
        this.modalVisible9001 = false;
      }
      if (selectedKeys.includes("archive_saldo")) {
        this.jsonDataSaldoF = [[]];
        this.lastSavedDataSaldoF = [];
        this.modifiedCellsSaldoF = {};
        this.errorsSaldoF = {};
        this.hasUnsavedChangesSaldoF = false;
        this.pendingDeletedRowsSaldoFCount = 0;
        this.modalVisibleSaldoF = false;
      }
    },
    getPctDeleteSuccessMessage(selectedKeys) {
      if (this.currentPctIsClient) {
        return `Piano Codici Tributo di ${this.selectedClientPctLabel} eliminato con successo.`;
      }
      const labels = this.getPctDeleteOptions()
        .filter((option) => selectedKeys.includes(option.key))
        .map((option) => option.label);
      return `${labels.join(", ")} eliminati con successo.`;
    },
    openPctDeleteModal(event, selectedFileKey = null) {
      this.setPctConfirmDeleteOptions(this.getPctDeleteOptions(), [
        selectedFileKey || this.selectedPctFileKey,
      ]);
      this.confirmModalTitle = this.currentPctIsClient
        ? "Elimina file cliente"
        : "Elimina file codici tributo";
      this.confirmModalMessaggio = this.currentPctIsClient
        ? `Vuoi eliminare il Piano Codici Tributo di ${this.selectedClientPctLabel}?\nI dati presenti nel file verranno rimossi in modo permanente.`
        : "Seleziona i file da eliminare.\nI dati presenti nei file selezionati verranno rimossi in modo permanente.";
      this.confirmModalShowArchiveOptions = !this.currentPctIsClient;
      this.confirmModalConfirmLabel = "Elimina";
      this.confirmModalCancelLabel = "Annulla";
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.confirmModalVisibile = true;

      this.confirmModalCallback = (confirmed) => {
        const selectedKeys = this.getSelectedPctDeleteKeys();
        this.resetConfirmModal();
        if (!confirmed || selectedKeys.length === 0) return;

        document.documentElement.style.cursor = "progress";
        document.body.style.cursor = "progress";
        if (event?.target) event.target.style.cursor = "progress";

        const deleteRequest = this.currentPctIsClient
          ? axios.post(`${API_BASE_URL}/delete_excel/client_pct`, {
              client_key: this.selectedClientPctKey,
            })
          : axios.post(`${API_BASE_URL}/delete_PCT`, {
              delete_pct: selectedKeys.includes("pct"),
              delete_9001: selectedKeys.includes("archive_9001"),
              delete_saldofinale: selectedKeys.includes("archive_saldo"),
            });

        deleteRequest
          .then(() => {
            this.resetDeletedPctState(selectedKeys);
            this.successModalMessaggio =
              this.getPctDeleteSuccessMessage(selectedKeys);
            this.successModalVisibile = true;
            return this.fetchClientPctPlans().then(() =>
              this.fetchCurrentPctFile()
            );
          })
          .catch((deleteError) => {
            console.error(
              "Errore durante l'eliminazione dei file:",
              deleteError
            );
            this.erroreModalMessaggio =
              deleteError.response?.data?.error ||
              "Errore durante l'eliminazione dei file selezionati.";
            this.erroreModalVisibile = true;
          })
          .finally(() => {
            this.refreshAddBilancino();
            document.documentElement.style.cursor = "default";
            document.body.style.cursor = "default";
            if (event?.target) event.target.style.cursor = "pointer";
          });
      };
    },
    getPendingDeletionCount() {
      return this.pendingDeletedRowCount;
    },
    confirmSaveWithPendingDeletions(count, onConfirm, context = "software") {
      const target =
        context === "archivio"
          ? {
              singular:
                "Con il salvataggio verranno eliminati i dati della riga rimossa dall'archivio.",
              plural:
                "Con il salvataggio verranno eliminati i dati delle righe rimosse dall'archivio.",
            }
          : {
              singular:
                "Con il salvataggio verranno eliminati i dati della riga rimossa per tutti i software contabili.",
              plural:
                "Con il salvataggio verranno eliminati i dati delle righe rimosse per tutti i software contabili.",
            };
      this.confirmModalTitle = "Salva modifiche";
      this.confirmModalMessaggio =
        count === 1
          ? `Tra le modifiche correnti e' inclusa anche l'eliminazione di 1 riga. ${target.singular}`
          : `Tra le modifiche correnti sono incluse anche ${count} eliminazioni di riga. ${target.plural}`;
      this.confirmModalShowArchiveOptions = false;
      this.confirmModalConfirmLabel = "Salva";
      this.confirmModalCancelLabel = "Annulla";
      this.confirmModalConfirmClass = "btn-primary";
      this.confirmModalConfirmIcon = "fa-solid fa-floppy-disk";
      this.delete9001AlongWithPct = false;
      this.deleteSaldoFAlongWithPct = false;
      this.confirmModalVisibile = true;
      this.confirmModalCallback = (confirmed) => {
        this.resetConfirmModal();
        if (confirmed) onConfirm();
      };
    },
    onSuccessModalClosed() {
      this.successModalVisibile = false;

      // Caso navigazione (router)
      if (this.pendingNavigationAfterSuccess && this.nextRoute) {
        const proceed = this.nextRoute;
        this.nextRoute = null;
        proceed();
      }

      // Caso uscita da modal 9001 (se hai un modal dedicato)
      if (this.isLeavingDueTo9001Changes) {
        this.modalVisible9001 = false;
      } else if (this.isLeavingDueToSaldoFChanges) {
        this.modalVisibleSaldoF = false;
      }

      // Reset stati condivisi
      this.pendingNavigationAfterSuccess = false;
      this.isLeavingDueTo9001Changes = false;
      this.isLeavingDueToSaldoFChanges = false;
    },
    mostraSuccesso(msg) {
      this.successModalMessaggio = msg;
      this.successModalVisibile = true;
    },
    mostraErrore(msg) {
      this.erroreModalMessaggio = msg;
      this.erroreModalVisibile = true;
    },
    cancelChanges() {
      if (!this.hasUnsavedChanges) {
        this.noChangesMessage = true;
        setTimeout(() => {
          this.noChangesMessage = false;
        }, 2000);
        return;
      }
      this.jsonData = JSON.parse(JSON.stringify(this.lastSavedData));
      this.tableKey++; // Forza il re-render della tabella
      this.hasUnsavedChanges = false;
      this.pendingDeletedRowCount = 0;
      this.finalizeAllRows();
      this.rebuildCellStates();
      this.refreshDashboard();
    },
    refreshAddRow() {
      this.showAddRow = false;
      this.newRow = Array(this.currentAddRowHeaders.length).fill("");
    },
    openAddRowModal() {
      const headers = this.currentAddRowHeaders;
      if (!headers.length) return;

      if (this.isPct9001View && this.jsonData9001[0]?.length < 9) {
        this.jsonData9001 = [this.default9001Headers];
      }

      this.showAddRow = true;
      this.showAddBilancino = false;
      this.showAddPiano = false;

      if (this.newRow.length !== this.currentAddRowHeaders.length) {
        this.newRow = Array(this.currentAddRowHeaders.length).fill("");
      }

      if (this.isPctArchiveView) {
        this.selectedAddRowSoftwares = [];
        return;
      }

      if (!this.selectedAddRowSoftwares.length) {
        this.selectedAddRowSoftwares = [
          this.selectedSoftwareAddRow || "TEAMSYSTEM",
        ];
      }
    },
    updateSelectedAddRowSoftwares(softwares) {
      this.selectedAddRowSoftwares = softwares;
      if (softwares.length) {
        this.selectedSoftwareAddRow = softwares[0];
      }
    },
    handleAddRowFieldInput({ index, value, format }) {
      if (this.isPctArchiveView) {
        this.$set(
          this.newRow,
          index,
          format ? this.formatArchiveAddRowValue(index, value) : value
        );
        return;
      }

      if (format) {
        this.formatCodiceConto({ target: { value } }, index);
        return;
      }

      this.$set(this.newRow, index, value);
    },
    getArchiveAddRowPlaceholder(index) {
      const header = String(
        this.currentAddRowHeaders[index] || ""
      ).toUpperCase();
      if (header.includes("DATA")) return "GG/MM/AAAA";
      if (header.includes("SALDO")) return "0,00";
      if (header === "IBAN") return "IT00-X-00000-00000-000000000000";
      if (header.includes("ABI") || header.includes("CAB")) return "00000";
      if (header.includes("COD. CONTO")) return "Codice conto";
      if (header.includes("TRIBUTO")) return "9001";
      if (header.includes("FISCALE")) return "Codice fiscale";
      return "Inserisci valore";
    },
    getArchiveAddRowTitle(index) {
      const header = this.currentAddRowHeaders[index] || `Colonna ${index + 1}`;
      return `Inserisci ${header}`;
    },
    isArchiveAddRowRequired(index) {
      if (this.isPct9001View) {
        return index < 4;
      }
      if (this.isPctSaldoFView) {
        return [
          "Denominazione Cliente",
          "Codice Fiscale",
          "Codice ABI",
          "Codice CAB",
        ].includes(this.currentAddRowHeaders[index]);
      }
      return false;
    },
    isArchiveAddRowFormatted(index) {
      const header = String(
        this.currentAddRowHeaders[index] || ""
      ).toUpperCase();
      return (
        header === "IBAN" ||
        header === "CODICE FISCALE" ||
        header.includes("ABI") ||
        header.includes("CAB") ||
        header.includes("COD. CONTO") ||
        header.includes("CODICE TRIBUTO")
      );
    },
    formatArchiveAddRowValue(index, value) {
      if (this.currentAddRowHeaders[index] === "IBAN")
        return formatItalianIban(value);
      if (this.currentAddRowHeaders[index] === "Codice Fiscale")
        return String(value || "")
          .trim()
          .toUpperCase();
      const header = String(
        this.currentAddRowHeaders[index] || ""
      ).toUpperCase();
      if (header.includes("CODICE TRIBUTO")) {
        return String(value || "")
          .replace(/\D/g, "")
          .slice(0, 4);
      }
      if (header.includes("ABI") || header.includes("CAB")) {
        return String(value || "")
          .replace(/\D/g, "")
          .slice(0, 5);
      }
      if (header.includes("COD. CONTO")) {
        return this.formatArchiveAccountCode(value, header);
      }
      return value;
    },
    formatArchiveAccountCode(value, header) {
      let numeric = String(value || "").replace(/\D/g, "");
      const normalizedHeader = String(header || "").toUpperCase();

      if (normalizedHeader.includes("TEAMSYSTEM")) {
        numeric = numeric.slice(0, 7);
        if (numeric.length >= 5) {
          return `${numeric.slice(0, 2)}/${numeric.slice(2, 4)}/${numeric.slice(
            4
          )}`;
        }
        if (numeric.length >= 3) {
          return `${numeric.slice(0, 2)}/${numeric.slice(2)}`;
        }
        return numeric;
      }
      if (normalizedHeader.includes("SISTEMI")) {
        numeric = numeric.slice(0, 9);
        if (numeric.length >= 7) {
          return `${numeric.slice(0, 2)}.${numeric.slice(2, 4)}.${numeric.slice(
            4,
            6
          )}.${numeric.slice(6)}`;
        }
        if (numeric.length >= 5) {
          return `${numeric.slice(0, 2)}.${numeric.slice(2, 4)}.${numeric.slice(
            4
          )}`;
        }
        if (numeric.length >= 3) {
          return `${numeric.slice(0, 2)}.${numeric.slice(2)}`;
        }
        return numeric;
      }
      if (normalizedHeader.includes("SEAC")) {
        return numeric.slice(0, 6);
      }
      if (normalizedHeader.includes("DATEV")) {
        return numeric.slice(0, 11);
      }
      return numeric;
    },
    refreshAddBilancino() {
      this.vettoreCodTributo = [];
      this.ExcelRows = [];
      this.showResult = false;
      this.showAddBilancino = false;
      this.isShifted = false;
      if (this.$refs.bilancinoInput) {
        this.$refs.bilancinoInput.value = "";
      }
      this.F24File = null;
      this.filePDF_URL = null;
      this.input_PC = "";
      this.output_PC = "";
      this.editPDCresponse = false;
      this.calculating = false;
      this.calculating2 = false;
      this.isEditModePCT = false;
      this.originalPCT = [];
      this.original9001PCT = [];
      this.isEditMode9001PCT = false;
      this.vettoreCodTributoPCT = [];
      this.vettoreCodTributo9001 = [];
      this.vettoreCodTributo9001_PCT = [];
      this.vettorePCTVisible = false;
      this.isTableExpanded = false;
      this.isTableTributoPCTExpanded = false;
      this.isTable9001Expanded = false;
      this.isTableSaldoExpanded = false;
      this.currentSubPhase = "A";
      this.resetSubPhaseState();
      this.loadUserPreferredSoftware();
    },
    isStaleScanRequest(requestId) {
      return requestId !== this.activeScanRequestId;
    },
    openScanResetConfirm(mode = "full") {
      this.pendingScanResetMode = mode;
      this.showScanResetConfirmModal = true;
    },
    async confirmScanReset() {
      this.showScanResetConfirmModal = false;
      this.isResettingScan = true;
      this.activeScanRequestId += 1;
      this.clearDelayMessageTimer();
      this.resetScanState(this.pendingScanResetMode === "full");
      await new Promise((resolve) => setTimeout(resolve, 280));
      this.isResettingScan = false;
      this.pendingScanResetMode = "full";
    },
    resetScanState(clearFile = true) {
      this.vettoreCodTributo = [];
      this.vettoreCodTributoPCT = [];
      this.vettoreCodTributo9001 = [];
      this.vettoreCodTributo9001_PCT = [];
      this.ExcelRows = [];
      this.isShifted = false;
      this.input_PC = "";
      this.output_PC = "";
      this.errorMessage = "";
      this.showErrorModal = false;
      if (clearFile) {
        this.F24File = null;
        this.filePDF_URL = null;
      }
      if (clearFile && this.$refs.bilancinoInput) {
        this.$refs.bilancinoInput.value = "";
      }
      this.showResult = false;
      this.editPDCresponse = false;
      this.calculating = false;
      this.calculating2 = false;
      this.resetSubPhaseState();
      this.loadUserPreferredSoftware();
    },
    refreshConversione() {
      if (this.calculating || this.calculating2) {
        this.openScanResetConfirm("full");
        return;
      }
      this.resetScanState(true);
    },
    refreshConversione2() {
      if (this.calculating || this.calculating2) {
        this.openScanResetConfirm("soft");
        return;
      }
      this.resetScanState(false);
    },
    deleteRow(rowIndex, event) {
      this.performDeleteRow(rowIndex, event);
    },
    performDeleteRow(rowIndex, event) {
      // 🔹 Imposta il cursore su "wait" su tutto il documento (HTML + Body)
      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event?.target) event.target.style.cursor = "progress"; // Anche sul pulsante
      // Mostra il messaggio di eliminazione per la riga specifica
      this.deletedRows = { ...this.deletedRows, [rowIndex]: true };
      // Attiva la classe per rendere il pulsante rosso
      this.$set(this.activeDelete, rowIndex, true);
      const isProvisionalRow = this.provisionalRows.includes(rowIndex);
      if (!isProvisionalRow) {
        this.pendingDeletedRowCount += 1;
      }

      setTimeout(() => {
        // 1) rimuovi i dati
        this.jsonData.splice(rowIndex, 1);

        // 2) reset stati locali
        this.hoveredRow = null;
        // --- ricostruzione modifiedCells ---
        const newModified = {};
        Object.keys(this.modifiedCells).forEach((key) => {
          const [r, c] = key.split("-").map(Number);
          if (r === rowIndex) return;
          const newRow = r > rowIndex ? r - 1 : r;
          newModified[`${newRow}-${c}`] = this.modifiedCells[key];
        });
        this.modifiedCells = newModified;

        // --- ricostruzione errors ---
        const newErrors = {};
        Object.keys(this.errors).forEach((key) => {
          const [r, c] = key.split("-").map(Number);
          if (r === rowIndex) return;
          const newRow = r > rowIndex ? r - 1 : r;
          newErrors[`${newRow}-${c}`] = this.errors[key];
        });
        this.errors = newErrors;
        this.$delete(this.deletedRows, rowIndex);
        this.$delete(this.activeDelete, rowIndex);

        // 3) forzatura rerender
        this.tableKey++;

        // 4) unsaved changes
        this.hasUnsavedChanges =
          !this.isDataEqual(this.jsonData, this.lastSavedData) || true;
        if (!this.hasDataRows) {
          this.isEditing = false;
        }

        // 5) cursore default
        document.documentElement.style.cursor = "default";
        document.body.style.cursor = "default";
        if (event?.target) event.target.style.cursor = "pointer";
      }, 700);
    },
    deleteAllExceptFirst(event) {
      this.confirmModalTitle = "Elimina Piano Codici Tributo";
      this.confirmModalShowArchiveOptions = true;
      this.delete9001AlongWithPct = false;
      this.deleteSaldoFAlongWithPct = false;
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      // Mostra il modal di conferma
      this.confirmModalMessaggio =
        "Sei sicuro di voler eliminare il Piano Codici Tributo?\nTutti i dati salvati andranno persi";
      this.confirmModalVisibile = true;
      this.confirmModalCallback = (confirmed) => {
        const delete9001AlongWithPct = this.delete9001AlongWithPct;
        const deleteSaldoFAlongWithPct = this.deleteSaldoFAlongWithPct;
        if (confirmed) {
          // L'utente ha cliccato "Sì"
          document.documentElement.style.cursor = "progress";
          document.body.style.cursor = "progress";
          event.target.style.cursor = "progress";

          axios
            .post(`${API_BASE_URL}/delete_PCT`, {
              delete_9001: delete9001AlongWithPct,
              delete_saldofinale: deleteSaldoFAlongWithPct,
            })
            .then((deleteResponse) => {
              console.log(
                "Risposta eliminazione file:",
                deleteResponse.data.message
              );
              // Svuota jsonData e aggiorna la tabella
              this.jsonData = [];
              this.messageToShow = "noRows"; // Mostra "Nessun codice tributo presente"
              this.tableKey += 1; // Forza il re-render della tabella
              if (delete9001AlongWithPct) {
                this.jsonData9001 = [[]];
                this.lastSavedData9001 = [];
                this.modifiedCells9001 = {};
                this.errors9001 = {};
                this.hasUnsavedChanges9001 = false;
                this.pendingDeletedRows9001Count = 0;
                this.modalVisible9001 = false;
              }

              if (deleteSaldoFAlongWithPct) {
                this.jsonDataSaldoF = [[]];
                this.lastSavedDataSaldoF = [];
                this.modifiedCellsSaldoF = {};
                this.errorsSaldoF = {};
                this.hasUnsavedChangesSaldoF = false;
                this.pendingDeletedRowsSaldoFCount = 0;
                this.modalVisibleSaldoF = false;
              }

              if (delete9001AlongWithPct && deleteSaldoFAlongWithPct) {
                this.successModalMessaggio =
                  "Piano Codici Tributo, archivio 9001 e Coordinate Bancarie eliminati con successo!";
              } else if (delete9001AlongWithPct) {
                this.successModalMessaggio =
                  "Piano Codici Tributo e archivio 9001 eliminati con successo!";
              } else if (deleteSaldoFAlongWithPct) {
                this.successModalMessaggio =
                  "Piano Codici Tributo e Coordinate Bancarie eliminati con successo!";
              } else {
                this.successModalMessaggio =
                  "Piano Codici Tributo eliminato con successo!";
              }
              this.successModalVisibile = true;
              this.hasUnsavedChanges = false;
            })
            .catch((deleteError) => {
              console.error(
                "Errore durante l'eliminazione del file:",
                deleteError
              );
              if (deleteError.response?.status === 500) {
                alert(
                  "Errore durante l'eliminazione del file Modelli F24 - Piano Codici Tributo.xlsx: " +
                    (deleteError.response?.data?.error || "Errore sconosciuto")
                );
              }
            })
            .finally(() => {
              this.refreshAddBilancino();
              document.documentElement.style.cursor = "default";
              document.body.style.cursor = "default";
              event.target.style.cursor = "pointer";
            });
        }
        // Chiudi il modal in ogni caso
        this.resetConfirmModal();
      };
    },
    // Impostazione del pattern per i campi add row
    getPattern(index) {
      if (index === 2) {
        // Codice Conto TeamSystem
        return "\\d{2}/\\d{2}/\\d{3}"; // Regex per il formato "XX/XX/XXX"
      } else if (index === 6) {
        // Codice Conto SEAC
        return "\\d{6}"; // Esattamente 6 cifre
      } else if (index === 7) {
        // Codice Conto Sistemi
        return "\\d{2}\\.\\d{2}\\.\\d{2}(\\.\\d{3})?"; // Formato XX.XX.XX o XX.XX.XX.XXX
      } else if (index === 3 || index === 4) {
        // Codice Conto Datev
        return "\\d{5,11}"; // Da 5 a 11 cifre
      } else if (index === 5) {
        // Altri Codici Conto (Zucchetti, etc.)
        return "^\\d+$"; // Solo numeri interi
      }
      return "";
    },
    onlyNumbers(event, index) {
      let value = event.target.value.replace(/\D/g, ""); // Rimuove tutti i caratteri non numerici
      if (index === 3 || index === 4) value = value.slice(0, 11);
      // Impostiamo il valore del campo solo con numeri
      this.newRow[index] = value;
      // Aggiorniamo il valore nel campo di input
      event.target.value = value;
    },
    // Messaggio di errore in caso di inserimento non valido
    getErrorMessage(index) {
      if (index === 2) {
        return "Il formato del Codice Conto TeamSystem deve essere: XX/XX/XXX.";
      } else if (index === 3 || index === 4) {
        return "Il Codice Conto Datev deve essere un numero da 5 a 11 cifre";
      } else if (index === 5) {
        return "Il Codice Conto Zucchetti deve essere un numero";
      } else if (index === 6) {
        return "Il Codice Conto SEAC deve essere un numero";
      } else if (index === 7) {
        return "Il Codice Conto Sistemi deve essere un numero";
      } else if (index === 0) {
        return "Inserisci la descrizione del codice conto.";
      } else if (index === 1) {
        return "Selezona il software contabile associato alla descrizione.";
      }
      return "";
    },
    // Placeholder per i campi
    getPlaceholder(index) {
      if (index === 2) {
        return "Codice Conto"; // Placeholder per Codice Conto TeamSystem
      } else if (
        index === 1 ||
        index === 4 ||
        index === 7 ||
        index === 10 ||
        index === 13 ||
        index === 16
      ) {
        return "Descrizione Cod. Conto"; // Placeholder per Descrizione Codice Conto
      } else if (index === 0) {
        return "Cod. Tributo"; // Placeholder per Descrizione Codice Conto
      } else if (
        index === 3 ||
        index === 5 ||
        index === 6 ||
        index === 8 ||
        index === 9 ||
        index === 11 ||
        index === 12 ||
        index === 14 ||
        index === 15 ||
        index === 17 ||
        index === 18
      ) {
        return "Codice Conto"; // Placeholder per gli altri Codici Conto
      }
      return "";
    },

    validateRow() {
      const errors = [];

      // === REGEX ===
      const teamSystemRegex = /^\d{2}\/\d{2}\/\d{3}$/;
      const numberRegex = /^\d+$/;
      const seacRegex = /^\d{6}$/;
      const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;

      // === UTILITY ===
      const isNA = (val) => val && val.trim().toUpperCase() === "N.A.";

      // === LABELS ===
      const teamSystemLabels = {
        2: "Codice Conto Dare TeamSystem",
        3: "Codice Conto Avere TeamSystem",
      };

      const codiceContoLabels = {
        5: "Cod. Conto DARE Datev - Aziende",
        6: "Cod. Conto AVERE Datev - Aziende",
        8: "Cod. Conto DARE Datev - Lib. Prof.",
        9: "Cod. Conto AVERE Datev - Lib. Prof.",
        11: "Cod. Conto DARE - Zucchetti",
        12: "Cod. Conto AVERE - Zucchetti",
        14: "Cod. Conto DARE - SEAC",
        15: "Cod. Conto AVERE - SEAC",
        17: "Cod. Conto DARE - Sistemi",
        18: "Cod. Conto AVERE - Sistemi",
      };

      Object.entries({ ...teamSystemLabels, ...codiceContoLabels }).forEach(
        ([index, label]) => {
          const value = (this.newRow[index] || "").trim();
          if (value && !isNA(value) && this.isCodContoDefault(value)) {
            errors.push(
              `- ${label}: il codice conto ${this.codContoDefault} e riservato e non puo essere salvato.`
            );
          }
        }
      );

      // === VALIDAZIONE COPPIE DARE/AVERE ===
      const validatePair = (
        dareIdx,
        avereIdx,
        labelObj,
        formatCheckFn = null
      ) => {
        const dareVal = (this.newRow[dareIdx] || "").trim();
        const avereVal = (this.newRow[avereIdx] || "").trim();

        const isFilled = (v) => !!v && !isNA(v);
        const isEmpty = (v) => !v;
        const isNaVal = (v) => isNA(v);

        // Controllo formato
        if (formatCheckFn) {
          if (dareVal && !isNA(dareVal) && !formatCheckFn(dareVal)) {
            errors.push(`• Formato errato in "${labelObj[dareIdx]}"`);
          }
          if (avereVal && !isNA(avereVal) && !formatCheckFn(avereVal)) {
            errors.push(`• Formato errato in "${labelObj[avereIdx]}"`);
          }
        }

        const filledCount = [dareVal, avereVal].filter(isFilled).length;
        const naCount = [dareVal, avereVal].filter(isNaVal).length;
        const emptyCount = [dareVal, avereVal].filter(isEmpty).length;

        // Entrambi N.A. → non valido
        if (naCount === 2) {
          errors.push(
            `• Non puoi assegnare "N.A." su entrambi i Cod. Conto per ${
              labelObj[dareIdx].split(" - ")[1] || "questo sistema"
            }`
          );
        }

        // Se uno è compilato e l'altro vuoto → errore specifico
        if (filledCount + naCount >= 1 && emptyCount >= 1) {
          const missingIdx =
            isFilled(dareVal) || isNaVal(dareVal) ? avereIdx : dareIdx;
          errors.push(
            `• Devi compilare o assegnare "N.A." anche a "${labelObj[missingIdx]}"`
          );
        }
      };

      // === VALIDAZIONE SPECIFICA SISTEMI ===
      validatePair(2, 3, teamSystemLabels, (v) => teamSystemRegex.test(v));
      validatePair(11, 12, codiceContoLabels, (v) => numberRegex.test(v));
      validatePair(14, 15, codiceContoLabels, (v) => seacRegex.test(v));
      validatePair(17, 18, codiceContoLabels, (v) => sistemiRegex.test(v));

      // === DATEV (regole speciali) ===
      const datevIndices = [5, 6, 8, 9];
      const datevValues = datevIndices.map((i) =>
        (this.newRow[i] || "").trim()
      );
      const datevFilled = datevValues.filter((v) => v && !isNA(v)).length;
      const datevNA = datevValues.filter(isNA).length;

      datevIndices.forEach((i) => {
        const val = (this.newRow[i] || "").trim();
        if (val && !isNA(val)) {
          if (!numberRegex.test(val)) {
            errors.push(
              `• "${codiceContoLabels[i]}" deve contenere solo numeri`
            );
          } else if (val.length < 5 || val.length > 11) {
            errors.push(
              `• "${codiceContoLabels[i]}" deve avere da 5 a 11 cifre`
            );
          }
        }
      });

      if (datevFilled > 0 || datevNA > 0) {
        datevIndices.forEach((i) => {
          if (!(this.newRow[i] || "").trim()) {
            errors.push(
              `• Se usi Datev, "${codiceContoLabels[i]}" è obbligatorio (compila o N.A.)`
            );
          }
        });
      }

      // === CAMPPI OBBLIGATORI GENERALI ===
      if (!this.newRow[0]?.trim()) {
        errors.push("• Il campo 'Cod. Tributo' è obbligatorio.");
      }

      const codTributo = this.newRow[0]?.trim() || "";
      if (
        codTributo &&
        this.jsonData.slice(1).some((row) => row[0]?.trim() === codTributo)
      ) {
        errors.push("• Il Codice Tributo inserito esiste già.");
      }

      const hasDescription = [1, 4, 7, 10, 13, 16].some((i) =>
        this.newRow[i]?.trim()
      );
      if (!hasDescription) {
        errors.push("• Inserisci almeno una Descrizione Codice Conto.");
      }

      // === CONTROLLO FINALE: almeno una coppia valida ===
      // Non ripetere se ci sono già errori di coppia incompleta
      const hasIncompletePairError = errors.some((e) =>
        e.includes("Devi compilare o assegnare")
      );

      if (!hasIncompletePairError) {
        const hasValidPair = [
          [2, 3], // TeamSystem
          [11, 12], // Zucchetti
          [14, 15], // SEAC
          [17, 18], // Sistemi
        ].some(([d, a]) => {
          const dv = (this.newRow[d] || "").trim();
          const av = (this.newRow[a] || "").trim();
          const isDvFilled = dv && !isNA(dv);
          const isAvFilled = av && !isNA(av);
          return isDvFilled || isAvFilled; // almeno un lato compilato → valido
        });

        if (!hasValidPair && datevFilled === 0 && datevNA === 0) {
          errors.push(
            "• Inserisci almeno un Codice Conto completo (Dare/Avere)."
          );
        }
      }

      // === ESITO ===
      if (errors.length > 0) {
        this.erroreModalMessaggio = errors.join("\n");
        this.erroreModalVisibile = true;
        return false;
      }

      return true;
    },

    toggleEditMode() {
      this.isEditMode = !this.isEditMode; // Toggle edit mode
    },
    toggleEditModePCT() {
      this.isEditModePCT = !this.isEditModePCT; // Toggle edit mode
    },
    attemptClose9001Modal() {
      if (!this.hasUnsavedChanges9001) {
        this.modalVisible9001 = false; // sostituisci con il nome reale della prop v-if
        return;
      }

      this.isLeavingDueTo9001Changes = true;
      this.showSaveModal = true;
    },
    attemptCloseSaldoFModal() {
      if (!this.hasUnsavedChangesSaldoF) {
        this.modalVisibleSaldoF = false;
        return;
      }

      this.isLeavingDueToSaldoFChanges = true;
      this.showSaveModal = true;
    },
    hasDescrizioneContoValue() {
      // Indici delle colonne "Descrizione Cod. Conto"
      const descrizioneColumns = [1, 4, 7, 10, 13, 16];

      return this.vettoreCodTributo.some((row) =>
        descrizioneColumns.some((colIndex) => {
          const val = row[colIndex];
          return (
            val && val !== "None" && val !== "Descrizione - Cod. Conto Default"
          );
        })
      );
    },
    blockLetters(event, rowIndex, colKey, colIndex) {
      const headerName = this.filteredHeaders[colIndex]; // o filteredHeaders
      if (!headerName || !headerName.includes("Cod. conto")) {
        return; // ← NON fare nulla → permetti tutto
      }
      const currentValue = this.vettoreCodTributo[rowIndex][colKey] || "";
      const hasNumbers = /\d/.test(currentValue);
      // === Gestione speciale per Backspace/Delete su "N.A." ===
      if (
        currentValue === "N.A." &&
        (event.key === "Backspace" || event.key === "Delete")
      ) {
        event.preventDefault(); // Blocca il comportamento di default
        this.$set(this.vettoreCodTributo[rowIndex], colKey, ""); // Svuota la cella
        return; // Esci subito
      }
      if (hasNumbers) {
        const key = event.key;
        const allowed = [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End",
        ];

        if (event.ctrlKey || event.metaKey) return;

        if (!allowed.includes(key) && !/[0-9]/.test(key)) {
          event.preventDefault();
        }
      }
    },
    blockPaste(event, colIndex) {
      const headerName = this.filteredHeaders[colIndex];
      if (!headerName || !headerName.includes("Cod. conto")) {
        return;
      }
      event.preventDefault();
      const pasted = (event.clipboardData || window.clipboardData).getData(
        "text"
      );
      const numbersOnly = pasted.replace(/\D/g, "");
      document.execCommand("insertText", false, numbersOnly);
    },
    isPCTModified() {
      if (!this.originalPCT) return false;
      if (this.vettoreCodTributoPCT.length !== this.originalPCT.length)
        return true;

      for (let i = 0; i < this.vettoreCodTributoPCT.length; i++) {
        for (let j = 0; j < this.vettoreCodTributoPCT[i].length; j++) {
          if (this.vettoreCodTributoPCT[i][j] !== this.originalPCT[i][j]) {
            return true;
          }
        }
      }
      return false;
    },
    is9001PCTModified() {
      if (!this.original9001PCT) return false;
      if (this.vettoreCodTributo9001_PCT.length !== this.original9001PCT.length)
        return true;

      for (let i = 0; i < this.vettoreCodTributo9001_PCT.length; i++) {
        for (let j = 0; j < this.vettoreCodTributo9001_PCT[i].length; j++) {
          if (
            this.vettoreCodTributo9001_PCT[i][j] !== this.original9001PCT[i][j]
          ) {
            return true;
          }
        }
      }
      return false;
    },
    validateInput(rowIndex, colIndex, vector) {
      // Se non passi vector → fallback su vettoreCodTributo (per compatibilità vecchia chiamata)
      if (!vector) {
        vector = this.vettoreCodTributo;
      }

      // Mappa colonna visibile → indice reale nel vettore
      // ATTENZIONE: se per PCT hai una mappa diversa, devi adattare qui sotto
      // Per ora assumiamo che usi la stessa visibleColumnsaddf24 (se non è così, crea visibleColumnsPCT)
      const realColIndex = this.visibleColumnsaddf24?.[colIndex] ?? colIndex;

      const columnName = this.headers?.[realColIndex] || "";
      if (!columnName) return;

      let value = vector[rowIndex][realColIndex];
      if (value == null) return; // cella vuota → non fare nulla

      value = String(value).trim();

      const isNomeConto = [
        "Descrizione Cod. Conto - TeamSystem",
        "Descrizione Cod. Conto - Datev",
        "Descrizione Cod. Conto - Zucchetti",
        "Descrizione Cod. Conto - SEAC",
        "Descrizione Cod. Conto - Sistemi",
      ].includes(columnName);

      if (isNomeConto) return; // nessuna limitazione su descrizioni

      // === Gestione robusta di "N.A." ===
      const onlyLetters = value.replace(/[^a-zA-Z]/g, "").toLowerCase();
      if (onlyLetters === "na") {
        const onlyNumbers = value.replace(/\D/g, "");
        if (onlyNumbers.length > 0) {
          value = onlyNumbers;
        } else {
          vector[rowIndex][realColIndex] = "N.A.";
          return;
        }
      }

      const startsWithLetter = /^[A-Za-z]/.test(value);
      const startsWithDigit = /^\d/.test(value);

      // Se contiene lettere in campo numerico → forza "N.A."
      if (/[a-zA-Z]/.test(value) && !isNomeConto) {
        vector[rowIndex][realColIndex] = "N.A.";
        return;
      }

      // TEAMSYSTEM - Codici Dare/Avere
      if (
        columnName === "Cod. Conto DARE - TeamSystem" ||
        columnName === "Cod. Conto AVERE - TeamSystem"
      ) {
        if (startsWithDigit) {
          value = value.replace(/[^0-9]/g, "");
          if (value.length > 2)
            value = value.slice(0, 2) + "/" + value.slice(2);
          if (value.length > 5)
            value = value.slice(0, 5) + "/" + value.slice(5);
          value = value.slice(0, 9);
        } else if (startsWithLetter) {
          value = value.replace(/[^A-Za-z.]/g, "");
        } else {
          value = "";
        }
      }

      // SEAC - Codici Dare/Avere
      else if (
        columnName === "Cod. Conto DARE - SEAC" ||
        columnName === "Cod. Conto AVERE - SEAC"
      ) {
        if (startsWithDigit) {
          value = value.replace(/\D/g, "").slice(0, 6);
        }
      }

      // SISTEMI - Codici Dare/Avere
      else if (
        columnName === "Cod. Conto DARE - Sistemi" ||
        columnName === "Cod. Conto AVERE - Sistemi"
      ) {
        if (startsWithDigit) {
          value = value.replace(/[^0-9]/g, "").slice(0, 9);
          if (value.length > 2)
            value = value.slice(0, 2) + "." + value.slice(2);
          if (value.length > 5)
            value = value.slice(0, 5) + "." + value.slice(5);
          if (value.length > 8)
            value = value.slice(0, 8) + "." + value.slice(8);
        }
      }

      // DATEV / ZUCCHETTI - Codici Dare/Avere
      else if (
        columnName.includes("Datev") ||
        columnName.includes("Zucchetti")
      ) {
        if (startsWithDigit) {
          value = value.replace(/\D/g, "");
        } else if (startsWithLetter) {
          value = value.replace(/[^A-Za-z.]/g, "");
        } else {
          value = "";
        }
      }

      // ALTRO: solo numeri
      else {
        value = value.replace(/\D/g, "");
      }

      // Salva il valore pulito nel vettore corretto
      vector[rowIndex][realColIndex] = value;

      // Sincronizzazione DATEV se necessario (solo su vettoreCodTributo)
      if (this.output_PC === "DATEV" && vector === this.vettoreCodTributo) {
        if (realColIndex === 4) {
          vector[rowIndex][7] = value;
        } else if (realColIndex === 7) {
          vector[rowIndex][4] = value;
        }
      }
    },
    addRow() {
      if (this.isPct9001View) {
        this.addRow9001Archive();
        return;
      }
      if (this.isPctSaldoFView) {
        this.addRowSaldoFArchive();
        return;
      }

      if (this.validateRow()) {
        const insertIndex = 1;

        // Se è selezionato "DATEV AZIENDE", copia il valore anche nell'indice 7
        if (this.selectedAddRowSoftwares.includes("DATEV")) {
          this.newRow[7] = this.newRow[4];
        }

        // Inserisci la nuova riga subito dopo l’intestazione
        this.jsonData.splice(insertIndex, 0, [...this.newRow]);

        // Aggiusta indici delle righe provvisorie e celle modificate
        this.provisionalRows = this.provisionalRows.map((index) =>
          index >= insertIndex ? index + 1 : index
        );
        this.provisionalRows.push(insertIndex);

        this.errors = this.shiftObjectKeys(this.errors, insertIndex);
        this.modifiedCells = this.shiftObjectKeys(
          this.modifiedCells,
          insertIndex
        );

        // 🔁 Allinea il filtro "principale" a quello scelto nel selettore addRow
        this.syncSoftwareSelection();

        // Reset dei valori
        this.newRow = new Array(this.jsonData[0].length).fill("");
        this.showAddRow = false;

        this.hasUnsavedChanges = !this.isDataEqual(
          this.jsonData,
          this.lastSavedData
        );
        this.tableKey += 1;
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    addRow9001Archive() {
      if (!this.validateArchiveAddRow()) return;

      const insertIndex = 1;
      const row = [...this.newRow];
      this.jsonData9001.splice(insertIndex, 0, row);
      this.modifiedCells9001 = this.shiftObjectKeys(
        this.modifiedCells9001,
        insertIndex
      );
      this.currentAddRowHeaders.forEach((_, index) => {
        this.$set(this.modifiedCells9001, `${insertIndex}-${index}`, true);
      });
      this.newRow = Array(this.currentAddRowHeaders.length).fill("");
      this.showAddRow = false;
      this.archive9001Missing = false;
      this.hasUnsavedChanges9001 = !this.isDataEqual(
        this.jsonData9001,
        this.lastSavedData9001
      );
      this.tableKey9001 += 1;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    addRowSaldoFArchive() {
      if (!this.validateArchiveAddRow()) return;
      const idIndex = this.currentAddRowHeaders.indexOf("ID Associazione");
      const ibanIndex = this.currentAddRowHeaders.indexOf("IBAN");
      this.$set(
        this.newRow,
        idIndex,
        newBankId(
          new Set(this.jsonDataSaldoF.slice(1).map((row) => row[idIndex]))
        )
      );

      const insertIndex = 1;
      const row = [...this.newRow];
      if (ibanIndex >= 0) row[ibanIndex] = normalizeIban(row[ibanIndex]);
      this.jsonDataSaldoF.splice(insertIndex, 0, row);
      this.modifiedCellsSaldoF = this.shiftObjectKeys(
        this.modifiedCellsSaldoF,
        insertIndex
      );
      this.currentAddRowHeaders.forEach((_, index) => {
        this.$set(this.modifiedCellsSaldoF, `${insertIndex}-${index}`, true);
      });
      this.newRow = Array(this.currentAddRowHeaders.length).fill("");
      this.showAddRow = false;
      this.archiveSaldoFMissing = false;
      this.hasUnsavedChangesSaldoF = !this.isDataEqual(
        this.jsonDataSaldoF,
        this.lastSavedDataSaldoF
      );
      this.tableKeySaldoF += 1;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    validateArchiveAddRow() {
      const errors = [];
      if (this.isPct9001View && !validFiscalCode(this.newRow[1])) {
        errors.push(
          "Codice Fiscale non valido: inserisci 11 cifre o 16 caratteri alfanumerici."
        );
      }
      if (this.isPctSaldoFView) {
        const headers = this.currentAddRowHeaders;
        const archiveHeaders = this.jsonDataSaldoF[0] || headers;
        errors.push(
          ...bankErrors(
            this.newRow[headers.indexOf("Codice Fiscale")],
            this.newRow[headers.indexOf("Codice ABI")],
            this.newRow[headers.indexOf("Codice CAB")],
            this.newRow[headers.indexOf("IBAN")]
          )
        );
        errors.push(
          ...bankAccountConflictErrors([
            ...this.jsonDataSaldoF
              .slice(1)
              .map((row) => bankRowFromArray(archiveHeaders, row)),
            bankRowFromArray(headers, this.newRow),
          ])
        );
      }
      this.currentAddRowBaseFields.forEach((field) => {
        if (!field.required) return;
        if (!String(this.newRow[field.index] || "").trim()) {
          errors.push(`â€¢ ${field.label} mancante.`);
        }
      });

      if (errors.length) {
        this.erroreModalMessaggio = errors.join("\n");
        this.erroreModalVisibile = true;
        return false;
      }

      this.currentAddRowHeaders.forEach((header, index) => {
        if (this.isArchiveAddRowFormatted(index)) {
          this.$set(
            this.newRow,
            index,
            this.formatArchiveAddRowValue(index, this.newRow[index])
          );
        } else if (
          String(header || "")
            .toUpperCase()
            .includes("FISCALE")
        ) {
          this.$set(
            this.newRow,
            index,
            String(this.newRow[index] || "").toUpperCase()
          );
        }
      });

      return true;
    },
    shiftObjectKeys(map, insertedAtRowIndex) {
      const shifted = {};
      for (const key in map) {
        const [row, col] = key.split("-").map(Number);
        if (row >= insertedAtRowIndex) {
          shifted[`${row + 1}-${col}`] = map[key];
        } else {
          shifted[key] = map[key];
        }
      }
      return shifted;
    },
    syncSoftwareSelection() {
      if (this.selectedSoftware === "ALL") {
        return;
      }

      const mappa = {
        TEAMSYSTEM: "TEAMSYSTEM",
        DATEV: "DATEV",
        ZUCCHETTI: "ZUCCHETTI",
        SEAC: "SEAC",
        SISTEMI: "SISTEMI",
      };
      const nuovoSoftware = mappa[this.selectedSoftwareAddRow];
      if (nuovoSoftware && this.selectedSoftware !== nuovoSoftware) {
        this.selectedSoftware = nuovoSoftware;
      }
    },
    finalizeAllRows() {
      this.provisionalRows = [];
    },
    // Funzione per annullare l'aggiunta della riga
    cancelAddRow() {
      this.newRow = new Array(this.jsonData[0].length).fill(""); // Reset del newRow
    },
    downloadPDC() {
      const isClientPct = this.currentPctIsClient;
      const requestConfig = {
        responseType: "arraybuffer",
      };
      if (isClientPct) {
        requestConfig.params = {
          client_key: this.selectedClientPctKey,
        };
      }

      axios
        .get(
          `${API_BASE_URL}${
            isClientPct ? "/excel/client_pct" : "/get_piano_tributo"
          }`,
          requestConfig
        )
        .then((response) => {
          downloadBlob(
            response.data,
            isClientPct
              ? `Modelli F24 - Piano Codici Tributo - ${this.selectedClientPctLabel}.xlsx`
              : "Modelli F24 - Piano Codici Tributo.xlsx",
            response.headers["content-disposition"]
          );
        })
        .catch((error) => {
          console.error("Errore nel download del file Excel:", error);
        });
    },
    addRowsInPDC() {
      if (!this.validateAllInputs()) {
        return;
      }

      this.calculating2 = true;

      console.log("this.vettoreCodTributo è:", this.vettoreCodTributo);

      const validColumns = this.getValidColumns();

      let finalVectorTributo = this.vettoreCodTributo.map((row) =>
        row
          .map((cell, index) => (validColumns.includes(index) ? cell : null))
          .slice(0, -2)
      );

      // Merge PCT
      if (this.isPCTModified() && this.vettoreCodTributoPCT?.length > 0) {
        const pctValidCols = this.validColumnsPCT || validColumns;
        const pctRows = this.vettoreCodTributoPCT.map((row) =>
          row
            .map((cell, index) => (pctValidCols.includes(index) ? cell : null))
            .slice(0, -2)
        );
        finalVectorTributo = [...finalVectorTributo, ...pctRows];
        console.log("PCT modificato → aggiunte", pctRows.length, "righe");
      }

      let finalVector9001 = [];

      if (this.vettoreCodTributo9001?.length > 0) {
        finalVector9001 = this.vettoreCodTributo9001.map((row) =>
          row.map((cell, index) =>
            this.validColumns9001?.includes(index) ? cell : null
          )
        );
      }

      if (
        this.is9001PCTModified() &&
        this.vettoreCodTributo9001_PCT?.length > 0
      ) {
        const pctRows9001 = this.vettoreCodTributo9001_PCT.map((row) =>
          row.map((cell, index) =>
            this.validColumns9001?.includes(index) ? cell : null
          )
        );
        finalVector9001 = [...finalVector9001, ...pctRows9001];
        console.log(
          "9001 PCT modificato → aggiunte",
          pctRows9001.length,
          "righe"
        );
      }

      const payload = {
        input_PC: this.input_PC,
        output_PC: this.output_PC,
        vettoreCodTributo: finalVectorTributo,
        vettoreCodTributo9001: finalVector9001,
      };

      this.startDelayMessageTimer();

      axios
        .post(`${API_BASE_URL}/add_bilancino_PCT`, payload, {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.clearDelayMessageTimer();
          console.log("Caricato con successo", res);

          this.naConfirmed = false;
          this.noCorrConfirmed = false;

          // Aspetta 1.5 secondi come prima, poi refresh (modal sparirà qui!)
          setTimeout(() => {
            this.fetchFileFromBackend?.();

            const softwareMapping = {
              TEAMSYSTEM: "TEAMSYSTEM",
              DATEV: "DATEV",
              ZUCCHETTI: "ZUCCHETTI",
              SEAC: "SEAC",
              SISTEMI: "SISTEMI",
            };

            if (softwareMapping[this.output_PC]) {
              this.selectedSoftware = softwareMapping[this.output_PC];
            }

            this.refreshDashboard(); // ← QUI! Come nel vecchio codice
          }, 1500);
        })
        .catch((err) => {
          this.clearDelayMessageTimer();
          console.error("Errore axios:", err);
          this.errorMessage =
            err.response?.data?.error || "Errore durante l'aggiunta";
        });
    },
    fillEmptyWithNA() {
      console.log("RIEMPIMENTO N.A. IN CORSO...");

      const fill = (vector, validColumns) => {
        vector.forEach((row) => {
          validColumns.forEach((colIndex) => {
            const col = this.headers[colIndex];
            const value = row[colIndex];
            if (!value || String(value).trim() === "") {
              if (
                !col.includes("Descrizione Cod. Conto") &&
                !col.includes("Descrizione")
              ) {
                this.$set(row, colIndex, "N.A.");
              }
            }
          });
        });
      };

      fill(this.vettoreCodTributo, this.getValidColumns());
      if (this.vettoreCodTributoPCT && this.vettoreCodTributoPCT.length > 0) {
        fill(this.vettoreCodTributoPCT, this.validColumnsPCT); // CORRETTO
      }
      // ===== CASO SPECIFICO 9001 (AD HOC, SEPARATO) =====
      // if (this.vettoreCodTributo9001?.length) {
      //   this.vettoreCodTributo9001.forEach((row, rowIndex) => {
      //     // colonne editabili della tabella 9001
      //     [7, 8].forEach((colIndex) => {
      //       const value = this.mapped9001(rowIndex)[colIndex];

      //       if (!value || String(value).trim() === "") {
      //         this.updateMapped9001(rowIndex, colIndex, "N.A.");
      //         this.$set(
      //           this.inputValues9001,
      //           `${rowIndex}-${colIndex}`,
      //           "N.A."
      //         );
      //       }
      //     });
      //   });
      // }

      this.showErrorModal = false;
    },
    fillEmptyWithNoCorr() {
      const fill = (vector, validColumns) => {
        vector.forEach((row) => {
          validColumns.forEach((colIndex) => {
            const col = this.headers[colIndex];
            const value = row[colIndex];

            // CORRETTO: Usa includes("Descrizione Codice Conto")
            if (
              col.includes("Descrizione Cod. Conto") &&
              (!value || String(value).trim() === "")
            ) {
              this.$set(row, colIndex, "NESSUNA CORRELAZIONE");
            }
          });
        });
      };

      fill(this.vettoreCodTributo, this.getValidColumns());
      if (this.vettoreCodTributoPCT && this.vettoreCodTributoPCT.length > 0) {
        fill(this.vettoreCodTributoPCT, this.validColumnsPCT);
      }
      // if (this.vettoreCodTributo9001?.length) {
      //   this.vettoreCodTributo9001.forEach((row, rowIndex) => {
      //     const colIndex = 6; // Descrizione Cod. Conto
      //     const value = this.mapped9001(rowIndex)[colIndex];

      //     if (!value || String(value).trim() === "") {
      //       this.updateMapped9001(rowIndex, colIndex, "NESSUNA CORRELAZIONE");
      //       this.$set(
      //         this.inputValues9001,
      //         `${rowIndex}-${colIndex}`,
      //         "NESSUNA CORRELAZIONE"
      //       );
      //     }
      //   });
      // }
      this.showErrorModal = false;
    },
    proceedWithWarnings() {
      this.naConfirmed = true;
      this.noCorrConfirmed = true;
      this.showErrorModal = false;
      this.addRowsInPDC();
    },
    validateAllInputs() {
      console.log("INIZIO VALIDAZIONE COMPLETA");
      console.log("output_PC:", this.output_PC);
      console.log("filteredHeaders:", this.filteredHeaders);

      // Contenitori errori
      let emptyCells = {
        "Codici Conto mancanti:": [],
        "Descrizioni Codici Conto mancanti:": [],
      };
      let emptyCells9001 = {
        "Codici Conto mancanti:": [],
        "Descrizioni Codici Conto mancanti:": [],
      };
      let formatErrors = [];
      let warnings = [];
      let naCells = [];
      let noCorrCells = [];
      let reservedCodContoDefaultCells = [];

      // Regex
      const teamSystemRegex = /^[0-9]{2}\/[0-9]{2}\/[0-9]{3}$/;
      const seacRegex = /^\d{6}$/;
      const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;
      const numberRegex = /^[0-9]+$/;
      const naRegex = /^(n\.?a\.?)$/i;

      const sistemaContabile = this.output_PC || "";
      let colonneDaControllare = [];

      if (sistemaContabile === "TEAMSYSTEM") {
        colonneDaControllare = [
          "Cod. Conto DARE - TeamSystem",
          "Cod. Conto AVERE - TeamSystem",
        ];
      } else if (sistemaContabile === "DATEV") {
        colonneDaControllare = [
          "Cod. Conto DARE - Datev Aziende",
          "Cod. Conto AVERE - Datev Aziende",
          "Cod. Conto DARE - Datev Lib. Prof.",
          "Cod. Conto AVERE - Datev Lib. Prof.",
        ];
      } else if (sistemaContabile === "ZUCCHETTI") {
        colonneDaControllare = [
          "Cod. Conto DARE - Zucchetti",
          "Cod. Conto AVERE - Zucchetti",
        ];
      } else if (sistemaContabile === "SEAC") {
        colonneDaControllare = [
          "Cod. Conto DARE - SEAC",
          "Cod. Conto AVERE - SEAC",
        ];
      } else if (sistemaContabile === "SISTEMI") {
        colonneDaControllare = [
          "Cod. Conto DARE - Sistemi",
          "Cod. Conto AVERE - Sistemi",
        ];
      }

      // =============================================
      // FUNZIONE GENERICA (solo per tributi normali e PCT)
      // =============================================
      const validateVector = (vector, headers, validCols, prefix = "") => {
        if (!Array.isArray(vector) || vector.length === 0) return;
        if (!Array.isArray(headers) || !Array.isArray(validCols)) return;

        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (let i = 0; i < validCols.length; i++) {
            const colIndex = validCols[i];
            const col = headers[i] || this.headers?.[colIndex] || "";
            let cellValue = vector[rowIndex][colIndex];

            if (cellValue) cellValue = String(cellValue).trim();

            if (naRegex.test(cellValue)) {
              vector[rowIndex][colIndex] = "N.A.";
              continue;
            }

            if (!cellValue) {
              if (col.includes("Descrizione Cod. Conto")) {
                emptyCells["Descrizioni Codici Conto mancanti:"].push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  } - Descrizione Cod. Conto mancante`
                );
              } else {
                emptyCells["Codici Conto mancanti:"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${col || "Codice Conto"}`
                );
              }
              continue;
            }

            if (
              !col.includes("Descrizione") &&
              this.isCodContoDefault(cellValue)
            ) {
              reservedCodContoDefaultCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${col || "Codice Conto"}`
              );
              continue;
            }

            if (colonneDaControllare.includes(col)) {
              let corrected = false;

              if (sistemaContabile === "TEAMSYSTEM") {
                if (!/[0-9]/.test(cellValue)) {
                  vector[rowIndex][colIndex] = "N.A.";
                  warnings.push(
                    `${prefix}Riga ${
                      rowIndex + 1
                    }, "${col}": nessuna cifra → corretto in 'N.A.'`
                  );
                  corrected = true;
                }
                if (!corrected && !teamSystemRegex.test(cellValue)) {
                  formatErrors.push(
                    `${prefix}Riga ${
                      rowIndex + 1
                    }, "${col}": formato errato, atteso XX/XX/XXX`
                  );
                }
              } else if (sistemaContabile === "SEAC") {
                if (!/[0-9]/.test(cellValue)) {
                  vector[rowIndex][colIndex] = "N.A.";
                  warnings.push(
                    `${prefix}Riga ${
                      rowIndex + 1
                    }, "${col}": nessuna cifra → corretto in 'N.A.'`
                  );
                  corrected = true;
                }
                if (!corrected && !seacRegex.test(cellValue)) {
                  formatErrors.push(
                    `${prefix}Riga ${
                      rowIndex + 1
                    }, "${col}": formato errato, atteso 6 cifre`
                  );
                }
              } else if (sistemaContabile === "SISTEMI") {
                if (!/[0-9]/.test(cellValue)) {
                  vector[rowIndex][colIndex] = "N.A.";
                  warnings.push(
                    `${prefix}Riga ${
                      rowIndex + 1
                    }, "${col}": nessuna cifra → corretto in 'N.A.'`
                  );
                  corrected = true;
                }
                if (!corrected && !sistemiRegex.test(cellValue)) {
                  formatErrors.push(
                    `${prefix}Riga ${
                      rowIndex + 1
                    }, "${col}": formato errato, atteso XX.XX.XX[.XXX]`
                  );
                }
              } else if (
                sistemaContabile === "DATEV" ||
                sistemaContabile === "ZUCCHETTI"
              ) {
                if (!numberRegex.test(cellValue)) {
                  vector[rowIndex][colIndex] = "N.A.";
                  warnings.push(
                    `${prefix}Riga ${
                      rowIndex + 1
                    }, "${col}": non solo cifre → corretto in 'N.A.'`
                  );
                  corrected = true;
                }
                if (
                  !corrected &&
                  (cellValue.length < 5 || cellValue.length > 11)
                ) {
                  formatErrors.push(
                    `${prefix}Riga ${
                      rowIndex + 1
                    }, "${col}": da 5 a 11 cifre numeriche richieste`
                  );
                }
              }
            }
          }
        }

        // Rilevamento N.A. / NESSUNA CORRELAZIONE
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (let i = 0; i < validCols.length; i++) {
            const colIndex = validCols[i];
            const col = headers[i] || this.headers?.[colIndex] || "";
            const cellValue = String(vector[rowIndex][colIndex] || "")
              .trim()
              .toUpperCase();

            if (!col.includes("Descrizione") && cellValue === "N.A.") {
              naCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${col || "Codice Conto"}`
              );
            }
            if (
              col.includes("Descrizione Cod. Conto") &&
              cellValue === "NESSUNA CORRELAZIONE"
            ) {
              noCorrCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${col || "Descrizione"}`
              );
            }
          }
        }
      };

      // =============================================
      // ESECUZIONE VALIDAZIONE
      // =============================================

      const validColumns = this.getValidColumns?.() || [];

      // Tributi normali
      validateVector(
        this.vettoreCodTributo,
        this.filteredHeaders || [],
        validColumns,
        ""
      );

      // Tributi PCT
      if (this.vettoreCodTributoPCT?.length > 0) {
        validateVector(
          this.vettoreCodTributoPCT,
          this.filteredHeadersPCT || [],
          this.validColumnsPCT || validColumns,
          "[SALVATI] "
        );
      }

      // =============================================
      // VALIDAZIONE DEDICATA 9001 e 9001_PCT
      // =============================================
      const validate9001Vector = (vector, prefix) => {
        if (!vector || vector.length === 0) return;

        const headersVisibili = this.headers9001 || [];
        const validCols = this.validColumns9001 || [];

        const uiToRealIndex = { 6: 4, 7: 5, 8: 6 };

        // Controllo celle vuote + formato
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (const uiCol of [6, 7, 8]) {
            if (!validCols.includes(uiCol)) continue;

            const realCol = uiToRealIndex[uiCol];
            const visibleHeader = headersVisibili[uiCol] || `Colonna ${uiCol}`;

            let cellValue = vector[rowIndex][realCol];
            cellValue = cellValue == null ? "" : String(cellValue).trim();

            if (cellValue === "N.A." || cellValue === "NESSUNA CORRELAZIONE")
              continue;

            if (!cellValue) {
              if (uiCol === 6) {
                emptyCells9001["Descrizioni Codici Conto mancanti:"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
              } else {
                emptyCells9001["Codici Conto mancanti:"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
              }
              continue;
            }

            // Formato solo per codici DARE / AVERE
            if (uiCol === 7 || uiCol === 8) {
              if (this.isCodContoDefault(cellValue)) {
                reservedCodContoDefaultCells.push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
                continue;
              }

              let errorMsg = null;

              if (
                sistemaContabile === "TEAMSYSTEM" &&
                !teamSystemRegex.test(cellValue)
              ) {
                errorMsg = "formato errato, atteso XX/XX/XXX";
              } else if (
                sistemaContabile === "DATEV" &&
                (!numberRegex.test(cellValue) ||
                  cellValue.length < 5 ||
                  cellValue.length > 11)
              ) {
                errorMsg = "deve contenere da 5 a 11 cifre numeriche";
              } else if (
                sistemaContabile === "ZUCCHETTI" &&
                (!numberRegex.test(cellValue) || cellValue.length < 5)
              ) {
                errorMsg = "deve contenere almeno 5 cifre numeriche";
              } else if (
                sistemaContabile === "SEAC" &&
                !seacRegex.test(cellValue.replace(/\D/g, ""))
              ) {
                errorMsg = "deve contenere esattamente 6 cifre";
              } else if (
                sistemaContabile === "SISTEMI" &&
                !sistemiRegex.test(cellValue)
              ) {
                errorMsg = "formato errato, atteso XX.XX.XX o XX.XX.XX.XXX";
              }

              if (errorMsg) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, "${visibleHeader}": ${errorMsg}`
                );
              }
            }
          }
        }

        // Rilevamento N.A. / NESSUNA CORRELAZIONE
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (const uiCol of [6, 7, 8]) {
            if (!validCols.includes(uiCol)) continue;

            const realCol = uiToRealIndex[uiCol];
            let cellValue = vector[rowIndex][realCol];
            cellValue =
              cellValue == null ? "" : String(cellValue).trim().toUpperCase();

            const visibleHeader = headersVisibili[uiCol] || `Colonna ${uiCol}`;

            if ((uiCol === 7 || uiCol === 8) && cellValue === "N.A.") {
              naCells.push(`${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`);
            }
            if (uiCol === 6 && cellValue === "NESSUNA CORRELAZIONE") {
              noCorrCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
              );
            }
          }
        }
      };

      // 9001 principale
      if (this.vettoreCodTributo9001?.length > 0) {
        validate9001Vector(this.vettoreCodTributo9001, "[9001] ");
      }

      // 9001 PCT (salvati)
      if (this.vettoreCodTributo9001_PCT?.length > 0) {
        validate9001Vector(this.vettoreCodTributo9001_PCT, "[9001 SALVATI] ");
      }

      // =============================================
      // COSTRUZIONE ERRORI
      // =============================================

      const detectedErrors = [];

      if (emptyCells["Codici Conto mancanti:"].length > 0) {
        detectedErrors.push({
          type: "empty-cells",
          title: "Codici Conto mancanti:",
          messages: emptyCells["Codici Conto mancanti:"],
        });
      }

      if (emptyCells["Descrizioni Codici Conto mancanti:"].length > 0) {
        detectedErrors.push({
          type: "empty-cells",
          title: "Descrizioni Codici Conto mancanti:",
          messages: emptyCells["Descrizioni Codici Conto mancanti:"],
        });
      }

      if (emptyCells9001["Codici Conto mancanti:"].length > 0) {
        detectedErrors.push({
          type: "empty-cells-obbligatorie",
          title: "Codici conto mancanti nei codici 9001:",
          messages: emptyCells9001["Codici Conto mancanti:"],
        });
      }

      if (emptyCells9001["Descrizioni Codici Conto mancanti:"].length > 0) {
        detectedErrors.push({
          type: "empty-cells-obbligatorie",
          title: "Descrizioni Codici Conto mancanti nei codici 9001:",
          messages: emptyCells9001["Descrizioni Codici Conto mancanti:"],
        });
      }

      if (formatErrors.length > 0) {
        detectedErrors.push({
          type: "format-errors",
          title: "Codici conto non validi:",
          messages: formatErrors,
        });
      }

      if (reservedCodContoDefaultCells.length > 0) {
        detectedErrors.push({
          type: "format-errors",
          title: `Codice conto ${this.codContoDefault} riservato:`,
          messages: reservedCodContoDefaultCells,
        });
      }

      if (warnings.length > 0) {
        detectedErrors.push({
          type: "warnings",
          title: "Avvertimenti sui codici conto:",
          messages: warnings,
        });
      }

      // Avviso unificato N.A. + NESSUNA CORRELAZIONE
      if (detectedErrors.length === 0) {
        const hasNA = naCells.length > 0 && !this.naConfirmed;
        const hasNoCorr = noCorrCells.length > 0 && !this.noCorrConfirmed;

        if (hasNA || hasNoCorr) {
          let title = "",
            messages = [],
            question = "";

          if (hasNA && hasNoCorr) {
            title = `Trovati ${naCells.length} codici con 'N.A.' e ${noCorrCells.length} descrizioni con 'NESSUNA CORRELAZIONE':`;
            messages = [...naCells, ...noCorrCells];
            question = `Vuoi proseguire? I codici 'N.A.' resteranno non assegnati e le descrizioni 'NESSUNA CORRELAZIONE' verranno mantenute come tali.`;
          } else if (hasNA) {
            title = `Trovati ${naCells.length} codici con 'N.A.':`;
            messages = naCells;
            question = `Vuoi proseguire senza assegnare questi codici conto? Verranno mantenuti come 'N.A.'.`;
          } else if (hasNoCorr) {
            title = `Trovate ${noCorrCells.length} descrizioni con 'NESSUNA CORRELAZIONE':`;
            messages = noCorrCells;
            question = `Vuoi proseguire mantenendo queste descrizioni come 'NESSUNA CORRELAZIONE'?`;
          }

          detectedErrors.push({
            type: "combined-warning",
            title,
            messages,
            question,
          });
        }
      }

      if (detectedErrors.length > 0) {
        this.errorsData = detectedErrors;
        this.showErrorModal = true;
        return false;
      }

      return true;
    },

    refreshDashboard() {
      this.rows = [];
      this.calculating = false;
      this.calculating2 = false;
      (this.input_PC = ""), (this.output_PC = "");
      this.vettoreCodTributo = [];
      this.currentSubPhase = "A";
      this.vettorePCTVisible = false;
      this.vettore9001PCTVisible = false;
      this.isTableExpanded = false;
      this.isTableTributoPCTExpanded = false;
      this.isTable9001Expanded = false;
      this.isTable9001PCTExpanded = false;
      this.F24File = null;
      this.selectedPiano = null;
      this.isShifted = false;
      this.isTransitionDone = false;
      this.expanded = true;
      this.editPDCresponse = false;
      this.F24File = null;
      this.filePDF_URL = null;
      // this.isEditing = false;
      this.errorMessage = "";
      this.showAddRow = false;
      this.showAddBilancino = false;
      this.showResult = false;
      this.showAddPiano = false;
      this.editableCells = new Set();
      // 🔴 Protezione contro undefined
      if (this.jsonData && this.jsonData.length > 0) {
        this.newRow = Array(this.jsonData[0].length).fill("");
      } else {
        console.warn("Nuovo piano dei conti caricato.");
        this.newRow = []; // Evita errori
      }
      this.loadUserPreferredSoftware();
      this.resetSubPhaseState();
    },
    getValidColumns() {
      // Mappa esclusioni per ciascun gestionale
      const excludedColumnsMap = {
        TEAMSYSTEM: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        DATEV: [1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        ZUCCHETTI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 13, 14, 15, 16, 17, 18],
        SEAC: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 16, 17, 18],
        SISTEMI: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      };

      const excluded = excludedColumnsMap[this.output_PC] || [];

      let possibleIndices = [];

      // Caso: nessuna riga tributo normale → fallback su colonne base (tipo 9001 o minime)
      if (
        !this.vettoreCodTributo ||
        !Array.isArray(this.vettoreCodTributo) ||
        this.vettoreCodTributo.length === 0
      ) {
        possibleIndices = [0, 1, 2, 3, 4, 5, 6, 7, 8]; // oppure estendi se serve
      }
      // Caso normale: usiamo la lunghezza reale della prima riga
      else if (
        this.vettoreCodTributo[0] &&
        Array.isArray(this.vettoreCodTributo[0])
      ) {
        const rowLength = this.vettoreCodTributo[0].length;

        // Limite rigido: non andare oltre headers.length
        const maxAllowed = Math.min(rowLength, this.headers.length);

        possibleIndices = Array.from({ length: maxAllowed }, (_, i) => i);
      }

      // Filtra le colonne escluse dal gestionale
      let valid = possibleIndices.filter((index) => !excluded.includes(index));

      // Ultima sicurezza: togli eventuali indici che superano headers (non dovrebbe servire ma...)
      valid = valid.filter((i) => i < this.headers.length);

      // Log per debug (rimuovi quando hai finito di testare)
      console.log("[getValidColumns]", {
        output_PC: this.output_PC,
        rowLength: this.vettoreCodTributo?.[0]?.length ?? "nessuna riga",
        excludedCount: excluded.length,
        restituisce: valid,
      });

      return valid;
    },
    getHeaderLabel(index) {
      const overrideLabels = {
        4: "Descrizione Cod. Conto - Datev", // Cambia solo per la visualizzazione
      };
      return (
        overrideLabels[index] ||
        this.jsonData?.[0]?.[index] ||
        `Colonna ${index + 1}`
      );
    },
    formatCodiceConto(event, index) {
      let value = event.target.value;
      if (index === 0) {
        value = value.replace(/\D/g, "");
        value = value.slice(0, 4);
      }
      // Se contiene almeno una lettera → diventa N.A. e fine
      if (/[a-zA-Z]/.test(value)) {
        this.newRow[index] = "N.A.";
        event.target.value = "N.A.";
        return;
      }

      // Altrimenti procedi solo con i numeri (comportamento attuale)
      value = value.replace(/\D/g, ""); // rimuove tutto ciò che non è cifra

      if (index === 2 || index === 3) {
        // TeamSystem (XX/XX/XXX)
        value = value.slice(0, 7);
        if (value.length >= 5) {
          value =
            value.slice(0, 2) + "/" + value.slice(2, 4) + "/" + value.slice(4);
        } else if (value.length >= 3) {
          value = value.slice(0, 2) + "/" + value.slice(2);
        }
      } else if (index === 14 || index === 15) {
        // SEAC → solo 6 cifre, nessun separatore
        value = value.slice(0, 6);
      } else if ([5, 6, 8, 9].includes(index)) {
        // Datev: solo numeri, massimo 11 cifre
        value = value.slice(0, 11);
      } else if (index === 17 || index === 18) {
        // Sistemi (XX.XX.XX o XX.XX.XX.XXX)
        value = value.slice(0, 9);
        if (value.length >= 7) {
          value =
            value.slice(0, 2) +
            "." +
            value.slice(2, 4) +
            "." +
            value.slice(4, 6) +
            "." +
            value.slice(6);
        } else if (value.length >= 5) {
          value =
            value.slice(0, 2) + "." + value.slice(2, 4) + "." + value.slice(4);
        } else if (value.length >= 3) {
          value = value.slice(0, 2) + "." + value.slice(2);
        }
      }

      this.newRow[index] = value;
      event.target.value = value;
    },
    isNessuno(value) {
      return value === "N.A.";
    },
    hasNessunaCorrelazione(value) {
      if (typeof value === "string") {
        return value.toLowerCase().includes("nessuna correlazione");
      }
      return false;
    },
    startDelayMessageTimer() {
      this.delayTimer = setTimeout(() => {
        this.showDelayedMessage = true;
      }, 10000);
      // Cambia il testo dopo 40 secondi totali
      this.updateTimer = setTimeout(() => {
        this.delayedMessageUpdated = true;
      }, 35000);
    },
    clearDelayMessageTimer() {
      clearTimeout(this.delayTimer);
      clearTimeout(this.updateTimer);
      this.showDelayedMessage = false;
      this.delayedMessageUpdated = false;
    },
  },
};
</script>

<style scoped>
.main-container {
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  padding: 0.75rem clamp(1rem, 5vw, 6rem) 2.25rem;
  overflow: visible;
}
body {
  margin-left: 2rem;
}
.library-page-header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-height: 5.85rem;
  margin: 0 0 0.675rem;
  padding: 0.72rem 11rem 0.72rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  overflow: hidden;
  border: 1px solid rgba(23, 106, 157, 0.1);
  border-radius: 12px;
  background: linear-gradient(105deg, #f5faff 0%, #eef7fd 68%, #e8f3fc 100%);
  box-shadow: 0 7px 20px rgba(23, 106, 157, 0.055);
}

.library-page-header__icon {
  position: relative;
  z-index: 1;
  display: block;
  flex: 0 0 3.7rem;
  width: 3.7rem;
  height: 3.7rem;
  object-fit: contain;
}

.library-page-header__copy {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.library-page-header__title-row {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  min-width: 0;
}

.library-page-header__title {
  margin: 0;
  color: #15334b;
  font-size: 1.42rem;
  font-weight: 750;
  letter-spacing: -0.015em;
  line-height: 1.15;
}

.library-page-header__subtitle {
  margin: 0.3rem 0 0;
  color: #657c88;
  font-size: 0.82rem;
  line-height: 1.35;
}

.library-page-header__visual {
  position: absolute;
  z-index: 0;
  display: block;
  pointer-events: none;
  user-select: none;
}

.library-page-header__visual--tributo {
  right: 1.2rem;
  bottom: -4.1rem;
  width: 12.5rem;
  opacity: 0.45;
}

.library-scope-badge {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.32rem;
  padding: 0.3rem 0.55rem;
  border: 1px solid #d4e5f0;
  border-radius: 999px;
  background: #edf6fc;
  color: #176a9d;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}
.library-scope-badge i {
  font-size: 0.65rem;
}
/* table,
th,
td {
  border: 1px solid black;
} */
th,
td {
  padding: 10px;
  text-align: left;
}
th {
  background-color: #f2f2f2;
}
td:nth-child(4),
td:nth-child(5),
td:nth-child(6),
td:nth-child(7) {
  width: 10rem;
  max-width: 10rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.italic-text {
  font-style: italic;
  font-size: 0.75rem !important;
  color: rgb(156, 156, 156);
}
.buttons > button,
.buttons > a {
  align-items: center;
  gap: 0.35rem;
  padding: 0.6rem 0.85rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease,
    box-shadow 0.3s ease;
  border: none;
  color: #333;
  background-color: transparent; /* Pulsanti trasparenti di default per un look minimal */
  white-space: nowrap;
}
.dashboard {
  margin-top: 0rem;
  margin-bottom: 0rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
}
.buttons > button {
  display: flex;
}
.buttons > button:hover,
.buttons > a:hover {
  background-color: #f0f0f0;
  transform: translateY(-1px);
}
.buttons > button:active,
.buttons > a:active {
  transform: translateY(0);
  background-color: #e0e0e0;
}
.lastbuttons {
  padding-top: 20px;
  padding-bottom: 4rem;
}
.italic-none {
  font-style: italic;
  font-size: 0.95rem;
  color: rgb(156, 156, 156);
}
.strumenti {
  position: relative;
  background-color: #898989;
  border-radius: 5px;
  color: white;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}
.strumenti:hover {
  background-color: #7a7a7a;
}
.strumenti:active {
  background-color: #616269; /* Grigio ancora più scuro quando è attivo */
}
.strumenti,
.strumenti2 {
  background-color: #f0f0f0; /* Sfondo leggero per il pulsante strumenti */
  color: #555;
  font-weight: 600;
}
.strumenti:hover,
.strumenti2:hover {
  background-color: #e0e0e0;
}
.strumenti:active,
.strumenti2:active {
  background-color: #d0d0d0;
}
.modificaButton {
  background-color: #4caf50;
  border-radius: 5px;
}
.modificaButton:hover {
  background-color: #45a049;
}
.annullamodifiche {
  background-color: #c94d41;
  border-radius: 5px;
}
.annullamodifiche:hover {
  background-color: #c12323;
}
.donwloadUploadIcons {
  padding-left: 0rem;
}
.delete-button {
  font-size: 0.9rem;
  color: #6b7280;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  transition: background-color 0.3s;
}
.delete-button:hover,
.delete-button.active {
  transform: scale(1.1); /* Aggiungi un effetto leggero di ingrandimento */
  background-color: #e61d1d !important;
  border-radius: 4px;
  color: #ffffff !important;
}
.delete-button1 {
  font-size: 1.1rem;
  color: white;
  background-color: #f9f9f9;
  border: none;
  cursor: pointer;
  padding: 4px 5px;
  transition: background-color 0.3s;
}
.delete-button1:hover,
.delete-button1.active {
  transform: scale(1.1); /* Aggiungi un effetto leggero di ingrandimento */
  background-color: #e61d1d;
  border-radius: 4px;
}
tr.highlight-row .delete-button {
  background-color: #ffeeba; /* Giallo acceso */
  color: black !important; /* Contrasto leggibile */
}

tr.highlight-row9001 .delete-button {
  background-color: #ffeeba;
  color: black !important;
}
.add-row-form {
  margin-top: 2rem;
  margin-bottom: 1.8rem;
  padding: 0 5px;
  background-color: #f9f9f9;
}
add-row-form table {
  border-collapse: collapse; /* Per evitare spazi tra le celle */
}
.addrowheaders {
  background-color: #d9d7dea1;
}
.add-row-form input {
  height: 1.6rem;
  width: 95%;
}
.addRowButton {
  background-color: #898989; /* Grigio di base */
  border-radius: 5px;
  color: white;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.addRowButton:hover {
  background-color: #7a7a7a; /* Grigio scuro al passaggio del mouse */
}

.addRowButton:active {
  background-color: #616269; /* Grigio ancora più scuro quando è attivo */
}
.addRowButton:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.addBilancinoButton {
  background-color: #898989;
  border-radius: 5px;
  color: white;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.addBilancinoButton:hover {
  background-color: #7a7a7a; /* Grigio scuro al passaggio del mouse */
}

.addBilancinoButton:active {
  background-color: #616269; /* Grigio ancora più scuro quando è attivo */
}
/* Stile per il pulsante attivo */
.active-button {
  background-color: #5a5a5a; /* Un grigio più scuro ma non troppo invadente */
  color: white;
  border: 1px solid #4c4c4c; /* Aggiungi un bordo grigio scuro per il pulsante attivo */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15); /* Ombra leggera per il pulsante attivo */
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.addRowButton,
.addBilancinoButton,
.btn-carica,
.btn-scarica {
  background-color: #f0f0f0;
  color: #555;
}
.btn-saldof-pdc:hover,
.btn-9001-pdc:hover,
.addRowButton:hover,
.addBilancinoButton:hover,
.btn-carica:hover,
.btn-scarica:hover {
  background-color: #e0e0e0;
}
.btn-saldof-pdc:disabled,
.btn-9001-pdc:disabled {
  opacity: 0.7;
  background-color: #f0f0f0;
  color: #737373;
}
.addRowButton:active,
.addBilancinoButton:active,
.btn-carica:active,
.btn-scarica:active {
  background-color: #d0d0d0;
}
.active-button {
  background-color: #e0e0e0 !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1); /* Effetto premuto per active */
}
.leggibilancino:active {
  background-color: #616269; /* Colore più scuro quando il pulsante è premuto */
  transform: translateY(
    0
  ); /* Ripristina la posizione quando il pulsante è attivo */
}
.download-icon {
  font-size: 1rem; /* Dimensione dell'icona */
  color: #28a745;
}

.upload-icon {
  font-size: 1.2rem; /* Dimensione dell'icona */
  color: #5c5c5c; /* Verde brillante */
}

.upload-icon:hover {
  color: #a1a1a1; /* Verde scuro al passaggio del mouse */ /* Colore al passaggio del mouse */
}
.tool-button:hover .back {
  color: rgb(33, 105, 81);
}
.tool-button {
  padding: 0.35rem !important;
  background-color: transparent;
  margin-right: 0;
}
.header-home-button {
  margin-right: 0;
}
.back {
  font-size: 1.5rem !important;
  color: #7d7d7d;
}
.backinheader {
  font-size: 1.55rem !important;
}
.back:hover {
  color: rgb(33, 105, 81);
}
.selectSoftwareInput {
  height: 1.8rem;
  color: rgb(0, 0, 0);
  width: 95%;
}
.riga {
  position: relative;
}
.loading-cursor {
  cursor: progress;
}
.highlight-row {
  background-color: #ffeeba; /* Giallo chiaro */
  transition: background-color 0.3s ease-in-out;
}
tr.highlight-row td {
  background-color: #ffeeba !important; /* Giallo chiaro */
  transition: background-color 0.3s ease-in-out !important;
}
table {
  border-spacing: 0;
  border: none !important;
  width: 100%;
}
#excelTable {
  position: relative;
  margin-top: 1.5rem;
  margin-bottom: 5rem;
  border-collapse: collapse;
  min-width: 74rem;
  max-width: 78rem;
  margin-top: 20px;
}
#excelTable.editing {
  min-width: 77.75rem;
}
#excelTable.all-software-table {
  min-width: 111rem;
  max-width: none;
  table-layout: fixed;
  margin-top: 0;
  margin-bottom: 0.6rem;
}
#excelTable.all-software-table.editing {
  min-width: 114rem;
}
#SaldoFTableInline.all-software-bank-table {
  min-width: 112rem;
  max-width: none;
}
#excelTable.has-empty-body {
  margin-bottom: 0;
}
#excelTable.has-empty-body .row-index {
  display: none;
}
.dashboarddiv {
  position: relative;
  min-width: 77.75rem;
  min-height: auto;
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
}
.dashboard-feedback {
  position: absolute;
  top: -1.7rem;
  right: 1.25rem;
  pointer-events: none;
}
.delete-column {
  width: 2.45rem !important;
  text-align: center;
}
#excelTable th:nth-child(1),
#excelTable td:nth-child(1) {
  width: 1rem !important;
}
#excelTable th:nth-child(2),
#excelTable td:nth-child(2) {
  max-width: 80px !important;
}
#excelTable th:nth-child(3),
#excelTable td:nth-child(3) {
  min-width: 150px;
}
#excelTable th:nth-child(4),
#excelTable td:nth-child(4) {
  min-width: 120px;
}
#excelTable th:nth-child(5),
#excelTable td:nth-child(5) {
  min-width: 120px;
}
#excelTable th:nth-child(7),
#excelTable td:nth-child(7) {
  min-width: 120px;
}
#excelTable th:nth-child(8),
#excelTable td:nth-child(8) {
  min-width: 120px;
}
#excelTable > tr {
  height: 3rem;
}
#excelTable th {
  height: 2.1rem;
}
#addRowTable {
  max-width: 80rem;
}
.addrowtable th:nth-child(1),
.addrowtable td:nth-child(1),
.addrowtable th:nth-child(2),
.addrowtable td:nth-child(2),
.addrowtable th:nth-child(3),
.addrowtable td:nth-child(3),
.addrowtable th:nth-child(4),
.addrowtable td:nth-child(4) {
  width: 20%;
}
.addrowtabledatev th:nth-child(1),
.addrowtabledatev td:nth-child(1),
.addrowtabledatev th:nth-child(2),
.addrowtabledatev td:nth-child(2) {
  width: 20%;
}
.addrowtabledatev th:nth-child(3),
.addrowtabledatev td:nth-child(3),
.addrowtabledatev th:nth-child(4),
.addrowtabledatev td:nth-child(4),
.addrowtabledatev th:nth-child(5),
.addrowtabledatev td:nth-child(5),
.addrowtabledatev th:nth-child(6),
.addrowtabledatev td:nth-child(6) {
  width: 15%;
}
.row-index {
  width: 1rem !important;
  background-color: #ffffff;
  font-family: monospace;
  color: #777;
  user-select: none;
  padding: 5px !important;
  text-align: center !important;
}
.file-upload-container {
  display: inline-block;
}

.btninput {
  display: flex;
  align-items: center;
  gap: 7px;
}

.hidden-file-input {
  display: none;
}
.software-output-select {
  margin-left: 10px;
  padding: 3px;
  font-size: 0.8rem;
}
.input-container {
  position: relative;
}
.btn-send-bilancino {
  background-color: #4caf50;
  border-radius: 5px;
  color: white;
  padding: 10px 20px;
  cursor: pointer;
  margin-top: 10px;
}

.btn-send-bilancino:hover {
  background-color: #45a049;
}

.btn-send-bilancino:disabled {
  background-color: #d3d3d3;
  cursor: default;
}
.response-message-add-bilancino {
  min-width: 55rem;
  height: auto;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  margin-top: 1.5rem;
}
.nessun-piano-header {
  margin: 0;
  font-weight: 700;
  font-style: normal;
  color: #233544;
  font-size: 1.15rem;
  line-height: 1.3;
  letter-spacing: 0.01em;
}
.empty-plan-icon {
  width: 2.7rem;
  height: 2.7rem;
  flex: 0 0 2.7rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--empty-soft);
  color: var(--empty-accent);
  font-size: 1.2rem;
}
.empty-plan-body {
  width: 100%;
  max-width: 58rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
}
.empty-plan-line {
  margin: 0;
  color: #5d6b79;
  font-size: 1rem;
  line-height: 1.55;
}
.empty-plan-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}
.empty-plan-action {
  min-height: 2.35rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.52rem 0.85rem;
  border-radius: 8px;
  font-size: 0.95rem !important;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    color 0.18s ease, transform 0.18s ease;
}
.empty-plan-action:hover {
  transform: translateY(-1px);
}
.empty-plan-action--primary {
  border: 1px solid var(--empty-accent);
  background: var(--empty-accent);
  color: #ffffff !important;
}
.empty-plan-action--primary:hover {
  background: var(--empty-accent-hover);
  border-color: var(--empty-accent-hover);
}
.empty-plan-action--secondary {
  border: 1px solid #cfdce7;
  background: #ffffff;
  color: var(--empty-accent);
}
.empty-plan-action--secondary:hover {
  background: var(--empty-soft);
  border-color: #bdd2e3;
}
.empty-plan-line .convertitore {
  font-size: inherit !important;
  font-weight: 600;
}
.div-add-bilancino {
  position: relative;
  display: flex;
  flex-direction: column; /* Gli elementi all'interno sono disposti in colonna */
  width: 18rem;
  padding: 0.8rem 2rem 1.8rem 2rem;
  align-items: center;
  justify-content: flex-start; /* Posizionamento degli elementi in alto */
  order: 1; /* Ordine iniziale: è il primo elemento */
  border: 2px solid rgba(223, 223, 223, 0.82) !important;
  background-color: rgb(243 243 243 / 99%);
  border-radius: 20px;
  box-shadow: 2px 2px 8px rgba(107, 107, 107, 0.1);
  transition: transform 0.8s ease-in-out, margin-bottom 0.2s ease-in-out 0.8s;
}

.div-add-bilancino.shift-left {
  align-items: center; /* Allinea gli elementi verticalmente al centro */
  transform: translateX(-132%);
  margin-bottom: 4.5rem;
}
.calcolatrice-add-bilancino {
  position: relative;
  padding-bottom: 2.25rem;
  margin-top: 1.75rem;
}
.container-wrapper-add-bilancino {
  position: relative;
  display: flex;
  align-items: flex-start; /* Allinea verticalmente in cima */
  justify-content: center; /* Allinea .contenitore al centro inizialmente */
  width: 100%;
}
.margin-active {
  margin-bottom: 5.5rem;
}
.input-container .action-button {
  background-color: #336987;
}
.file-input-add-bilancino {
  width: 17.4rem;
  padding: 0.55rem 0 0.55rem 0.55rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  border: 1px solid #cccccc;
  border-radius: 5px;
  background-color: #fff;
}
.select-input-add-bilancino {
  width: 100%;
  padding: 0.55rem 0 0.55rem 0.55rem;
  margin-bottom: 1.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
}
.result-container-add-bilancino {
  position: absolute;
  height: 27rem;
  left: 29%;
  opacity: 0; /* Inizialmente nascosto */
  transition: opacity 3s ease-in-out 5s;
  order: 2; /* Ordine iniziale: è il secondo elemento */
  border-radius: 5px;
  margin-top: 2rem;
  margin-bottom: 5rem;
  border: 1px solid rgba(198, 198, 198, 0.525);
  background-color: white;
}
.result-container-add-bilancino.show {
  opacity: 1;
}
.cod_conto_table_div,
.cod_conto_table_divPCT {
  max-height: 16.75rem !important;
}
.refresh {
  color: #274f66;
}
.title-add-bilancino {
  color: #274f66;
  display: block;
  font-size: 1.12em;
  margin-top: 0.9em;
  margin-bottom: 1.5em;
  font-weight: bold;
  width: 14rem;
}
.titleaddpiano {
  color: #274f66;
  font-weight: bold;
  font-size: 1.12rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #b2b2b2;
  width: 17rem;
}
.headerButtons-add-bilancino {
  position: absolute;
  opacity: 100%;
  transform: scale(0.75);
  top: 0rem;
  left: -3.2rem;
  display: flex;
  flex-direction: column; /* Dispone gli elementi in verticale */
  align-items: center; /* Centra gli elementi orizzontalmente (opzionale) */
  border: 2px solid rgb(202 219 223 / 60%) !important;
  background-color: rgb(243 243 243 / 99%);
  border-radius: 18px;
  padding: 0.6rem 0.5rem 0.6rem 0.5rem;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); */
}
.btn-saldof-pdc:hover,
.btn-9001-pdc:hover,
.headerButtons-add-bilancino:hover {
  cursor: pointer;
}
.headerButtons-add-bilancino:hover .refresh {
  color: rgb(91, 94, 91);
}
/* .editable-input {
  height: 20px;
  width: 90%;
} */
.codcontotable-add-f24-datev,
.codcontotable-add-f24 {
  position: relative;
  border-spacing: 0;
}
.softwaredetected {
  margin-bottom: 1rem;
  margin-top: -0.6rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: rgb(244, 244, 244);
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  font-size: 0.85rem !important;
}
.finebtn {
  width: 5rem !important;
  margin-top: 2rem;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #84929e;
  color: white;
  font-size: 1.05rem;
  transition: background-color 0.3s ease;
}
.finebtn:hover {
  background-color: #687682;
}
.annullaAddRow {
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 1.1rem;
  cursor: pointer;
  text-align: center;
  padding: 0.75rem;
  margin: 0.5rem;
  width: 6rem !important;
  background-color: grey !important;
}
.dashboard {
  margin-top: 0rem;
  margin-bottom: 0rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
}
.buttons {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.5rem 0.75rem;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease;
}
.buttons:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.buttons > button,
.buttons > a {
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease,
    box-shadow 0.3s ease;
  border: none;
  color: #333;
  background-color: transparent; /* Pulsanti trasparenti di default per un look minimal */
}
.buttons > button {
  display: flex;
}
.buttons > button:hover,
.buttons > a:hover {
  background-color: #f0f0f0;
  transform: translateY(-1px); /* Leggero sollevamento su hover */
}
.buttons > button:active,
.buttons > a:active {
  transform: translateY(0);
  background-color: #e0e0e0;
}
.addrowbuttons {
  margin-top: 0.5rem;
  gap: 0.5rem;
  display: flex;
  justify-content: center;
}
.addrowbuttons > button {
  width: auto;
  padding: 0.8rem;
  margin: 0.6rem;
  cursor: pointer;
}
.addrowbuttons > button {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 1.05rem;
  cursor: pointer;
  text-align: center;
  padding: 0.75rem;
  margin: 0.5rem;
}
.PCT_header {
  --empty-accent: #1d5f8f;
  --empty-accent-hover: #144c73;
  --empty-soft: #eef6fb;
  width: min(100%, 60rem);
  margin: 2rem auto 0;
  padding: 1.25rem 1.45rem;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  text-align: left;
  background: #ffffff;
  border: 1px solid #d7e3ec;
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(37, 87, 122, 0.07);
}
.PDCcontainer {
  flex: 1;
  display: flex;
  flex-direction: column;
}
footer {
  font-size: 0.95rem;
}
.table-empty-message {
  width: 100%;
  min-width: 74rem;
  min-height: 5.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 0 5rem;
  border: 1px solid #cfcfcf;
  border-top: none;
  background: #fbfbfb;
  color: #3f4f5f;
  font-size: 1.15rem;
  font-style: italic;
  text-align: center;
}

#excelTable.all-software-table + .table-empty-message {
  min-width: 111rem;
}

.table-empty-message p {
  margin: 0;
}
.menu-invia-piano {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center; /* Allinea il contenuto al centro */
  justify-content: flex-start;
  gap: 1.5rem; /* Spaziatura tra gli elementi */
  padding: 2.5rem 1.2rem 2rem 1.2rem;
  width: 25rem;
  margin: 0rem auto;
  margin-bottom: 2rem;
  background-color: rgb(243 243 243 / 99%);
  border: 2px solid rgba(223, 223, 223, 0.82);
  border-radius: 10px; /* Bordo arrotondato */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: 0.75rem;
}
.file-input-add-piano {
  padding: 0.55rem 0 0.55rem 0.55rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  border: 1px solid #cccccc;
  border-radius: 5px;
  background-color: #fff;
}
.anteprimaexcel.piano {
  position: absolute;
  top: -28px;
  right: 23px;
}
.label-container {
  position: relative;
  display: flex;
  align-items: center; /* Allinea label e info-piano sulla stessa linea */
  gap: 8px; /* Distanza tra il testo e l'icona */
}
.info-piano {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  font-size: 11px;
  color: #555;
  border: 1px solid #555;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  top: -18px; /* Sposta leggermente verso l'alto */
  right: 2px;
}

.tooltip-piano {
  visibility: hidden;
  background-color: #ffffff;
  border: 1px solid grey;
  color: #393939;
  justify-content: center;
  font-weight: normal;
  text-align: left;
  padding: 8px;
  border-radius: 5px;
  position: absolute;
  right: -14.5rem;
  top: 0rem;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  font-size: 12px;
  white-space: normal;
  max-width: 8.4rem;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
}

.info-piano:hover .tooltip-piano {
  visibility: visible;
  opacity: 1;
}
.btn-invia {
  padding: 0.75rem;
  background-color: #007bff; /* Azzurro per il pulsante Converti */
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 1.1rem;
  cursor: pointer;
  text-align: center;
}
.btn-invia:disabled {
  opacity: 0.6;
  cursor: default;
}
.linkstrumentiPCT {
  text-decoration: none;
  color: rgb(46, 114, 169);
  font-weight: bold;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.2s ease;
  font-size: 1.1rem;
}
.linkstrumentiPCT:hover {
  color: rgb(31, 80, 120);
}
.toolicon {
  font-size: 1.1rem;
  color: #666;
  margin-left: -0.1rem;
}
.software-selector {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex-wrap: nowrap;
  justify-content: flex-start;
  text-align: left;
  margin: 0;
}

.software-context-group {
  display: inline-flex;
  align-items: stretch;
  flex: 0 0 auto;
  min-width: 0;
  filter: drop-shadow(0 3px 8px rgba(13, 68, 104, 0.08));
}

.software-context-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.58rem 0.78rem 0.58rem 0.92rem;
  border: 1px solid rgba(20, 121, 184, 0.24);
  border-right: none;
  border-radius: 10px 0 0 10px;
  background: linear-gradient(180deg, #eef7fd 0%, #dfeef9 100%);
  color: #0d4468;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.pdc-view-selector {
  display: inline-flex;
  align-items: stretch;
  min-width: 0;
}

.pdc-view-selector select {
  min-width: 13rem;
  max-width: 15rem;
  padding: 0.58rem 2.1rem 0.58rem 0.92rem;
  border: 1px solid rgba(20, 121, 184, 0.24);
  border-radius: 10px;
  color: #10466f;
  background-color: #eef7fd;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%2310466f' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"),
    linear-gradient(180deg, #eef7fd 0%, #dfeef9 100%);
  background-repeat: no-repeat, no-repeat;
  background-position: right 0.85rem center, center;
  background-size: 0.72rem 0.42rem, 100% 100%;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 6px 14px rgba(13, 68, 104, 0.06);
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.pdc-view-selector select:hover {
  border-color: rgba(20, 121, 184, 0.4);
  background-color: #e7f3fb;
}

.pdc-view-selector select:focus {
  outline: none;
  border-color: #5aa2d5;
  box-shadow: 0 0 0 3px rgba(90, 162, 213, 0.18);
  position: relative;
  z-index: 1;
}

.search-input-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: 0 1 15rem;
  width: 15rem;
  min-width: 12rem;
}

.search-icon {
  position: absolute;
  left: 0.8rem;
  color: #8f9aaa;
  font-size: 0.95rem;
  pointer-events: none;
}

.search-input-pct {
  width: 100%;
  max-width: 100%;
  padding: 0.6rem 0.85rem 0.6rem 2.2rem;
  border: 1px solid #d6dfeb;
  border-radius: 10px;
  font-size: 0.95rem;
  background: #ffffff;
}

.search-input-pct:focus {
  outline: none;
  border-color: #7da9d8;
  box-shadow: 0 0 0 3px rgba(125, 169, 216, 0.18);
}
.software-selector-add-row {
  padding-bottom: 1rem;
  text-align: left;
  display: block;
  width: fit-content;
  margin-left: 0;
}
#softwareSelect,
#softwareSelectAddRow {
  gap: 1rem;
  padding: 0.6rem 0.85rem;
  background-color: #ffffff;
  border: 1px solid #d6dfeb;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-left: 0.25rem;
  transition: box-shadow 0.3s ease;
  margin-bottom: 0rem;
  min-height: 2.45rem;
  width: 10.5rem;
}
.software-context-group #softwareSelect {
  margin-left: 0;
  min-width: 9rem;
  width: 9rem;
  padding: 0.52rem 2rem 0.52rem 0.72rem;
  border-radius: 10px;
  box-shadow: none;
  color: #17324d;
  background: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%2364707d' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.85rem center;
  background-size: 0.72rem 0.42rem;
  font-size: 0.86rem;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.software-context-group #softwareSelect:focus {
  outline: none;
  border-color: #7da9d8;
  box-shadow: 0 0 0 3px rgba(125, 169, 216, 0.18);
  position: relative;
  z-index: 1;
}
.provisional-row {
  background-color: #cee9cb;
}
.dot-anim::after {
  content: "";
  display: inline-block;
  width: 1em;
  text-align: left;
  animation: dots 1.5s steps(3, end) infinite;
}

@keyframes dots {
  0% {
    content: "";
  }
  33% {
    content: ".";
  }
  66% {
    content: "..";
  }
  100% {
    content: "...";
  }
}
.waiting-message {
  position: absolute;
  width: 19.5rem;
  top: 20rem !important;
  background-color: rgba(243, 243, 243, 0.954);
  color: #1b1b1b;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 14px;
  pointer-events: none;
  z-index: 9999;
  transition: top 0.05s linear, left 0.05s linear;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.5s ease-in-out;
}
.table-wrapper {
  display: flex;
  padding-bottom: 3rem;
  width: 77.75rem;
}
.table-scroll-toolbar {
  position: sticky;
  top: 0.75rem;
  z-index: 12;
  width: min(30rem, 38vw);
  height: 1.25rem;
  align-self: flex-end;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 0 -1.35rem;
  padding: 0;
  background: transparent;
}
.table-mini-scrollbar {
  width: 100%;
  height: 0.8rem;
  margin: 0;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  accent-color: #b8c1c9;
  cursor: pointer;
}
.table-mini-scrollbar:disabled {
  opacity: 0.35;
  cursor: default;
}
.table-mini-scrollbar::-webkit-slider-runnable-track {
  height: 0.72rem;
  border-radius: 999px;
  background: #e9eef2;
}
.table-mini-scrollbar::-webkit-slider-thumb {
  width: 5.5rem;
  height: 0.72rem;
  margin-top: 0;
  border: none;
  border-radius: 999px;
  background: #b8c1c9;
  box-shadow: none;
  -webkit-appearance: none;
  appearance: none;
}
.table-mini-scrollbar::-webkit-slider-thumb:hover {
  background: #d1c4c1;
}
.table-mini-scrollbar::-moz-range-track {
  height: 0.72rem;
  border-radius: 999px;
  background: #e9eef2;
}
.table-mini-scrollbar::-moz-range-thumb {
  width: 5.5rem;
  height: 0.72rem;
  border: none;
  border-radius: 999px;
  background: #b8c1c9;
  box-shadow: none;
}
.table-mini-scrollbar::-moz-range-thumb:hover {
  background: #d1c4c1;
}
.table-mini-scrollbar:disabled::-webkit-slider-thumb {
  box-shadow: none;
}
.table-mini-scrollbar:disabled::-moz-range-thumb {
  box-shadow: none;
}
.table-wrapper--all {
  --table-top-gutter: 2.75rem;
  width: 84.5rem;
  display: block;
  position: relative;
  flex: 0 0 auto;
  overflow-x: auto;
  height: max-content;
  min-height: max-content;
  max-height: none;
  padding-top: var(--table-top-gutter);
  padding-bottom: 0.25rem;
  margin-bottom: 2.4rem;
  background: linear-gradient(
      to bottom,
      transparent 0 var(--table-top-gutter),
      #d9e0e6 var(--table-top-gutter) calc(100% - 0.25rem),
      transparent calc(100% - 0.25rem)
    )
    right top / 1px 100% no-repeat;
  border-bottom: 1px solid #d9e0e6;
  scrollbar-color: #b8c1c9 #e9eef2;
  scrollbar-width: auto;
}
.table-wrapper--all::-webkit-scrollbar {
  height: 14px;
}
.table-wrapper--all::-webkit-scrollbar-thumb {
  background: #b8c1c9;
  border-radius: 999px;
  border: 3px solid #e9eef2;
}
.table-wrapper--all::-webkit-scrollbar-thumb:hover {
  background: #d1c4c1;
}
.table-wrapper--all::-webkit-scrollbar-track {
  background: #e9eef2;
  border-radius: 999px;
}
.all-software-table :is(th, td):nth-child(2) {
  width: 8rem;
  min-width: 8rem;
  max-width: 8rem;
}
.all-software-table :is(th, td):nth-child(3),
.all-software-table :is(th, td):nth-child(6),
.all-software-table :is(th, td):nth-child(9),
.all-software-table :is(th, td):nth-child(12),
.all-software-table :is(th, td):nth-child(15),
.all-software-table :is(th, td):nth-child(18) {
  width: 17rem;
  min-width: 17rem;
  max-width: 17rem;
}
.all-software-table :is(th, td):nth-child(4),
.all-software-table :is(th, td):nth-child(5),
.all-software-table :is(th, td):nth-child(7),
.all-software-table :is(th, td):nth-child(8),
.all-software-table :is(th, td):nth-child(10),
.all-software-table :is(th, td):nth-child(11),
.all-software-table :is(th, td):nth-child(13),
.all-software-table :is(th, td):nth-child(14),
.all-software-table :is(th, td):nth-child(16),
.all-software-table :is(th, td):nth-child(17),
.all-software-table :is(th, td):nth-child(19),
.all-software-table :is(th, td):nth-child(20) {
  width: 9.5rem;
  min-width: 9.5rem;
  max-width: 9.5rem;
}
.all-software-table th {
  white-space: normal;
  overflow-wrap: break-word;
}
.all-software-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: normal;
  word-break: normal;
}
.all-software-table td:nth-child(3),
.all-software-table td:nth-child(6),
.all-software-table td:nth-child(9),
.all-software-table td:nth-child(12),
.all-software-table td:nth-child(15),
.all-software-table td:nth-child(18) {
  text-align: left !important;
}
.row-number-cell {
  text-align: center !important;
  font-family: monospace;
  color: #666;
  padding-right: 8px;
  background-color: #f5f5f5;
  width: 16px;
  min-width: 16px;
  max-width: 16px;
  user-select: none;
}
.headerIndici {
  font-weight: normal !important;
  text-align: center !important;
}
.dashboardsave {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.68rem 1rem;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease;
  margin-bottom: 1.2rem;
}
.dashboardsave:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.dashboard {
  margin-top: 0rem;
  margin-bottom: 0rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
}
.dashboard9001 {
  margin-bottom: 1.5rem;
  max-width: 45rem;
}
.ultimamodifica {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 0 0 auto;
  margin-left: auto;
  text-align: right;
  min-width: 14.5rem;
  padding-top: 0;
}
.ultimamodificatext {
  width: auto;
  font-size: 0.9rem;
  font-style: italic;
  white-space: nowrap;
}

.causale-library-cluster {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  min-width: 0;
}

.causale-library-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  height: 2.1rem;
  padding: 0 0.58rem 0 0.62rem;
  border: 1px solid #d6dfeb;
  border-radius: 8px;
  background: #ffffff;
  color: #102a3e;
  font-size: 0.84rem;
  font-weight: 750;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 3px 9px rgba(16, 42, 62, 0.06);
}

.causale-library-trigger:hover,
.causale-library-trigger.active {
  border-color: #9eb7d4;
  background: #f8fbff;
}

.causale-library-trigger-label {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
  padding-right: 0.55rem;
}

.causale-library-trigger-label-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.causale-library-trigger-value {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 3.2rem;
  padding-left: 0.5rem;
  border-left: 1px solid #dbe5ef;
  color: #17324d;
  font-size: 0.86rem;
  font-weight: 800;
  line-height: 1;
  text-align: left;
}

.causale-library-trigger > i {
  margin-left: 0.36rem;
  color: #52677c;
  font-size: 0.72rem;
}

.causale-library-trigger-label .info-icon {
  z-index: auto;
}

.causale-library-trigger-label .tooltip {
  z-index: 35;
}

.causale-library-panel {
  position: absolute;
  top: calc(100% + 0.42rem);
  left: 0;
  z-index: 42;
  width: 20rem;
  box-sizing: border-box;
  padding: 0.84rem 0.88rem;
  border: 1px solid #d8e2ec;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 14px 30px rgba(16, 42, 62, 0.16);
  text-align: left;
}

.causale-library-panel-label {
  display: block;
  margin-bottom: 0.56rem;
  color: #52677c;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: left;
}

.causale-library-panel-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.55rem;
}

.causale-library-input {
  width: 5.75rem;
  height: 2rem;
  border: 1px solid #bfcbd5;
  border-radius: 7px;
  padding: 0 0.45rem;
  font-weight: 800;
  text-align: left;
  text-transform: uppercase;
}

.causale-library-button {
  border: 1px solid #bfd2e4;
  border-radius: 7px;
  background: #2367ad;
  color: #fff;
  font-weight: 800;
  padding: 0.44rem 0.7rem;
  cursor: pointer;
}

.causale-library-button--ghost {
  background: #fff;
  color: #2367ad;
}

.causale-library-button:disabled {
  opacity: 0.65;
  cursor: wait;
}

.causale-library-panel-hint {
  display: block;
  margin-top: 0.58rem;
  color: #66788a;
  font-size: 0.75rem;
  text-align: left;
}

.causale-library-error {
  display: block;
  margin-top: 0.35rem;
  color: #b42318;
  font-size: 0.78rem;
  font-weight: 700;
}
.savebuttondiv:disabled {
  opacity: 1;
  background-color: #ffffff !important;
  cursor: not-allowed;
}
.savebuttondiv:not(.unsaved) {
  background-color: #ffffff !important;
}
.savebuttondiv:disabled i,
.savebuttondiv:disabled span {
  color: #818080 !important;
  cursor: inherit;
}
.savebutton {
  font-size: 1.2rem;
  color: #cbcaca;
  transition: color 0.3s ease, transform 0.3s ease;
}
.savebutton.unsaved {
  cursor: pointer;
  color: rgb(33, 105, 81);
  transform: scale(1.08);
}
.addRowButton.unsaved {
  background-color: #fbf9dd !important;
  transition: background-color 0.3s ease;
}
.addRowButton.unsaved:hover {
  background-color: #f7f3c1 !important;
}
.cancelbutton {
  font-size: 1.2rem;
  padding-top: 0.1rem;
  color: #cbcaca;
  transition: color 0.3s ease, transform 0.2s ease;
}
.cancelbutton.unsaved {
  opacity: 1;
  cursor: pointer;
  color: rgb(180, 39, 29);
  transform: scale(1.08);
}
.savebuttondiv:not(.unsaved):not(:disabled):hover {
  background-color: inherit !important; /* Mantieni il colore di sfondo */
  cursor: default; /* Cursore non interattivo */
}
.savebuttondiv:not(.unsaved) span {
  color: #cbcaca;
}
.nochanges-message {
  width: 15rem;
  text-align: right;
  font-size: 0.96rem;
  color: gray;
  font-style: italic;
  transition: opacity 0.3s;
}
.archive-missing-notice {
  margin: 0 auto 0.8rem;
  width: 100%;
  max-width: 36rem;
  padding: 1.15rem 1.2rem;
  border: 1px solid #d7e3ec;
  border-radius: 12px;
  background: linear-gradient(180deg, #f9fcfe 0%, #f1f7fb 100%);
  color: #35556c;
  font-size: 0.95rem;
  line-height: 1.55;
}
.archive-missing-notice p {
  margin: 0;
}
.archive-missing-inline-action {
  display: inline;
  padding: 0;
  border: none;
  background: transparent;
  color: #1d5f8f;
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 0.14em;
  cursor: pointer;
}
.archive-missing-inline-action:hover {
  color: #144c73;
}
.table-meta-row {
  width: 77.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  margin: 0.1rem 0 1.05rem;
}
.table-meta-row--all {
  width: 84.5rem;
}

.inline-archive-wrapper {
  width: 100%;
}

.library-control-row {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.85rem;
  min-width: 0;
}
.library-active-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.62rem;
  min-width: 0;
  padding: 0.72rem 0.82rem;
  border: 1px solid #cfe1ef;
  border-radius: 12px;
  background: linear-gradient(180deg, #fbfdff 0%, #f3f8fc 100%);
  box-shadow: 0 8px 20px rgba(13, 68, 104, 0.08);
}

.library-active-summary {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: 0.72rem;
  row-gap: 0.08rem;
  align-items: baseline;
  min-width: 0;
}

.library-active-eyebrow {
  grid-row: 1 / span 2;
  align-self: center;
  padding: 0.28rem 0.46rem;
  border: 1px solid rgba(20, 121, 184, 0.2);
  border-radius: 8px;
  background: #eaf5fc;
  color: #0d4468;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.library-active-summary strong {
  min-width: 0;
  color: #102a3e;
  font-size: 1.05rem;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-active-details {
  min-width: 0;
  color: #5d6f78;
  font-size: 0.84rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-active-controls {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: 0.72rem 0.9rem;
  min-width: 0;
  width: 100%;
  padding-top: 0;
  border-top: 0;
}

.library-active-controls.has-datev-causale .search-input-wrap {
  flex-basis: 11.4rem;
  width: 11.4rem;
}

.library-active-controls.has-datev-causale .causale-library-trigger {
  width: 18.5rem;
}

.library-active-controls.has-datev-causale .causale-library-panel {
  width: 19.7rem;
}

.library-active-controls.has-datev-causale .causale-library-trigger-label {
  flex: 0 0 auto;
}

.library-active-controls.has-datev-causale .causale-library-trigger-value {
  flex: 1 1 auto;
  min-width: 3.2rem;
}

.library-file-menu {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.16rem;
  flex: 0 0 16rem;
  width: 16rem;
  min-width: 16rem;
  max-width: 16rem;
}

.library-file-trigger {
  display: inline-grid;
  position: relative;
  grid-template-columns: minmax(0, 1fr) 1.15rem;
  align-items: center;
  gap: 0.55rem;
  width: 16rem;
  min-width: 16rem;
  max-width: 16rem;
  height: 2.4rem;
  box-sizing: border-box;
  padding: 0 0.58rem 0 0.78rem;
  border: 1px solid #d7dde2;
  border-radius: 10px;
  background: linear-gradient(180deg, #ffffff 0%, #f1f3f5 100%);
  color: #26323d;
  box-shadow: 0 5px 14px rgba(53, 64, 76, 0.06);
  cursor: pointer;
  overflow: hidden;
  text-align: left;
}

.library-file-trigger:hover,
.library-file-trigger.active {
  border-color: #c7cfd7;
  background: linear-gradient(180deg, #ffffff 0%, #eceff2 100%);
}

.library-file-trigger.is-client-file {
  border-color: rgba(213, 138, 33, 0.42);
  background: linear-gradient(180deg, #fff8e9 0%, #fcebc4 100%);
}

.library-file-trigger.is-client-file:hover,
.library-file-trigger.is-client-file.active {
  border-color: rgba(197, 116, 18, 0.66);
  background: linear-gradient(180deg, #fff3dc 0%, #f8dfad 100%);
}

.library-file-trigger-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  height: 100%;
  padding: 0;
  border-right: 0;
  background: transparent;
  color: #3f4750;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-file-trigger.is-client-file .library-file-trigger-label {
  color: #7a5010;
}

.library-file-trigger-label span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-file-trigger-book {
  flex: 0 0 auto;
  color: #3f4750;
  font-size: 0.78rem;
}

.library-file-trigger.is-client-file .library-file-trigger-book,
.library-file-trigger.is-client-file > i {
  color: #b67518;
}

.library-file-trigger-scope {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.26rem;
  min-width: 0;
  width: 100%;
  margin-top: 0.25rem;
  padding: 0 0.72rem;
  color: #344154;
  font-size: 0.68rem;
  font-weight: 760;
  line-height: 1.05;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-file-trigger-scope-prefix {
  flex: 0 0 auto;
  color: #6b7280;
  font-weight: 680;
  text-transform: none;
}

.library-file-trigger-scope span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-file-trigger > i {
  padding-right: 0;
  color: #3f4750;
  font-size: 0.78rem;
}

.library-file-dropdown {
  position: absolute;
  top: calc(100% + 0.42rem);
  left: 0;
  z-index: 45;
  display: flex;
  flex-direction: column;
  min-width: 26rem;
  max-width: 36rem;
  max-height: 25.5rem;
  padding: 0.5rem;
  border: 1px solid #d7e4ef;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 16px 34px rgba(16, 42, 62, 0.18);
  overflow-y: auto;
}

.library-file-section-title {
  padding: 0.34rem 0.5rem 0.2rem;
  color: #6d7f87;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: center;
}

.library-file-option {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
  width: 100%;
  padding: 0.62rem 0.7rem;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: #102a3e;
  text-align: left;
  cursor: pointer;
}

.library-file-option:hover {
  background: #f3f8fc;
  border-color: #dce8f2;
}

.library-file-option.active {
  background: #eaf5fc;
  border-color: #a9cde7;
}

.library-file-option.is-empty,
.library-file-client-action.is-empty {
  color: #52636b;
  background: #fafcff;
}

.library-file-option.is-missing,
.library-file-client-action.is-missing {
  color: #748189;
  background: #fbfbfb;
}

.library-file-option-body {
  display: flex;
  align-items: flex-start;
  gap: 0.54rem;
  min-width: 0;
}

.library-file-option-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.library-file-option strong,
.library-file-option small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-file-option strong {
  font-size: 0.92rem;
}

.library-file-option small {
  color: #637680;
  font-size: 0.76rem;
  font-weight: 600;
}

.library-file-status {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin-left: 0.38rem;
  padding: 0.08rem 0.36rem;
  border-radius: 999px;
  font-size: 0.66rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.1;
  vertical-align: middle;
}

.library-file-status--empty {
  background: #eef1f3;
  color: #60717a;
}

.library-file-status--missing {
  background: #fff4d7;
  color: #8a6200;
}

.library-file-status--compact {
  position: absolute;
  top: -0.34rem;
  right: -0.28rem;
  margin-left: 0;
  padding: 0.06rem 0.28rem;
  border: 1px solid #fff;
  font-size: 0.58rem;
  box-shadow: 0 1px 4px rgba(16, 42, 62, 0.12);
  pointer-events: none;
}

.library-file-option-file-icon,
.library-file-option-check {
  flex: 0 0 auto;
  color: #0d6fb0;
  font-size: 0.82rem;
}

.library-file-option-file-icon {
  width: 1rem;
  margin-top: 0.14rem;
  text-align: center;
}

.library-file-option-check {
  margin-top: 0.15rem;
}

.library-file-client-group {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.55rem;
  padding: 0.78rem 0.82rem;
  border: 1px solid #e1edf6;
  border-radius: 10px;
  background: #f8fbfe;
}

.library-file-client-group + .library-file-client-group {
  margin-top: 0.45rem;
}

.library-file-client-heading {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.42rem;
  width: 100%;
  min-width: 0;
  color: #315f7c;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1.2;
  text-align: left;
}

.library-file-client-heading i {
  flex: 0 0 auto;
  color: #f0a51c;
  font-size: 0.82rem;
}

.library-file-client-heading span {
  display: block;
  min-width: 0;
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: left;
}

.library-file-client-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.38rem;
}

.library-file-client-action {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.42rem;
  flex: 1 1 0;
  min-width: 10.6rem;
  min-height: 2rem;
  box-sizing: border-box;
  padding: 0.38rem 0.5rem;
  border: 1px solid #d7e7f2;
  border-radius: 8px;
  background: #fff;
  color: #143b57;
  font-size: 0.76rem;
  font-weight: 800;
  cursor: pointer;
}

.library-file-client-action:hover {
  border-color: #e3b767;
  background: #fff3dc;
  color: #7a5010;
}

.library-file-client-action.active {
  border-color: #d58a21;
  background: #fbeccb;
  color: #6b4309;
}

.library-file-client-action:disabled {
  opacity: 0.68;
  cursor: not-allowed;
}

.library-file-client-action:disabled:hover {
  border-color: #d7e7f2;
  background: #fbfbfb;
  color: #748189;
}

.library-file-client-action i {
  color: inherit;
  font-size: 0.78rem;
}

.library-file-client-action span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.archive-menu {
  position: relative;
  display: flex;
}
.archive-menu-trigger {
  position: relative;
  border: 1px solid #d8d8d8;
  outline: none;
  font: inherit;
  cursor: pointer;
  color: inherit;
  white-space: nowrap;
  background-color: #f3f3f3 !important;
  border-radius: 10px !important;
  padding: 0.46rem 0.78rem !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);
}
.archive-menu-trigger:hover {
  background-color: #ebebeb !important;
}
.archive-chevron {
  font-size: 0.8rem;
  color: #7d7d7d;
  margin-left: -0.05rem;
}
.archive-menu-dropdown {
  position: absolute;
  top: calc(100% + 0.35rem);
  left: 0;
  display: none;
  min-width: 18rem;
  padding: 0.35rem;
  background: #fff;
  border: 1px solid #dde3ea;
  border-radius: 12px;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.12);
  z-index: 20;
}
.archive-menu-dropdown::before {
  content: "";
  position: absolute;
  top: -0.5rem;
  left: 0;
  width: 100%;
  height: 0.5rem;
}
.archive-menu--open .archive-menu-dropdown {
  display: block;
}
.archive-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 0.85rem;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #333;
  font-size: 0.94rem;
  cursor: pointer;
  text-align: left;
}
.archive-menu-item:hover {
  background-color: #f3f5f7;
}
td.modified-cell {
  background-color: #cee9cb !important;
}

td.error-cell {
  background-color: #f7cdcd !important;
}
.row-deleting td {
  background-color: #ffdddd !important;
  color: #000 !important;
}
.row-deleting-cell {
  background-color: #ffcccc !important;
  border: 2px solid red !important;
  color: black !important;
}
.error-message-leggi-f24 {
  position: absolute;
  top: 21rem;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  text-align: center;
  color: #da3838e4;
  font-weight: bold;
  padding: 0.5rem 1rem; /* padding per dare un po’ di spazio */
  background: #fff0; /* opzionale, per evidenziare */
  border-radius: 4px; /* opzionale */
  box-sizing: border-box;
  max-width: 90vw;
}
.error-message-leggi-piano {
  position: absolute;
  top: 16rem;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  text-align: center;
  color: #da3838e4;
  font-weight: bold;
  padding: 0.5rem 1rem; /* padding per dare un po’ di spazio */
  background: #fff0; /* opzionale, per evidenziare */
  border-radius: 4px; /* opzionale */
  box-sizing: border-box;
  max-width: 90vw;
}
.skeleton-loader {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  min-height: 8rem;
  width: min(100%, 77.75rem);
}

.skeleton {
  background-color: #e0e0e0;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shimmer 1.5s infinite;
}

.skeleton-title {
  width: 70%;
  height: 24px;
}

.skeleton-text {
  width: 100%;
  height: 16px;
}

.skeleton-button {
  width: 30%;
  height: 36px;
  border-radius: 8px;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.btn-condividi {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 9px 18px;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease;
}

.btn-condividi:hover {
  background-color: #0056b3;
}

.badge {
  background: red;
  color: white;
  font-size: 0.75rem;
  padding: 2px 6px;
  border-radius: 9999px;
  position: absolute;
  top: -5px;
  right: -5px;
  font-weight: bold;
}

.upload-scope-panel {
  margin: 0 0 1.25rem;
  padding: 0.85rem 0.95rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fbfdff;
  text-align: left;
}

.upload-scope-title {
  display: block;
  margin-bottom: 0.55rem;
  color: #374151;
  font-size: 0.95rem;
  font-weight: 700;
}

.upload-scope-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  margin-bottom: 0.8rem;
}

.upload-scope-option {
  display: inline-flex;
  align-items: center;
  gap: 0.38rem;
  padding: 0.42rem 0.62rem;
  border: 1px solid #d8e1eb;
  border-radius: 8px;
  background: #ffffff;
  color: #24364a;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
}

.upload-scope-option input {
  width: 12px;
  height: 12px;
  accent-color: #2563eb;
}

.upload-client-select,
.upload-client-input {
  width: 100%;
  box-sizing: border-box;
  padding: 0.62rem 0.72rem;
  border: 1px solid #cfd9e5;
  border-radius: 8px;
  background: #ffffff;
  color: #1f3448;
}

.upload-new-client-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.7rem;
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Sfondo oscurato */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background-color: rgb(255, 255, 255);
  padding: 40px 20px 20px 30px;
  border-radius: 5px;
  text-align: center;
  min-width: 30rem;
}

.delete-archive-options {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: fit-content;
  margin: 1.05rem auto 1.25rem;
}

.delete-archive-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.42rem 0;
  color: #6b7280;
  font-size: 0.88rem;
  font-weight: 400;
}

.delete-archive-checkbox:last-child {
  margin-bottom: 0;
}

.delete-archive-checkbox input {
  width: 12px;
  height: 12px;
  accent-color: #6b7280;
  cursor: pointer;
}

.deletemessage {
  white-space: pre-line;
}

.modal-content button {
  margin: 10px;
  padding: 8px 16px;
  cursor: pointer;
}
.btn-modal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.6rem 1.5rem;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background-color 0.2s ease;
  min-width: 100px;
}

/* Rosso Elimina */
.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-danger:hover {
  background-color: #c82333;
}

/* Grigio “Annulla” */
.btn-primary {
  background-color: #1474bd;
  border-color: #1474bd;
  color: white;
}

.btn-primary:hover {
  background-color: #115f9b;
  border-color: #0f568d;
}

.btn-secondary {
  background-color: #eef1f4;
  border-color: #d5dce4;
  color: #374151;
}

.btn-secondary:hover {
  background-color: #e3e8ed;
  border-color: #c4ced8;
}
.tool-button {
  padding: 0.5rem 0.75rem !important;
  background-color: transparent;
  margin-right: -0.3rem;
}
.checkcodicicontoIcon {
  color: rgb(115 183 224);
}
#excelTable td {
  position: relative;
  text-align: center;
}
#excelTable th {
  text-align: center;
}
#excelTable.all-software-table {
  --sticky-row-index-offset: calc(1rem + 10px);
  --sticky-tributo-width: 8rem;
  border-collapse: separate;
  border-spacing: 0;
}
#excelTable.all-software-table .sticky-row-index-cell {
  position: sticky;
  left: 0;
  z-index: 6;
  width: 1rem !important;
  min-width: 1rem;
  max-width: 1rem;
  background: #ffffff;
  box-sizing: content-box;
}
#excelTable.all-software-table .sticky-tributo-cell {
  position: sticky;
  left: var(--sticky-row-index-offset);
  z-index: 5;
  width: var(--sticky-tributo-width) !important;
  min-width: var(--sticky-tributo-width) !important;
  max-width: var(--sticky-tributo-width) !important;
  box-sizing: content-box;
  background: #ffffff;
  border-left: none !important;
  border-right: none !important;
  box-shadow: 8px 0 12px -12px rgba(34, 51, 68, 0.55);
}
#excelTable.all-software-table :is(th, td):nth-child(3) {
  border-left: none !important;
}
#excelTable.all-software-table th.sticky-tributo-cell {
  z-index: 7;
  background: #eef2f4;
}
#excelTable.all-software-table th.sticky-row-index-cell {
  z-index: 8;
  background: #eef2f4;
}
#excelTable.all-software-table tr.highlight-row td.sticky-tributo-cell {
  background-color: #ffeeba !important;
}
#excelTable.all-software-table tr.provisional-row td.sticky-tributo-cell,
#excelTable.all-software-table td.sticky-tributo-cell.modified-cell {
  background-color: #cee9cb;
}
#excelTable.all-software-table td.sticky-tributo-cell.error-cell {
  background-color: #f7cdcd;
}
#excelTable.all-software-table tr.row-deleting td.sticky-tributo-cell {
  background-color: #ffdddd !important;
}
#excelTable td:nth-child(3),
#excelTable td:nth-child(6) {
  text-align: left;
}
.btn-9001-pdc {
  position: absolute;
  top: 4.4rem;
  left: 0rem;
  display: flex;
  display: flex; /* Make button a flex container */
  align-items: center; /* Vertically center icon and text */
  gap: 0.5rem; /* Add gap between icon and text */
  padding: 0.5rem 0.7rem;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease, background-color 0.3s ease;
}
.btn-saldof-pdc {
  position: absolute;
  top: 4.4rem;
  left: 14rem;
  display: flex;
  display: flex; /* Make button a flex container */
  align-items: center; /* Vertically center icon and text */
  gap: 0.5rem; /* Add gap between icon and text */
  padding: 0.5rem 0.7rem;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease, background-color 0.3s ease;
}
.fa-book-open {
  color: #666;
}
.fa-globe {
  color: #4f4f4f;
}
.modal-saldof,
.modal-9001 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9900;
}
.modal-content-saldof,
.modal-content-9001 {
  position: relative;
  background-color: white;
  padding: 20px 30px;
  border-radius: 5px;
  min-width: 48rem;
  max-width: 80%;
  max-height: 80%;
  display: flex;
  flex-direction: column; /* Dispone gli elementi in colonna */
}
.table-container {
  max-height: calc(
    80vh - 120px
  ); /* Altezza massima per la tabella, lasciando spazio per titolo e footer */
  overflow-y: auto; /* Abilita lo scrolling verticale solo per la tabella */
}

#PDCTable9001 {
  width: 100%;
  border-collapse: collapse;
}

#PDCTable9001 th:nth-child(2),
#PDCTable9001 th:nth-child(3),
#PDCTable9001 td:nth-child(3),
#PDCTable9001 th:nth-child(4),
#PDCTable9001 td:nth-child(4) {
  text-align: center;
}

#PDCTable9001 th,
#PDCTable9001 td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

#PDCTable9001 th {
  background-color: #f2f2f2;
}

.modal-footer {
  padding-top: 10px; /* Spazio sopra il footer */
  text-align: center; /* Allinea il pulsante a destra */
  border-top: 1px solid #ddd; /* Separatore visivo */
}
.btn-modal-saldof,
.btn-modal-9001 {
  margin: 10px 5px;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-secondary-saldof,
.btn-secondary-9001 {
  background-color: #6c757d;
  color: white;
}
.btn-secondary-saldof:hover,
.btn-secondary-9001:hover {
  background-color: #5a6268;
}
.chiudiPDCsaldof,
.chiudiPDC9001 {
  font-size: 1.5rem;
  position: absolute;
  top: 12px;
  right: 12px;
}

.chiudiPDC9001:hover {
  color: #717171;
}

/* Assicura che lo scrollbar sia visivamente separato */
.table-container::-webkit-scrollbar {
  width: 8px; /* Larghezza dello scrollbar */
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1; /* Sfondo dello scrollbar */
}

.table-container::-webkit-scrollbar-thumb {
  background: #888; /* Colore del cursore dello scrollbar */
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #555; /* Colore al passaggio del mouse */
}
/* Blocco 0 - TeamSystem */
.hide-block-0 :is(th, td):nth-child(n + 6):nth-child(-n + 8) {
  display: none !important;
}

/* Blocco 1 - Datev Aziende */
.hide-block-1 :is(th, td):nth-child(n + 9):nth-child(-n + 11) {
  display: none !important;
}

/* Blocco 2 */
.hide-block-2 :is(th, td):nth-child(n + 12):nth-child(-n + 14) {
  display: none !important;
}

/* Blocco 3 */
.hide-block-3 :is(th, td):nth-child(n + 15):nth-child(-n + 17) {
  display: none !important;
}

/* Blocco 4 */
.hide-block-4 :is(th, td):nth-child(n + 18):nth-child(-n + 20) {
  display: none !important;
}

/* Blocco 5 - Sistemi */
.hide-block-5 :is(th, td):nth-child(n + 21):nth-child(-n + 23) {
  display: none !important;
}

/* Opzionale: quando nascondi un blocco, riduci un po' il padding della colonna successiva */
.hide-block-0 :is(th, td):nth-child(8),
.hide-block-1 :is(th, td):nth-child(11),
.hide-block-2 :is(th, td):nth-child(14),
.hide-block-3 :is(th, td):nth-child(17),
.hide-block-4 :is(th, td):nth-child(20),
.hide-block-5 :is(th, td):nth-child(23) {
  padding-left: 4px !important;
}
.expand-buttontributo {
  z-index: 10;
  margin-bottom: 1rem;
  font-size: 21px; /* Dimensione dell'icona */
  position: absolute;
  top: 7px;
  left: 8px;
  color: #aaa9a9;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
}
.expand-buttontributo:hover {
  transform: scale(1.1); /* Ingrandisce leggermente al passaggio del mouse */
  color: rgb(136, 135, 135); /* Colore diverso al hover */
}
.subphase-navigation {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.btnPCTvisible {
  top: 1.8rem;
}
.row-deleting9001 {
  background-color: #ffcccc;
  transition: opacity 0.7s;
  opacity: 0;
}

.highlight-row9001 {
  background-color: #f0f0f0;
}

/* Workspace libreria: strumenti e contenuto appartengono allo stesso file. */
.PDCcontainer {
  box-sizing: border-box;
  width: 100%;
  max-width: none;
  margin: 0 auto;
}

.library-workspace {
  --library-accent: #176a9d;
  --library-accent-hover: #10577f;
  --library-accent-soft: #edf6fb;
  --library-border: #d5e3ec;
  box-sizing: border-box;
  width: 100%;
  margin: 0.16rem 0 3rem;
  padding: 1rem 1.15rem 1.25rem;
  border: 1px solid var(--library-border);
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(22, 83, 119, 0.085);
}

.library-workspace--empty {
  min-height: 23rem;
}

.library-workspace .dashboarddiv {
  width: 100%;
  min-width: 0;
  margin: 0;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #e4edf3;
}

.library-workspace .dashboard,
.library-workspace .dashboarddiv > .dashboard > .buttons {
  width: 100%;
  box-sizing: border-box;
}

.library-workspace .dashboarddiv > .dashboard > .buttons {
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.38rem;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.library-workspace .dashboarddiv > .dashboard > .buttons:hover {
  box-shadow: none;
}

.library-workspace .dashboarddiv > .dashboard > .buttons > button,
.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > .download-menu
  > .download-menu-trigger {
  min-height: 2.9rem;
  padding: 0.68rem 1.08rem;
  border: 1px solid #d9e5ed;
  border-radius: 9px;
  background: #ffffff;
  color: #263b4b;
  box-shadow: 0 2px 5px rgba(28, 66, 91, 0.035);
}

.library-workspace .dashboarddiv > .dashboard > .buttons > button,
.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > .download-menu
  > .download-menu-trigger {
  gap: 0.7rem;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button.leggibilancino {
  min-width: 13.8rem;
}

.library-workspace .dashboarddiv > .dashboard > .buttons > button:first-child {
  border-color: var(--library-accent);
  background: linear-gradient(
    180deg,
    #2180b6 0%,
    var(--library-accent) 100%
  ) !important;
  color: #ffffff;
  box-shadow: 0 5px 12px rgba(23, 106, 157, 0.2);
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:first-child
  i {
  color: #ffffff !important;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:first-child:hover:not(:disabled) {
  border-color: var(--library-accent-hover);
  background: linear-gradient(
    180deg,
    #1c729f 0%,
    var(--library-accent-hover) 100%
  ) !important;
  transform: none !important;
  box-shadow: 0 5px 12px rgba(23, 106, 157, 0.24);
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:disabled:not(.savebuttondiv) {
  border-color: #e4eaee;
  background: #f3f6f8;
  color: #a1acb4;
  box-shadow: none;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:not(:first-child):not(.savebuttondiv)
  i,
.library-workspace .dashboarddiv > .dashboard > .buttons > .download-menu i,
.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  :deep(.btn-condividi i) {
  color: #3f4750 !important;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:not(:first-child):not(.savebuttondiv):hover:not(:disabled),
.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > .download-menu
  > .download-menu-trigger:hover:not(:disabled) {
  border-color: #ced9e0;
  background: #f6f7f8 !important;
  transform: none !important;
  box-shadow: 0 4px 10px rgba(22, 83, 119, 0.08);
}

.library-workspace .dashboarddiv > .dashboard > .buttons :deep(.btn-condividi) {
  min-height: 2.9rem;
  padding: 0.68rem 1.08rem;
  gap: 0.7rem;
  border: 1px solid #d9e5ed;
  border-radius: 9px;
  background: #ffffff;
  color: #263b4b;
  box-shadow: 0 2px 5px rgba(28, 66, 91, 0.035);
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > .download-menu
  > .download-menu-trigger {
  border: 1px solid #d9e5ed !important;
  background: #ffffff !important;
  box-shadow: 0 2px 5px rgba(28, 66, 91, 0.035) !important;
}

.library-workspace .library-share-control {
  display: inline-flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 0;
  min-width: 0;
}

.library-workspace .library-share-control::after {
  content: "";
  display: block;
  flex: 0 0 1px;
  width: 1px;
  height: 2rem;
  margin: 0 auto;
  background: #d4e0e8;
  transform: translateX(0.19rem);
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  :deep(.btn-condividi:hover:not(:disabled)) {
  border-color: #ced9e0;
  background: #f6f7f8;
  transform: none;
  box-shadow: 0 4px 10px rgba(22, 83, 119, 0.08);
}

.library-workspace .dashboarddiv > .dashboard > .buttons > button,
.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > .download-menu
  > .download-menu-trigger {
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease, color 0.18s ease;
}

.library-workspace .dashboarddiv > .dashboard > .buttons > button:first-child {
  transition: border-color 0.18s ease, box-shadow 0.18s ease, color 0.18s ease;
}

.library-workspace .savebuttondiv:disabled,
.library-workspace .savebuttondiv:not(.unsaved) {
  opacity: 1;
  border-color: #e2e6e8 !important;
  background: #f1f3f4 !important;
  color: #a9afb4 !important;
  box-shadow: none !important;
}

.library-workspace .savebuttondiv {
  box-sizing: border-box;
  flex: 0 0 7rem;
  width: 7rem;
  min-width: 7rem;
  justify-content: center;
}

@media (min-width: 1500px) {
  .library-workspace .dashboarddiv > .dashboard > .buttons {
    flex-wrap: nowrap;
  }
}

.library-workspace .savebuttondiv:disabled :is(i, span),
.library-workspace .savebuttondiv:not(.unsaved) :is(i, span) {
  color: #a9afb4 !important;
}

.library-workspace .savebuttondiv:not(.unsaved):hover {
  border-color: #e2e6e8 !important;
  background: #f4f5f6 !important;
  color: #a9afb4 !important;
  transform: none !important;
  box-shadow: none !important;
}

.library-workspace button:not(:disabled) {
  cursor: pointer;
}

.library-workspace button:disabled,
.library-workspace button:disabled * {
  cursor: not-allowed !important;
  transform: none !important;
}

.library-workspace button:disabled:hover {
  transform: none !important;
}

.library-workspace .savebuttondiv:not(.unsaved),
.library-workspace .savebuttondiv:not(.unsaved) * {
  cursor: not-allowed !important;
  transform: none !important;
}

.library-workspace :deep(.btn-condividi:disabled),
.library-workspace :deep(.btn-condividi:disabled:hover) {
  opacity: 1;
  border-color: #e1e8ec !important;
  background: #ffffff !important;
  color: #a7b0b6 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  :deep(.btn-condividi:disabled i) {
  color: #a7b0b6 !important;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:disabled:not(.savebuttondiv) {
  opacity: 1;
  border-color: #e1e8ec !important;
  background: #ffffff !important;
  color: #a7b0b6 !important;
  box-shadow: none !important;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:disabled:not(.savebuttondiv)
  :is(i, span) {
  color: #a7b0b6 !important;
}

.library-workspace .table-scroll-toolbar {
  width: min(30rem, 36%);
  margin-top: 0.85rem;
}

.library-workspace .table-wrapper {
  box-sizing: border-box;
  width: 100%;
  padding: 1rem 0 0;
}

.library-workspace .table-wrapper--all {
  width: 100%;
  padding-top: var(--table-top-gutter);
}

.library-workspace .table-meta-row,
.library-workspace .table-meta-row--all {
  box-sizing: border-box;
  width: 100%;
  margin: 0 0 0.9rem;
}

.library-workspace > .table-meta-row,
.library-workspace > .table-meta-row--all {
  margin-top: 1rem;
}

.library-workspace #excelTable,
.library-workspace #PDCTable9001Inline,
.library-workspace #SaldoFTableInline {
  width: 100%;
  max-width: none;
  margin-top: 0;
  margin-bottom: 0;
  overflow: hidden;
  border: 1px solid #d6e1e8 !important;
  border-radius: 11px;
  border-collapse: separate;
  border-spacing: 0;
  color: #243b4d;
  font-size: 0.9rem;
}

.library-workspace
  :is(#excelTable, #PDCTable9001Inline, #SaldoFTableInline)
  :is(th, td) {
  padding: 0.72rem 0.78rem;
  border: 0;
  border-right: 1px solid #e4ebf0;
  border-bottom: 1px solid #e2e9ee;
  line-height: 1.28;
  vertical-align: middle;
}

.library-workspace
  :is(#excelTable, #PDCTable9001Inline, #SaldoFTableInline)
  th {
  background: #eef2f4;
  color: #304658;
  font-size: 0.92rem;
  font-weight: 750;
}

.library-workspace
  :is(#excelTable, #PDCTable9001Inline, #SaldoFTableInline)
  tr:last-child
  > :is(td, th) {
  border-bottom: 0;
}

.library-workspace
  :is(#excelTable, #PDCTable9001Inline, #SaldoFTableInline)
  :is(th, td):last-child {
  border-right: 0;
}

.library-workspace
  :is(
    #excelTable,
    #PDCTable9001Inline,
    #SaldoFTableInline,
    #PDCTable9001,
    #SaldoFTable
  )
  > tr:nth-child(odd):not(.highlight-row):not(.highlight-row9001):not(
    .provisional-row
  ):not(.row-deleting):not(.row-deleting9001)
  > td:not(.modified-cell):not(.error-cell) {
  background: #f9f9f9;
}

.library-workspace
  :is(
    #excelTable,
    #PDCTable9001Inline,
    #SaldoFTableInline,
    #PDCTable9001,
    #SaldoFTable
  )
  > tr:is(.highlight-row, .highlight-row9001)
  > td {
  background: #ffeeba !important;
  transition: background-color 0.3s ease-in-out !important;
}

.library-workspace tr:is(.highlight-row, .highlight-row9001) .delete-button {
  background: #ffeeba !important;
  color: #000000 !important;
}

.library-workspace #excelTable > tr {
  height: 3.15rem;
  border: 0 !important;
}

.library-workspace .row-index {
  color: #798995;
  font-size: 0.78rem;
}

:is(#SaldoFTableInline, #SaldoFTable) :is(th, td).library-bank-code-column {
  width: 5.3rem;
  min-width: 5.3rem;
  max-width: 5.3rem;
  padding-right: 0.45rem;
  padding-left: 0.45rem;
  text-align: center;
  white-space: nowrap;
}

:is(#SaldoFTableInline, #SaldoFTable) :is(th, td).library-bank-iban-column {
  width: 18rem;
  min-width: 18rem;
  max-width: 18rem;
  white-space: nowrap;
  overflow-wrap: normal;
}

:is(#SaldoFTableInline, #SaldoFTable) th.library-bank-iban-column {
  text-align: center;
}

.library-bank-iban-editor {
  --iban-input-height: 2rem;
  width: 100%;
}

.library-bank-iban-value {
  display: block;
  width: 100%;
  white-space: nowrap;
}

.library-workspace .table-empty-message {
  margin-bottom: 0;
  border-color: #d6e1e8;
  background: #f7fafc;
  color: #5e7180;
}

.library-workspace .ultimamodificatext {
  color: #627584;
  font-size: 0.82rem;
}

.title {
  color: #176a9d;
}

.title::after {
  background: #176a9d;
}
</style>
